// // // // import React, { useState, useEffect, useMemo } from "react";
// // // // import {
// // // //   TableContainer, Table, TableHead, TableRow, TableCell,
// // // //   TableBody, Paper, Card, CardContent, Box, Typography,
// // // //   Button, TextField, FormControl, InputLabel, Select, MenuItem,
// // // //   CircularProgress, Alert, Chip
// // // // } from "@mui/material";
// // // // import axiosClient from "../axiosClient";
// // // // import { useTranslation } from "react-i18next";

// // // // const pickIssuesFromResponse = (data) => {
// // // //   if (!data) return [];
// // // //   if (Array.isArray(data)) return data;
// // // //   if (data.results && Array.isArray(data.results)) return data.results;
// // // //   return [];
// // // // };

// // // // const IssuesScreen = () => {
// // // //   const [allIssues, setAllIssues] = useState([]);
// // // //   const [loading, setLoading] = useState(false);
// // // //   const [error, setError] = useState(null);
// // // //   const [statusFilter, setStatusFilter] = useState("");
// // // //   const [search, setSearch] = useState("");
// // // //   const { t } = useTranslation();

// // // //   const fetchIssues = async () => {
// // // //     setLoading(true);
// // // //     setError(null);
// // // //     try {
// // // //       const res = await axiosClient.get("api/issues/");
// // // //       const data = pickIssuesFromResponse(res.data);
// // // //       setAllIssues(data);
// // // //     } catch (err) {
// // // //       console.error("Fetch error:", err);
// // // //       setError(t("Failed to load issues from the server."));
// // // //     } finally {
// // // //       setLoading(false);
// // // //     }
// // // //   };

// // // //   useEffect(() => {
// // // //     fetchIssues();
// // // //   }, []);

// // // //   // Frontend Filter Logic
// // // //   const filteredIssues = useMemo(() => {
// // // //     return allIssues.filter((issue) => {
// // // //       const matchesStatus = statusFilter ? issue.status === statusFilter : true;
      
// // // //       const searchStr = search.toLowerCase();
// // // //       const matchesSearch = search
// // // //         ? (issue.title?.toLowerCase().includes(searchStr) ||
// // // //            issue.description?.toLowerCase().includes(searchStr) ||
// // // //            issue.technician_name?.toLowerCase().includes(searchStr))
// // // //         : true;

// // // //       return matchesStatus && matchesSearch;
// // // //     });
// // // //   }, [allIssues, statusFilter, search]);

// // // //   const getStatusColor = (status) => {
// // // //     switch (status?.toLowerCase()) {
// // // //       case 'closed': return 'success';
// // // //       case 'in progress': return 'warning';
// // // //       case 'open': return 'error';
// // // //       default: return 'default';
// // // //     }
// // // //   };

// // // //   return (
// // // //     <Box sx={{ p: { xs: 1, sm: 3 } }}>
// // // //       <Card elevation={16} sx={{ borderRadius: 2 }}>
// // // //         <CardContent>
// // // //           <Typography variant="h5" fontWeight="bold" gutterBottom>
// // // //             {t("Issue Management List")}
// // // //           </Typography>

// // // //           <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 4, mt: 2, alignItems: "center" }}>
// // // //             <TextField
// // // //               label={t("Search Title, Description or Technician")}
// // // //               variant="outlined"
// // // //               size="small"
// // // //               value={search}
// // // //               onChange={(e) => setSearch(e.target.value)}
// // // //               sx={{ flex: { xs: "1 1 100%", sm: "1 1 400px" } }}
// // // //             />

// // // //             <FormControl size="small" sx={{ minWidth: "200px" }}>
// // // //               <InputLabel>{t("Status")}</InputLabel>
// // // //               <Select
// // // //                 value={statusFilter}
// // // //                 label={t("Status")}
// // // //                 onChange={(e) => setStatusFilter(e.target.value)}
// // // //               >
// // // //                 <MenuItem value="">{t("All Statuses")}</MenuItem>
// // // //                 <MenuItem value="Open">{t("Open")}</MenuItem>
// // // //                 <MenuItem value="In Progress">{t("In Progress")}</MenuItem>
// // // //                 <MenuItem value="Closed">{t("Closed")}</MenuItem>
// // // //               </Select>
// // // //             </FormControl>

// // // //             <Button variant="outlined" color="secondary" onClick={() => {setSearch(""); setStatusFilter("");}}>
// // // //               {t("Reset")}
// // // //             </Button>
            
// // // //             <Button variant="contained" onClick={fetchIssues} disabled={loading}>
// // // //               {t("Refresh")}
// // // //             </Button>
// // // //           </Box>

// // // //           {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// // // //           <TableContainer component={Paper} sx={{ maxHeight: 600, border: "1px solid #e0e0e0" }}>
// // // //             {loading ? (
// // // //               <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}><CircularProgress /></Box>
// // // //             ) : (
// // // //               <Table stickyHeader>
// // // //                 <TableHead>
// // // //                   <TableRow>
// // // //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("ID")}</TableCell>
// // // //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Title")}</TableCell>
// // // //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Status")}</TableCell>
// // // //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Priority")}</TableCell>
// // // //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Technician")}</TableCell>
// // // //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Created At")}</TableCell>
// // // //                   </TableRow>
// // // //                 </TableHead>
// // // //                 <TableBody>
// // // //                   {filteredIssues.length > 0 ? (
// // // //                     filteredIssues.map((issue) => (
// // // //                       <TableRow key={issue.id} hover>
// // // //                         <TableCell>#{issue.id}</TableCell>
// // // //                         <TableCell>
// // // //                           <Typography variant="body2" fontWeight="bold">{issue.title}</Typography>
// // // //                           <Typography variant="caption" color="textSecondary" noWrap sx={{ maxWidth: 200, display: 'block' }}>
// // // //                             {issue.description}
// // // //                           </Typography>
// // // //                         </TableCell>
// // // //                         <TableCell>
// // // //                           <Chip 
// // // //                             label={t(issue.status || "Open")} 
// // // //                             color={getStatusColor(issue.status)} 
// // // //                             size="small" 
// // // //                             variant="outlined"
// // // //                           />
// // // //                         </TableCell>
// // // //                         <TableCell>{t(issue.priority || "Medium")}</TableCell>
// // // //                         <TableCell>{issue.technician_name || t("Unassigned")}</TableCell>
// // // //                         <TableCell>{new Date(issue.created_at).toLocaleDateString()}</TableCell>
// // // //                       </TableRow>
// // // //                     ))
// // // //                   ) : (
// // // //                     <TableRow>
// // // //                       <TableCell colSpan={6} align="center" sx={{ py: 5 }}>
// // // //                         <Typography color="textSecondary">{t("No issues found")}</Typography>
// // // //                       </TableCell>
// // // //                     </TableRow>
// // // //                   )}
// // // //                 </TableBody>
// // // //               </Table>
// // // //             )}
// // // //           </TableContainer>
// // // //         </CardContent>
// // // //       </Card>
// // // //     </Box>
// // // //   );
// // // // };

// // // // export default IssuesScreen;

// // // import React, { useState, useEffect, useMemo } from "react";
// // // import {
// // //   TableContainer, Table, TableHead, TableRow, TableCell,
// // //   TableBody, Paper, Card, CardContent, Box, Typography,
// // //   Button, TextField, FormControl, InputLabel, Select, MenuItem,
// // //   CircularProgress, Alert, Chip
// // // } from "@mui/material";
// // // import axiosClient from "../axiosClient";
// // // import { useTranslation } from "react-i18next";

// // // const pickIssuesFromResponse = (data) => {
// // //   if (!data) return [];
// // //   if (Array.isArray(data)) return data;
// // //   if (data.results && Array.isArray(data.results)) return data.results;
// // //   return [];
// // // };

// // // const IssuesScreen = () => {
// // //   const [allIssues, setAllIssues] = useState([]);
// // //   const [loading, setLoading] = useState(false);
// // //   const [error, setError] = useState(null);
// // //   const [statusFilter, setStatusFilter] = useState("");
// // //   const [search, setSearch] = useState("");
// // //   const { t } = useTranslation();

// // //   const fetchIssues = async () => {
// // //     setLoading(true);
// // //     setError(null);
// // //     try {
// // //       const res = await axiosClient.get("api/issues/");
// // //       const data = pickIssuesFromResponse(res.data);
// // //       setAllIssues(data);
// // //     } catch (err) {
// // //       console.error("Fetch error:", err);
// // //       setError(t("Failed to load issues from the server."));
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     fetchIssues();
// // //   }, []);

// // //   // Frontend Filter Logic (Includes Room Number Search)
// // //   const filteredIssues = useMemo(() => {
// // //     return allIssues.filter((issue) => {
// // //       const matchesStatus = statusFilter ? issue.status === statusFilter : true;
      
// // //       const searchStr = search.toLowerCase();
// // //       const matchesSearch = search
// // //         ? (issue.title?.toLowerCase().includes(searchStr) ||
// // //            issue.description?.toLowerCase().includes(searchStr) ||
// // //            issue.room_number?.toLowerCase().includes(searchStr) || // 🆕 Search by Room
// // //            issue.technician_name?.toLowerCase().includes(searchStr))
// // //         : true;

// // //       return matchesStatus && matchesSearch;
// // //     });
// // //   }, [allIssues, statusFilter, search]);

// // //   const getStatusColor = (status) => {
// // //     switch (status?.toLowerCase()) {
// // //       case 'closed': return 'success';
// // //       case 'in progress': return 'warning';
// // //       case 'open': return 'error';
// // //       default: return 'default';
// // //     }
// // //   };

// // //   return (
// // //     <Box sx={{ p: { xs: 1, sm: 3 } }}>
// // //       <Card elevation={16} sx={{ borderRadius: 2 }}>
// // //         <CardContent>
// // //           <Typography variant="h5" fontWeight="bold" gutterBottom>
// // //             {t("Issue Management List")}
// // //           </Typography>

// // //           <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 4, mt: 2, alignItems: "center" }}>
// // //             <TextField
// // //               label={t("Search Title, Room, or Technician")}
// // //               variant="outlined"
// // //               size="small"
// // //               value={search}
// // //               onChange={(e) => setSearch(e.target.value)}
// // //               sx={{ flex: { xs: "1 1 100%", sm: "1 1 400px" } }}
// // //             />

// // //             <FormControl size="small" sx={{ minWidth: "200px" }}>
// // //               <InputLabel>{t("Status")}</InputLabel>
// // //               <Select
// // //                 value={statusFilter}
// // //                 label={t("Status")}
// // //                 onChange={(e) => setStatusFilter(e.target.value)}
// // //               >
// // //                 <MenuItem value="">{t("All Statuses")}</MenuItem>
// // //                 <MenuItem value="Open">{t("Open")}</MenuItem>
// // //                 <MenuItem value="In Progress">{t("In Progress")}</MenuItem>
// // //                 <MenuItem value="Closed">{t("Closed")}</MenuItem>
// // //               </Select>
// // //             </FormControl>

// // //             <Button variant="outlined" color="secondary" onClick={() => {setSearch(""); setStatusFilter("");}}>
// // //               {t("Reset")}
// // //             </Button>
            
// // //             <Button variant="contained" onClick={fetchIssues} disabled={loading}>
// // //               {t("Refresh")}
// // //             </Button>
// // //           </Box>

// // //           {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// // //           <TableContainer component={Paper} sx={{ maxHeight: 600, border: "1px solid #e0e0e0" }}>
// // //             {loading ? (
// // //               <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}><CircularProgress /></Box>
// // //             ) : (
// // //               <Table stickyHeader>
// // //                 <TableHead>
// // //                   <TableRow>
// // //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("ID")}</TableCell>
// // //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Room")}</TableCell> {/* 🆕 Room Column */}
// // //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Title")}</TableCell>
// // //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Status")}</TableCell>
// // //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Priority")}</TableCell>
// // //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Technician")}</TableCell>
// // //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Created At")}</TableCell>
// // //                   </TableRow>
// // //                 </TableHead>
// // //                 <TableBody>
// // //                   {filteredIssues.length > 0 ? (
// // //                     filteredIssues.map((issue) => (
// // //                       <TableRow key={issue.id} hover>
// // //                         <TableCell>#{issue.id}</TableCell>
// // //                         <TableCell>
// // //                           <Typography variant="body2" fontWeight="bold" color="primary">
// // //                             {issue.room_number || "-"} {/* 🆕 Render Room Number */}
// // //                           </Typography>
// // //                         </TableCell>
// // //                         <TableCell>
// // //                           <Typography variant="body2" fontWeight="bold">{issue.title}</Typography>
// // //                           <Typography variant="caption" color="textSecondary" noWrap sx={{ maxWidth: 200, display: 'block' }}>
// // //                             {issue.description}
// // //                           </Typography>
// // //                         </TableCell>
// // //                         <TableCell>
// // //                           <Chip 
// // //                             label={t(issue.status || "Open")} 
// // //                             color={getStatusColor(issue.status)} 
// // //                             size="small" 
// // //                             variant="outlined"
// // //                           />
// // //                         </TableCell>
// // //                         <TableCell>{t(issue.priority || "Medium")}</TableCell>
// // //                         <TableCell>{issue.technician_name || t("Unassigned")}</TableCell>
// // //                         <TableCell>{new Date(issue.created_at).toLocaleDateString()}</TableCell>
// // //                       </TableRow>
// // //                     ))
// // //                   ) : (
// // //                     <TableRow>
// // //                       <TableCell colSpan={7} align="center" sx={{ py: 5 }}>
// // //                         <Typography color="textSecondary">{t("No issues found")}</Typography>
// // //                       </TableCell>
// // //                     </TableRow>
// // //                   )}
// // //                 </TableBody>
// // //               </Table>
// // //             )}
// // //           </TableContainer>
// // //         </CardContent>
// // //       </Card>
// // //     </Box>
// // //   );
// // // };

// // // export default IssuesScreen;



// // import React, { useState, useEffect, useMemo } from "react";
// // import {
// //   TableContainer, Table, TableHead, TableRow, TableCell,
// //   TableBody, Paper, Card, CardContent, Box, Typography,
// //   Button, TextField, FormControl, InputLabel, Select, MenuItem,
// //   CircularProgress, Alert, Chip
// // } from "@mui/material";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";

// // const pickIssuesFromResponse = (data) => {
// //   if (!data) return [];
// //   if (Array.isArray(data)) return data;
// //   if (data.results && Array.isArray(data.results)) return data.results;
// //   return [];
// // };

// // const IssuesScreen = () => {
// //   const [allIssues, setAllIssues] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [statusFilter, setStatusFilter] = useState("");
// //   const [search, setSearch] = useState("");
// //   const { t } = useTranslation();

// //   const fetchIssues = async () => {
// //     setLoading(true);
// //     setError(null);
// //     try {
// //       const res = await axiosClient.get("api/issues/");
// //       const data = pickIssuesFromResponse(res.data);
      
// //       // 🔍 Debug: Look at your browser console (F12) to see if 'room_number' exists in the data
// //       console.log("Raw Data from Backend:", res.data);
      
// //       setAllIssues(data);
// //     } catch (err) {
// //       console.error("Fetch error:", err);
// //       setError(t("Failed to load issues from the server."));
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchIssues();
// //   }, []);

// //   const filteredIssues = useMemo(() => {
// //     return allIssues.filter((issue) => {
// //       const matchesStatus = statusFilter ? issue.status === statusFilter : true;
      
// //       const searchStr = search.toLowerCase();
// //       // Safe check: include room_number in the search logic
// //       const matchesSearch = search
// //         ? (issue.title?.toLowerCase().includes(searchStr) ||
// //            issue.description?.toLowerCase().includes(searchStr) ||
// //            String(issue.room_number || "").toLowerCase().includes(searchStr) ||
// //            issue.technician_name?.toLowerCase().includes(searchStr))
// //         : true;

// //       return matchesStatus && matchesSearch;
// //     });
// //   }, [allIssues, statusFilter, search]);

// //   const getStatusColor = (status) => {
// //     switch (status?.toLowerCase()) {
// //       case 'closed': return 'success';
// //       case 'in progress': return 'warning';
// //       case 'open': return 'error';
// //       default: return 'default';
// //     }
// //   };

// //   return (
// //     <Box sx={{ p: { xs: 1, sm: 3 } }}>
// //       <Card elevation={16} sx={{ borderRadius: 2 }}>
// //         <CardContent>
// //           <Typography variant="h5" fontWeight="bold" gutterBottom>
// //             {t("Issue Management List")}
// //           </Typography>

// //           <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 4, mt: 2, alignItems: "center" }}>
// //             <TextField
// //               label={t("Search Title, Room, or Technician")}
// //               variant="outlined"
// //               size="small"
// //               value={search}
// //               onChange={(e) => setSearch(e.target.value)}
// //               sx={{ flex: { xs: "1 1 100%", sm: "1 1 400px" } }}
// //             />

// //             <FormControl size="small" sx={{ minWidth: "200px" }}>
// //               <InputLabel>{t("Status")}</InputLabel>
// //               <Select
// //                 value={statusFilter}
// //                 label={t("Status")}
// //                 onChange={(e) => setStatusFilter(e.target.value)}
// //               >
// //                 <MenuItem value="">{t("All Statuses")}</MenuItem>
// //                 <MenuItem value="Open">{t("Open")}</MenuItem>
// //                 <MenuItem value="In Progress">{t("In Progress")}</MenuItem>
// //                 <MenuItem value="Closed">{t("Closed")}</MenuItem>
// //               </Select>
// //             </FormControl>

// //             <Button variant="outlined" color="secondary" onClick={() => {setSearch(""); setStatusFilter("");}}>
// //               {t("Reset")}
// //             </Button>
            
// //             <Button variant="contained" onClick={fetchIssues} disabled={loading}>
// //               {t("Refresh")}
// //             </Button>
// //           </Box>

// //           {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// //           <TableContainer component={Paper} sx={{ maxHeight: 600, border: "1px solid #e0e0e0" }}>
// //             {loading ? (
// //               <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}><CircularProgress /></Box>
// //             ) : (
// //               <Table stickyHeader>
// //                 <TableHead>
// //                   <TableRow>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("ID")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Room")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Title")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Status")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Priority")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Technician")}</TableCell>
// //                   </TableRow>
// //                 </TableHead>
// //                 <TableBody>
// //                   {filteredIssues.length > 0 ? (
// //                     filteredIssues.map((issue) => (
// //                       <TableRow key={issue.id} hover>
// //                         <TableCell>#{issue.id}</TableCell>
                        
// //                         {/* 🛠️ ROOM NUMBER COLUMN WITH FALLBACKS */}
// //                         <TableCell>
// //                           <Typography variant="body2" fontWeight="bold" color="primary">
// //                             {issue.room_number || issue.room || issue.room_id || "-"}
// //                           </Typography>
// //                         </TableCell>

// //                         <TableCell>
// //                           <Typography variant="body2" fontWeight="bold">{issue.title}</Typography>
// //                           <Typography variant="caption" color="textSecondary" noWrap sx={{ maxWidth: 200, display: 'block' }}>
// //                             {issue.description}
// //                           </Typography>
// //                         </TableCell>
// //                         <TableCell>
// //                           <Chip 
// //                             label={t(issue.status || "Open")} 
// //                             color={getStatusColor(issue.status)} 
// //                             size="small" 
// //                             variant="outlined"
// //                           />
// //                         </TableCell>
// //                         <TableCell>{t(issue.priority || "Medium")}</TableCell>
// //                         <TableCell>{issue.technician_name || t("Unassigned")}</TableCell>
// //                       </TableRow>
// //                     ))
// //                   ) : (
// //                     <TableRow>
// //                       <TableCell colSpan={6} align="center" sx={{ py: 5 }}>
// //                         <Typography color="textSecondary">{t("No issues found")}</Typography>
// //                       </TableCell>
// //                     </TableRow>
// //                   )}
// //                 </TableBody>
// //               </Table>
// //             )}
// //           </TableContainer>
// //         </CardContent>
// //       </Card>
// //     </Box>
// //   );
// // };

// // export default IssuesScreen;

// // import React, { useState, useEffect, useMemo } from "react";
// // import {
// //   TableContainer, Table, TableHead, TableRow, TableCell,
// //   TableBody, Paper, Card, CardContent, Box, Typography,
// //   Button, TextField, FormControl, InputLabel, Select, MenuItem,
// //   CircularProgress, Alert, Chip
// // } from "@mui/material";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";

// // const pickIssuesFromResponse = (data) => {
// //   if (!data) return [];
// //   if (Array.isArray(data)) return data;
// //   if (data.results && Array.isArray(data.results)) return data.results;
// //   return [];
// // };

// // const IssuesScreen = () => {
// //   const [allIssues, setAllIssues] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [statusFilter, setStatusFilter] = useState("");
// //   const [search, setSearch] = useState("");
// //   const { t } = useTranslation();

// //   const fetchIssues = async () => {
// //     setLoading(true);
// //     setError(null);
// //     try {
// //       const res = await axiosClient.get("api/issues/");
// //       const data = pickIssuesFromResponse(res.data);
// //       console.log("Raw Data from Backend:", res.data);
// //       setAllIssues(data);
// //     } catch (err) {
// //       console.error("Fetch error:", err);
// //       setError(t("Failed to load issues from the server."));
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchIssues();
// //   }, []);

// //   const filteredIssues = useMemo(() => {
// //     return allIssues.filter((issue) => {
// //       const matchesStatus = statusFilter ? issue.status === statusFilter : true;
// //       const searchStr = search.toLowerCase();
// //       const matchesSearch = search
// //         ? (issue.title?.toLowerCase().includes(searchStr) ||
// //            issue.description?.toLowerCase().includes(searchStr) ||
// //            String(issue.room_number || "").toLowerCase().includes(searchStr) ||
// //            issue.technician_name?.toLowerCase().includes(searchStr))
// //         : true;

// //       return matchesStatus && matchesSearch;
// //     });
// //   }, [allIssues, statusFilter, search]);

// //   const getStatusColor = (status) => {
// //     switch (status?.toLowerCase()) {
// //       case 'closed': return 'success';
// //       case 'in progress': return 'warning';
// //       case 'open': return 'error';
// //       default: return 'default';
// //     }
// //   };

// //   // Helper function to format date/time strings
// //   const formatDateTime = (dateString) => {
// //     if (!dateString) return "-";
// //     const date = new Date(dateString);
// //     return date.toLocaleString(); // Returns format like: MM/DD/YYYY, HH:MM:SS
// //   };

// //   return (
// //     <Box sx={{ p: { xs: 1, sm: 3 } }}>
// //       <Card elevation={16} sx={{ borderRadius: 2 }}>
// //         <CardContent>
// //           <Typography variant="h5" fontWeight="bold" gutterBottom>
// //             {t("Issue Management List")}
// //           </Typography>

// //           <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 4, mt: 2, alignItems: "center" }}>
// //             <TextField
// //               label={t("Search Title, Room, or Technician")}
// //               variant="outlined"
// //               size="small"
// //               value={search}
// //               onChange={(e) => setSearch(e.target.value)}
// //               sx={{ flex: { xs: "1 1 100%", sm: "1 1 400px" } }}
// //             />

// //             <FormControl size="small" sx={{ minWidth: "200px" }}>
// //               <InputLabel>{t("Status")}</InputLabel>
// //               <Select
// //                 value={statusFilter}
// //                 label={t("Status")}
// //                 onChange={(e) => setStatusFilter(e.target.value)}
// //               >
// //                 <MenuItem value="">{t("All Statuses")}</MenuItem>
// //                 <MenuItem value="Open">{t("Open")}</MenuItem>
// //                 <MenuItem value="In Progress">{t("In Progress")}</MenuItem>
// //                 <MenuItem value="Closed">{t("Closed")}</MenuItem>
// //               </Select>
// //             </FormControl>

// //             <Button variant="outlined" color="secondary" onClick={() => {setSearch(""); setStatusFilter("");}}>
// //               {t("Reset")}
// //             </Button>
            
// //             <Button variant="contained" onClick={fetchIssues} disabled={loading}>
// //               {t("Refresh")}
// //             </Button>
// //           </Box>

// //           {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// //           <TableContainer component={Paper} sx={{ maxHeight: 600, border: "1px solid #e0e0e0" }}>
// //             {loading ? (
// //               <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}><CircularProgress /></Box>
// //             ) : (
// //               <Table stickyHeader>
// //                 <TableHead>
// //                   <TableRow>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("ID")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Room")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Title")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Start Date/Time")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("End Date/Time")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Status")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Priority")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Technician")}</TableCell>
// //                   </TableRow>
// //                 </TableHead>
// //                 <TableBody>
// //                   {filteredIssues.length > 0 ? (
// //                     filteredIssues.map((issue) => (
// //                       <TableRow key={issue.id} hover>
// //                         <TableCell>#{issue.id}</TableCell>
                        
// //                         <TableCell>
// //                           <Typography variant="body2" fontWeight="bold" color="primary">
// //                             {issue.room_number || issue.room || issue.room_id || "-"}
// //                           </Typography>
// //                         </TableCell>

// //                         <TableCell>
// //                           <Typography variant="body2" fontWeight="bold">{issue.title}</Typography>
// //                           <Typography variant="caption" color="textSecondary" noWrap sx={{ maxWidth: 200, display: 'block' }}>
// //                             {issue.description}
// //                           </Typography>
// //                         </TableCell>

// //                         {/* 🟢 NEW START DATE/TIME COLUMN */}
// //                         <TableCell>
// //                           <Typography variant="body2">
// //                             {formatDateTime(issue.created_at || issue.start_time)}
// //                           </Typography>
// //                         </TableCell>

// //                         {/* 🟢 NEW END DATE/TIME COLUMN */}
// //                         <TableCell>
// //                           <Typography variant="body2">
// //                             {formatDateTime(issue.closed_at || issue.end_time)}
// //                           </Typography>
// //                         </TableCell>

// //                         <TableCell>
// //                           <Chip 
// //                             label={t(issue.status || "Open")} 
// //                             color={getStatusColor(issue.status)} 
// //                             size="small" 
// //                             variant="outlined"
// //                           />
// //                         </TableCell>
// //                         <TableCell>{t(issue.priority || "Medium")}</TableCell>
// //                         <TableCell>{issue.technician_name || t("Unassigned")}</TableCell>
// //                       </TableRow>
// //                     ))
// //                   ) : (
// //                     <TableRow>
// //                       <TableCell colSpan={8} align="center" sx={{ py: 5 }}>
// //                         <Typography color="textSecondary">{t("No issues found")}</Typography>
// //                       </TableCell>
// //                     </TableRow>
// //                   )}
// //                 </TableBody>
// //               </Table>
// //             )}
// //           </TableContainer>
// //         </CardContent>
// //       </Card>
// //     </Box>
// //   );
// // };

// // export default IssuesScreen;


// // import React, { useState, useEffect, useMemo } from "react";
// // import {
// //   TableContainer, Table, TableHead, TableRow, TableCell,
// //   TableBody, Paper, Card, CardContent, Box, Typography,
// //   Button, TextField, FormControl, InputLabel, Select, MenuItem,
// //   CircularProgress, Alert, Chip
// // } from "@mui/material";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";

// // const pickIssuesFromResponse = (data) => {
// //   if (!data) return [];
// //   if (Array.isArray(data)) return data;
// //   if (data.results && Array.isArray(data.results)) return data.results;
// //   return [];
// // };

// // const IssuesScreen = () => {
// //   const [allIssues, setAllIssues] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [statusFilter, setStatusFilter] = useState("");
// //   const [search, setSearch] = useState("");
// //   const { t } = useTranslation();

// //   const fetchIssues = async () => {
// //     setLoading(true);
// //     setError(null);
// //     try {
// //       const res = await axiosClient.get("api/issues/");
// //       const data = pickIssuesFromResponse(res.data);
// //       setAllIssues(data);
// //     } catch (err) {
// //       console.error("Fetch error:", err);
// //       setError(t("Failed to load issues from the server."));
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchIssues();
// //   }, []);

// //   const filteredIssues = useMemo(() => {
// //     return allIssues.filter((issue) => {
// //       const matchesStatus = statusFilter ? issue.status === statusFilter : true;
// //       const searchStr = search.toLowerCase();
// //       // Search logic includes staff names to cover technician and maid
// //       const matchesSearch = search
// //         ? (issue.title?.toLowerCase().includes(searchStr) ||
// //            issue.description?.toLowerCase().includes(searchStr) ||
// //            String(issue.room_number || "").toLowerCase().includes(searchStr) ||
// //            issue.staff_name?.toLowerCase().includes(searchStr) ||
// //            issue.technician_name?.toLowerCase().includes(searchStr))
// //         : true;

// //       return matchesStatus && matchesSearch;
// //     });
// //   }, [allIssues, statusFilter, search]);

// //   const getStatusColor = (status) => {
// //     switch (status?.toLowerCase()) {
// //       case 'closed': return 'success';
// //       case 'in progress': return 'warning';
// //       case 'open': return 'error';
// //       default: return 'default';
// //     }
// //   };

// //   const formatDateTime = (dateString) => {
// //     if (!dateString || dateString === "-") return "-";
// //     const date = new Date(dateString);
// //     return date.toLocaleString();
// //   };

// //   return (
// //     <Box sx={{ p: { xs: 1, sm: 3 } }}>
// //       <Card elevation={16} sx={{ borderRadius: 2 }}>
// //         <CardContent>
// //           <Typography variant="h5" fontWeight="bold" gutterBottom>
// //             {t("Issue Management List")}
// //           </Typography>

// //           <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 4, mt: 2, alignItems: "center" }}>
// //             <TextField
// //               label={t("Search Title, Room, or Staff")}
// //               variant="outlined"
// //               size="small"
// //               value={search}
// //               onChange={(e) => setSearch(e.target.value)}
// //               sx={{ flex: { xs: "1 1 100%", sm: "1 1 400px" } }}
// //             />

// //             <FormControl size="small" sx={{ minWidth: "200px" }}>
// //               <InputLabel>{t("Status")}</InputLabel>
// //               <Select
// //                 value={statusFilter}
// //                 label={t("Status")}
// //                 onChange={(e) => setStatusFilter(e.target.value)}
// //               >
// //                 <MenuItem value="">{t("All Statuses")}</MenuItem>
// //                 <MenuItem value="Open">{t("Open")}</MenuItem>
// //                 <MenuItem value="In Progress">{t("In Progress")}</MenuItem>
// //                 <MenuItem value="Closed">{t("Closed")}</MenuItem>
// //               </Select>
// //             </FormControl>

// //             <Button variant="outlined" color="secondary" onClick={() => {setSearch(""); setStatusFilter("");}}>
// //               {t("Reset")}
// //             </Button>
            
// //             <Button variant="contained" onClick={fetchIssues} disabled={loading}>
// //               {t("Refresh")}
// //             </Button>
// //           </Box>

// //           {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// //           <TableContainer component={Paper} sx={{ maxHeight: 600, border: "1px solid #e0e0e0" }}>
// //             {loading ? (
// //               <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}><CircularProgress /></Box>
// //             ) : (
// //               <Table stickyHeader>
// //                 <TableHead>
// //                   <TableRow>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("ID")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Room")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Title")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Start Date/Time")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("End Date/Time")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Status")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Priority")}</TableCell>
// //                     {/* RENAMED FROM DOCTOR TO STAFF */}
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("STAFF")}</TableCell>
// //                   </TableRow>
// //                 </TableHead>
// //                 <TableBody>
// //                   {filteredIssues.length > 0 ? (
// //                     filteredIssues.map((issue) => (
// //                       <TableRow key={issue.id} hover>
// //                         <TableCell>#{issue.id}</TableCell>
// //                         <TableCell>
// //                           <Typography variant="body2" fontWeight="bold" color="primary">
// //                             {issue.room_number || issue.room || "-"}
// //                           </Typography>
// //                         </TableCell>
// //                         <TableCell>
// //                           <Typography variant="body2" fontWeight="bold">{issue.title}</Typography>
// //                           <Typography variant="caption" color="textSecondary" noWrap sx={{ maxWidth: 200, display: 'block' }}>
// //                             {issue.description}
// //                           </Typography>
// //                         </TableCell>
// //                         <TableCell>{formatDateTime(issue.created_at || issue.start_time)}</TableCell>
// //                         <TableCell>{formatDateTime(issue.closed_at || issue.end_time)}</TableCell>
// //                         <TableCell>
// //                           <Chip 
// //                             label={t(issue.status || "Open")} 
// //                             color={getStatusColor(issue.status)} 
// //                             size="small" 
// //                             variant="outlined"
// //                           />
// //                         </TableCell>
// //                         <TableCell>{t(issue.priority || "Medium")}</TableCell>
// //                         {/* ENSURES NAME APPEARS INSTEAD OF UNASSIGNED */}
// //                         <TableCell sx={{ fontWeight: "bold" }}>
// //                           {issue.staff_name || issue.technician_name || t("Unassigned")}
// //                         </TableCell>
// //                       </TableRow>
// //                     ))
// //                   ) : (
// //                     <TableRow>
// //                       <TableCell colSpan={8} align="center" sx={{ py: 5 }}>
// //                         <Typography color="textSecondary">{t("No issues found")}</Typography>
// //                       </TableCell>
// //                     </TableRow>
// //                   )}
// //                 </TableBody>
// //               </Table>
// //             )}
// //           </TableContainer>
// //         </CardContent>
// //       </Card>
// //     </Box>
// //   );
// // };

// // export default IssuesScreen;


// ///////////////////

// // import React, { useState, useEffect, useMemo } from "react";
// // import {
// //   TableContainer, Table, TableHead, TableRow, TableCell,
// //   TableBody, Paper, Card, CardContent, Box, Typography,
// //   Button, TextField, FormControl, InputLabel, Select, MenuItem,
// //   CircularProgress, Alert, Chip, Stack, IconButton, Tooltip
// // } from "@mui/material";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import EditIcon from "@mui/icons-material/Edit";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";

// // const pickIssuesFromResponse = (data) => {
// //   if (!data) return [];
// //   if (Array.isArray(data)) return data;
// //   if (data.results && Array.isArray(data.results)) return data.results;
// //   return [];
// // };

// // const IssuesScreen = () => {
// //   const [allIssues, setAllIssues] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [statusFilter, setStatusFilter] = useState("");
// //   const [search, setSearch] = useState("");
// //   const { t } = useTranslation();

// //   const fetchIssues = async () => {
// //     setLoading(true);
// //     setError(null);
// //     try {
// //       const res = await axiosClient.get("api/issues/");
// //       const data = pickIssuesFromResponse(res.data);
// //       setAllIssues(data);
// //     } catch (err) {
// //       console.error("Fetch error:", err);
// //       setError(t("Failed to load issues from the server."));
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchIssues();
// //   }, []);

// //   // DELETE LOGIC
// //   const handleDelete = async (id) => {
// //     if (window.confirm(t("Are you sure you want to delete this issue?"))) {
// //       try {
// //         await axiosClient.delete(`api/issues/${id}/`);
// //         // Remove from local state immediately so UI updates
// //         setAllIssues((prev) => prev.filter((issue) => issue.id !== id));
// //       } catch (err) {
// //         console.error("Delete error:", err);
// //         alert(t("Error deleting issue. Please try again."));
// //       }
// //     }
// //   };

// //   // EDIT LOGIC (Placeholder for navigation or opening a modal)
// //   const handleEdit = (issue) => {
// //     console.log("Edit issue clicked:", issue);
// //     // If you have an edit screen: window.location.href = `/edit-issue/${issue.id}`;
// //     alert(t("Edit functionality for issue #") + issue.id);
// //   };

// //   const filteredIssues = useMemo(() => {
// //     return allIssues.filter((issue) => {
// //       const matchesStatus = statusFilter ? issue.status === statusFilter : true;
// //       const searchStr = search.toLowerCase();
// //       const matchesSearch = search
// //         ? (issue.title?.toLowerCase().includes(searchStr) ||
// //            issue.description?.toLowerCase().includes(searchStr) ||
// //            String(issue.room_number || "").toLowerCase().includes(searchStr) ||
// //            issue.staff_name?.toLowerCase().includes(searchStr) ||
// //            issue.technician_name?.toLowerCase().includes(searchStr))
// //         : true;

// //       return matchesStatus && matchesSearch;
// //     });
// //   }, [allIssues, statusFilter, search]);

// //   const getStatusColor = (status) => {
// //     switch (status?.toLowerCase()) {
// //       case 'closed': return 'success';
// //       case 'in progress': return 'warning';
// //       case 'open': return 'error';
// //       default: return 'default';
// //     }
// //   };

// //   const formatDateTime = (dateString) => {
// //     if (!dateString || dateString === "-") return "-";
// //     const date = new Date(dateString);
// //     return date.toLocaleString();
// //   };

// //   return (
// //     <Box sx={{ p: { xs: 1, sm: 3 } }}>
// //       <Card elevation={16} sx={{ borderRadius: 2 }}>
// //         <CardContent>
// //           <Typography variant="h5" fontWeight="bold" gutterBottom>
// //             {t("Issue Management List")}
// //           </Typography>

// //           <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 4, mt: 2, alignItems: "center" }}>
// //             <TextField
// //               label={t("Search Title, Room, or Staff")}
// //               variant="outlined"
// //               size="small"
// //               value={search}
// //               onChange={(e) => setSearch(e.target.value)}
// //               sx={{ flex: { xs: "1 1 100%", sm: "1 1 400px" } }}
// //             />

// //             <FormControl size="small" sx={{ minWidth: "200px" }}>
// //               <InputLabel>{t("Status")}</InputLabel>
// //               <Select
// //                 value={statusFilter}
// //                 label={t("Status")}
// //                 onChange={(e) => setStatusFilter(e.target.value)}
// //               >
// //                 <MenuItem value="">{t("All Statuses")}</MenuItem>
// //                 <MenuItem value="Open">{t("Open")}</MenuItem>
// //                 <MenuItem value="In Progress">{t("In Progress")}</MenuItem>
// //                 <MenuItem value="Closed">{t("Closed")}</MenuItem>
// //               </Select>
// //             </FormControl>

// //             <Button variant="outlined" color="secondary" onClick={() => {setSearch(""); setStatusFilter("");}}>
// //               {t("Reset")}
// //             </Button>
            
// //             <Button variant="contained" onClick={fetchIssues} disabled={loading}>
// //               {t("Refresh")}
// //             </Button>
// //           </Box>

// //           {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// //           <TableContainer component={Paper} sx={{ maxHeight: 600, border: "1px solid #e0e0e0" }}>
// //             {loading ? (
// //               <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}><CircularProgress /></Box>
// //             ) : (
// //               <Table stickyHeader>
// //                 <TableHead>
// //                   <TableRow>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("ID")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Room")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Title")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Start Date/Time")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Status")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("STAFF")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5", textAlign: "center" }}>{t("ACTIONS")}</TableCell>
// //                   </TableRow>
// //                 </TableHead>
// //                 <TableBody>
// //                   {filteredIssues.length > 0 ? (
// //                     filteredIssues.map((issue) => (
// //                       <TableRow key={issue.id} hover>
// //                         <TableCell>#{issue.id}</TableCell>
// //                         <TableCell>
// //                           <Typography variant="body2" fontWeight="bold" color="primary">
// //                             {issue.room_number || issue.room || "-"}
// //                           </Typography>
// //                         </TableCell>
// //                         <TableCell>
// //                           <Typography variant="body2" fontWeight="bold">{issue.title}</Typography>
// //                         </TableCell>
// //                         <TableCell>{formatDateTime(issue.created_at || issue.start_time)}</TableCell>
// //                         <TableCell>
// //                           <Chip 
// //                             label={t(issue.status || "Open")} 
// //                             color={getStatusColor(issue.status)} 
// //                             size="small" 
// //                             variant="outlined"
// //                           />
// //                         </TableCell>
// //                         <TableCell sx={{ fontWeight: "bold" }}>
// //                           {issue.staff_name || issue.technician_name || t("Unassigned")}
// //                         </TableCell>
                        
// //                         {/* NEW ACTIONS CELL */}
// //                         <TableCell>
// //                           <Stack direction="row" spacing={1} justifyContent="center">
// //                             <Tooltip title={t("Edit")}>
// //                               <IconButton size="small" color="primary" onClick={() => handleEdit(issue)}>
// //                                 <EditIcon fontSize="small" />
// //                               </IconButton>
// //                             </Tooltip>
// //                             <Tooltip title={t("Delete")}>
// //                               <IconButton size="small" color="error" onClick={() => handleDelete(issue.id)}>
// //                                 <DeleteIcon fontSize="small" />
// //                               </IconButton>
// //                             </Tooltip>
// //                           </Stack>
// //                         </TableCell>
// //                       </TableRow>
// //                     ))
// //                   ) : (
// //                     <TableRow>
// //                       <TableCell colSpan={7} align="center" sx={{ py: 5 }}>
// //                         <Typography color="textSecondary">{t("No issues found")}</Typography>
// //                       </TableCell>
// //                     </TableRow>
// //                   )}
// //                 </TableBody>
// //               </Table>
// //             )}
// //           </TableContainer>
// //         </CardContent>
// //       </Card>
// //     </Box>
// //   );
// // };

// // export default IssuesScreen;

// //////////////////


// // import React, { useState, useEffect, useMemo } from "react";
// // import {
// //   TableContainer, Table, TableHead, TableRow, TableCell,
// //   TableBody, Paper, Card, CardContent, Box, Typography,
// //   Button, TextField, FormControl, InputLabel, Select, MenuItem,
// //   CircularProgress, Alert, Chip, Stack, IconButton, Tooltip,
// //   Dialog, DialogTitle, DialogContent, DialogActions
// // } from "@mui/material";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import EditIcon from "@mui/icons-material/Edit";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";

// // const pickIssuesFromResponse = (data) => {
// //   if (!data) return [];
// //   if (Array.isArray(data)) return data;
// //   if (data.results && Array.isArray(data.results)) return data.results;
// //   return [];
// // };

// // const IssuesScreen = () => {
// //   const { t } = useTranslation();
// //   const [allIssues, setAllIssues] = useState([]);
// //   const [staffList, setStaffList] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [search, setSearch] = useState("");

// //   // Edit Modal State
// //   const [openEdit, setOpenEdit] = useState(false);
// //   const [selectedIssueId, setSelectedIssueId] = useState(null);
// //   const [editData, setEditData] = useState({
// //     title: "",
// //     room_number: "",
// //     status: "Open",
// //     assigned_technician: ""
// //   });

// //   const fetchData = async () => {
// //     setLoading(true);
// //     try {
// //       const [issueRes, staffRes] = await Promise.all([
// //         axiosClient.get("api/issues/"), // Fixed: Added 'api/'
// //         axiosClient.get("auth/users/")
// //       ]);
// //       setAllIssues(pickIssuesFromResponse(issueRes.data));
// //       const allUsers = Array.isArray(staffRes.data) ? staffRes.data : (staffRes.data.results || []);
// //       setStaffList(allUsers.filter(u => u.user_role === "TECHNICIAN" || u.user_role === "MAID"));
// //     } catch (err) {
// //       setError(t("Failed to load data."));
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchData();
// //   }, [t]);

// //   const handleDelete = async (id) => {
// //     if (!id) return;
// //     if (window.confirm(t("Are you sure you want to delete this issue?"))) {
// //       try {
// //         await axiosClient.delete(`api/issues/${id}/`); // Fixed: Added 'api/'
// //         setAllIssues(prev => prev.filter(issue => issue.id !== id));
// //       } catch (err) {
// //         alert(t("Delete failed. Check permissions."));
// //       }
// //     }
// //   };

// //   const handleOpenEdit = (issue) => {
// //     setSelectedIssueId(issue.id);
// //     setEditData({
// //       title: issue.title || "",
// //       room_number: issue.room_number || "",
// //       status: issue.status || "Open",
// //       assigned_technician: issue.assigned_technician || ""
// //     });
// //     setOpenEdit(true);
// //   };

// //   const handleSaveEdit = async () => {
// //     if (!selectedIssueId) return;
// //     try {
// //       const response = await axiosClient.put(`api/issues/${selectedIssueId}/`, editData); // Fixed: Added 'api/'
// //       setAllIssues(prev => prev.map(item => item.id === selectedIssueId ? response.data : item));
// //       setOpenEdit(false);
// //       alert(t("Updated successfully!"));
// //     } catch (err) {
// //       alert(t("Update failed. Check all fields."));
// //     }
// //   };

// //   const filteredIssues = useMemo(() => {
// //     return allIssues.filter((issue) => {
// //       const searchStr = search.toLowerCase();
// //       return issue.title?.toLowerCase().includes(searchStr) || 
// //              String(issue.room_number || "").toLowerCase().includes(searchStr);
// //     });
// //   }, [allIssues, search]);

// //   return (
// //     <Box sx={{ p: 3 }}>
// //       <Card elevation={6} sx={{ borderRadius: 2 }}>
// //         <CardContent>
// //           <Typography variant="h5" fontWeight="bold" mb={3}>{t("Issue Management List")}</Typography>
// //           <Box display="flex" gap={2} mb={3}>
// //              <TextField label={t("Search")} size="small" value={search} onChange={(e) => setSearch(e.target.value)} />
// //              <Button variant="contained" onClick={fetchData}>{t("Refresh")}</Button>
// //           </Box>
// //           <TableContainer component={Paper}>
// //             <Table stickyHeader>
// //               <TableHead>
// //                 <TableRow sx={{ bgcolor: "#f5f5f5" }}>
// //                   <TableCell>ID</TableCell>
// //                   <TableCell>{t("Room")}</TableCell>
// //                   <TableCell>{t("Title")}</TableCell>
// //                   <TableCell>{t("Status")}</TableCell>
// //                   <TableCell align="center">{t("Actions")}</TableCell>
// //                 </TableRow>
// //               </TableHead>
// //               <TableBody>
// //                 {filteredIssues.map((issue) => (
// //                   <TableRow key={issue.id} hover>
// //                     <TableCell>#{issue.id}</TableCell>
// //                     <TableCell sx={{ fontWeight: 'bold' }}>{issue.room_number}</TableCell>
// //                     <TableCell>{issue.title}</TableCell>
// //                     <TableCell><Chip label={issue.status} size="small" variant="outlined" /></TableCell>
// //                     <TableCell align="center">
// //                       <Stack direction="row" spacing={1} justifyContent="center">
// //                         <IconButton color="primary" onClick={() => handleOpenEdit(issue)}><EditIcon /></IconButton>
// //                         <IconButton color="error" onClick={() => handleDelete(issue.id)}><DeleteIcon /></IconButton>
// //                       </Stack>
// //                     </TableCell>
// //                   </TableRow>
// //                 ))}
// //               </TableBody>
// //             </Table>
// //           </TableContainer>
// //         </CardContent>
// //       </Card>

// //       <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="sm">
// //         <DialogTitle>{t("Edit Issue")} #{selectedIssueId}</DialogTitle>
// //         <DialogContent dividers>
// //           <Stack spacing={3} mt={1}>
// //             <TextField fullWidth label={t("Title")} value={editData.title} onChange={(e) => setEditData({ ...editData, title: e.target.value })} />
// //             <TextField fullWidth label={t("Room")} value={editData.room_number} onChange={(e) => setEditData({ ...editData, room_number: e.target.value })} />
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Status")}</InputLabel>
// //               <Select value={editData.status} label={t("Status")} onChange={(e) => setEditData({ ...editData, status: e.target.value })}>
// //                 <MenuItem value="Open">{t("Open")}</MenuItem>
// //                 <MenuItem value="In Progress">{t("In Progress")}</MenuItem>
// //                 <MenuItem value="Closed">{t("Closed")}</MenuItem>
// //               </Select>
// //             </FormControl>
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Staff")}</InputLabel>
// //               <Select value={editData.assigned_technician} label={t("Staff")} onChange={(e) => setEditData({ ...editData, assigned_technician: e.target.value })}>
// //                 <MenuItem value=""><em>None</em></MenuItem>
// //                 {staffList.map(user => (
// //                   <MenuItem key={user.id} value={user.id}>{user.first_name} {user.last_name} ({user.user_role})</MenuItem>
// //                 ))}
// //               </Select>
// //             </FormControl>
// //           </Stack>
// //         </DialogContent>
// //         <DialogActions sx={{ p: 2 }}>
// //           <Button onClick={() => setOpenEdit(false)}>{t("Cancel")}</Button>
// //           <Button variant="contained" onClick={handleSaveEdit}>{t("Save Changes")}</Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Box>
// //   );
// // };

// // export default IssuesScreen;



// // import React, { useState, useEffect, useMemo } from "react";
// // import {
// //   TableContainer, Table, TableHead, TableRow, TableCell,
// //   TableBody, Paper, Card, CardContent, Box, Typography,
// //   Button, TextField, FormControl, InputLabel, Select, MenuItem,
// //   CircularProgress, Alert, Chip, Stack, IconButton, Tooltip,
// //   Dialog, DialogTitle, DialogContent, DialogActions
// // } from "@mui/material";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import EditIcon from "@mui/icons-material/Edit";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";

// // const pickIssuesFromResponse = (data) => {
// //   if (!data) return [];
// //   if (Array.isArray(data)) return data;
// //   if (data.results && Array.isArray(data.results)) return data.results;
// //   return [];
// // };

// // const IssuesScreen = () => {
// //   const { t } = useTranslation();
// //   const [allIssues, setAllIssues] = useState([]);
// //   const [staffList, setStaffList] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [search, setSearch] = useState("");

// //   const [openEdit, setOpenEdit] = useState(false);
// //   const [selectedIssueId, setSelectedIssueId] = useState(null);
// //   const [editData, setEditData] = useState({
// //     title: "",
// //     room_number: "",
// //     status: "Open",
// //     priority: "Medium",
// //     assigned_technician: ""
// //   });

// //   const fetchData = async () => {
// //     setLoading(true);
// //     try {
// //       const [issueRes, staffRes] = await Promise.all([
// //         axiosClient.get("api/issues/"),
// //         axiosClient.get("auth/users/")
// //       ]);
// //       setAllIssues(pickIssuesFromResponse(issueRes.data));
// //       const allUsers = Array.isArray(staffRes.data) ? staffRes.data : (staffRes.data.results || []);
// //       setStaffList(allUsers.filter(u => u.user_role === "TECHNICIAN" || u.user_role === "MAID"));
// //     } catch (err) {
// //       setError(t("Failed to load data."));
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchData();
// //   }, [t]);

// //   const handleDelete = async (id) => {
// //     if (!id) return;
// //     if (window.confirm(t("Are you sure you want to delete this issue?"))) {
// //       try {
// //         await axiosClient.delete(`api/issues/${id}/`);
// //         setAllIssues(prev => prev.filter(issue => issue.id !== id));
// //       } catch (err) {
// //         alert(t("Delete failed."));
// //       }
// //     }
// //   };

// //   const handleOpenEdit = (issue) => {
// //     setSelectedIssueId(issue.id);
// //     setEditData({
// //       title: issue.title || "",
// //       room_number: issue.room_number || "",
// //       status: issue.status || "Open",
// //       priority: issue.priority || "Medium",
// //       assigned_technician: issue.assigned_technician || ""
// //     });
// //     setOpenEdit(true);
// //   };

// //   const handleSaveEdit = async () => {
// //     if (!selectedIssueId) return;
// //     try {
// //       const response = await axiosClient.put(`api/issues/${selectedIssueId}/`, editData);
// //       setAllIssues(prev => prev.map(item => item.id === selectedIssueId ? response.data : item));
// //       setOpenEdit(false);
// //       alert(t("Updated successfully!"));
// //     } catch (err) {
// //       alert(t("Update failed."));
// //     }
// //   };

// //   const formatDateTime = (dateString) => {
// //     if (!dateString || dateString === "-") return "-";
// //     const date = new Date(dateString);
// //     return date.toLocaleString();
// //   };

// //   const filteredIssues = useMemo(() => {
// //     return allIssues.filter((issue) => {
// //       const searchStr = search.toLowerCase();
// //       return issue.title?.toLowerCase().includes(searchStr) || 
// //              String(issue.room_number || "").toLowerCase().includes(searchStr);
// //     });
// //   }, [allIssues, search]);

// //   return (
// //     <Box sx={{ p: 3 }}>
// //       <Card elevation={16} sx={{ borderRadius: 2 }}>
// //         <CardContent>
// //           <Typography variant="h5" fontWeight="bold" mb={3}>{t("Issue Management List")}</Typography>
// //           <Box display="flex" gap={2} mb={3}>
// //              <TextField label={t("Search")} size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ flex: 1 }} />
// //              <Button variant="contained" onClick={fetchData}>{t("Refresh")}</Button>
// //           </Box>
// //           <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
// //             <Table stickyHeader>
// //               <TableHead>
// //                 <TableRow>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>ID</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Room")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Title")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Start Date/Time")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("End Date/Time")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Status")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Priority")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("STAFF")}</TableCell>
// //                   <TableCell align="center" sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("ACTIONS")}</TableCell>
// //                 </TableRow>
// //               </TableHead>
// //               <TableBody>
// //                 {filteredIssues.map((issue) => (
// //                   <TableRow key={issue.id} hover>
// //                     <TableCell>#{issue.id}</TableCell>
// //                     <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>{issue.room_number || "-"}</TableCell>
// //                     <TableCell>
// //                         <Typography variant="body2" fontWeight="bold">{issue.title}</Typography>
// //                         <Typography variant="caption" color="textSecondary">{issue.description}</Typography>
// //                     </TableCell>
// //                     <TableCell>{formatDateTime(issue.created_at || issue.start_time)}</TableCell>
// //                     <TableCell>{formatDateTime(issue.closed_at || issue.end_time)}</TableCell>
// //                     <TableCell>
// //                         <Chip label={issue.status} size="small" variant="outlined" color={issue.status === 'open' ? 'error' : 'default'} />
// //                     </TableCell>
// //                     <TableCell>{t(issue.priority || "Medium")}</TableCell>
// //                     <TableCell sx={{ fontWeight: 'bold' }}>{issue.staff_name || issue.technician_name || t("Unassigned")}</TableCell>
// //                     <TableCell align="center">
// //                       <Stack direction="row" spacing={1} justifyContent="center">
// //                         <IconButton color="primary" onClick={() => handleOpenEdit(issue)}><EditIcon fontSize="small" /></IconButton>
// //                         <IconButton color="error" onClick={() => handleDelete(issue.id)}><DeleteIcon fontSize="small" /></IconButton>
// //                       </Stack>
// //                     </TableCell>
// //                   </TableRow>
// //                 ))}
// //               </TableBody>
// //             </Table>
// //           </TableContainer>
// //         </CardContent>
// //       </Card>

// //       <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="sm">
// //         <DialogTitle sx={{ fontWeight: "bold" }}>{t("Edit Issue")} #{selectedIssueId}</DialogTitle>
// //         <DialogContent dividers>
// //           <Stack spacing={3} mt={1}>
// //             <TextField fullWidth label={t("Title")} value={editData.title} onChange={(e) => setEditData({ ...editData, title: e.target.value })} />
// //             <TextField fullWidth label={t("Room")} value={editData.room_number} onChange={(e) => setEditData({ ...editData, room_number: e.target.value })} />
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Status")}</InputLabel>
// //               <Select value={editData.status} label={t("Status")} onChange={(e) => setEditData({ ...editData, status: e.target.value })}>
// //                 <MenuItem value="open">{t("Open")}</MenuItem>
// //                 <MenuItem value="in_progress">{t("In Progress")}</MenuItem>
// //                 <MenuItem value="closed">{t("Closed")}</MenuItem>
// //               </Select>
// //             </FormControl>
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Priority")}</InputLabel>
// //               <Select value={editData.priority} label={t("Priority")} onChange={(e) => setEditData({ ...editData, priority: e.target.value })}>
// //                 <MenuItem value="Low">{t("Low")}</MenuItem>
// //                 <MenuItem value="Medium">{t("Medium")}</MenuItem>
// //                 <MenuItem value="High">{t("High")}</MenuItem>
// //               </Select>
// //             </FormControl>
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Staff")}</InputLabel>
// //               <Select value={editData.assigned_technician} label={t("Staff")} onChange={(e) => setEditData({ ...editData, assigned_technician: e.target.value })}>
// //                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
// //                 {staffList.map(user => (
// //                   <MenuItem key={user.id} value={user.id}>{user.first_name} {user.last_name} ({user.user_role})</MenuItem>
// //                 ))}
// //               </Select>
// //             </FormControl>
// //           </Stack>
// //         </DialogContent>
// //         <DialogActions sx={{ p: 2 }}>
// //           <Button onClick={() => setOpenEdit(false)}>{t("Cancel")}</Button>
// //           <Button variant="contained" onClick={handleSaveEdit}>{t("Save Changes")}</Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Box>
// //   );
// // };

// // export default IssuesScreen;

// // import React, { useState, useEffect, useMemo } from "react";
// // import {
// //   TableContainer, Table, TableHead, TableRow, TableCell,
// //   TableBody, Paper, Card, CardContent, Box, Typography,
// //   Button, TextField, FormControl, InputLabel, Select, MenuItem,
// //   CircularProgress, Alert, Chip, Stack, IconButton, Tooltip,
// //   Dialog, DialogTitle, DialogContent, DialogActions
// // } from "@mui/material";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import EditIcon from "@mui/icons-material/Edit";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";

// // const pickIssuesFromResponse = (data) => {
// //   if (!data) return [];
// //   if (Array.isArray(data)) return data;
// //   if (data.results && Array.isArray(data.results)) return data.results;
// //   return [];
// // };

// // const IssuesScreen = () => {
// //   const { t } = useTranslation();
// //   const [allIssues, setAllIssues] = useState([]);
// //   const [staffList, setStaffList] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [search, setSearch] = useState("");
// //   const [statusFilter, setStatusFilter] = useState("");

// //   // Edit Modal State
// //   const [openEdit, setOpenEdit] = useState(false);
// //   const [selectedIssueId, setSelectedIssueId] = useState(null);
// //   const [editData, setEditData] = useState({
// //     title: "",
// //     room_number: "",
// //     status: "open",
// //     priority: "Medium",
// //     assigned_technician: ""
// //   });

// //   const fetchData = async () => {
// //     setLoading(true);
// //     setError(null);
// //     try {
// //       const [issueRes, staffRes] = await Promise.all([
// //         axiosClient.get("api/issues/"),
// //         axiosClient.get("auth/users/")
// //       ]);
// //       setAllIssues(pickIssuesFromResponse(issueRes.data));
// //       const allUsers = Array.isArray(staffRes.data) ? staffRes.data : (staffRes.data.results || []);
// //       setStaffList(allUsers.filter(u => u.user_role === "TECHNICIAN" || u.user_role === "MAID"));
// //     } catch (err) {
// //       console.error("Fetch error:", err);
// //       setError(t("Failed to load data from the server. Check backend routes."));
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchData();
// //   }, [t]);

// //   const handleDelete = async (id) => {
// //     if (!id) return;
// //     if (window.confirm(t("Are you sure you want to delete this issue?"))) {
// //       try {
// //         await axiosClient.delete(`api/issues/${id}/`);
// //         setAllIssues(prev => prev.filter(issue => issue.id !== id));
// //       } catch (err) {
// //         console.error("Delete error:", err);
// //         alert(t("Error deleting issue. Please try again."));
// //       }
// //     }
// //   };

// //   const handleOpenEdit = (issue) => {
// //     setSelectedIssueId(issue.id);
// //     setEditData({
// //       title: issue.title || "",
// //       room_number: issue.room_number || "",
// //       status: issue.status || "open",
// //       priority: issue.priority || "Medium",
// //       assigned_technician: issue.assigned_technician || ""
// //     });
// //     setOpenEdit(true);
// //   };

// //   const handleSaveEdit = async () => {
// //     if (!selectedIssueId) return;
// //     try {
// //       const response = await axiosClient.put(`api/issues/${selectedIssueId}/`, editData);
// //       setAllIssues(prev => prev.map(item => item.id === selectedIssueId ? response.data : item));
// //       setOpenEdit(false);
// //       alert(t("Issue updated successfully!"));
// //     } catch (err) {
// //       console.error("Update error:", err);
// //       alert(t("Error updating issue. Check backend logs."));
// //     }
// //   };

// //   const formatDateTime = (dateString) => {
// //     if (!dateString || dateString === "-") return "-";
// //     const date = new Date(dateString);
// //     return date.toLocaleString();
// //   };

// //   const getStatusColor = (status) => {
// //     switch (status?.toLowerCase()) {
// //       case 'closed': return 'success';
// //       case 'in_progress': return 'warning';
// //       case 'open': return 'error';
// //       default: return 'default';
// //     }
// //   };

// //   const filteredIssues = useMemo(() => {
// //     return allIssues.filter((issue) => {
// //       const matchesStatus = statusFilter ? issue.status === statusFilter : true;
// //       const searchStr = search.toLowerCase();
// //       return matchesStatus && (
// //         issue.title?.toLowerCase().includes(searchStr) || 
// //         String(issue.room_number || "").toLowerCase().includes(searchStr) ||
// //         issue.staff_name?.toLowerCase().includes(searchStr)
// //       );
// //     });
// //   }, [allIssues, statusFilter, search]);

// //   return (
// //     <Box sx={{ p: { xs: 1, sm: 3 } }}>
// //       <Card elevation={16} sx={{ borderRadius: 2 }}>
// //         <CardContent>
// //           <Typography variant="h5" fontWeight="bold" gutterBottom>{t("Issue Management List")}</Typography>

// //           <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 4, mt: 2, alignItems: "center" }}>
// //             <TextField
// //               label={t("Search Title, Room, or Staff")}
// //               variant="outlined"
// //               size="small"
// //               value={search}
// //               onChange={(e) => setSearch(e.target.value)}
// //               sx={{ flex: { xs: "1 1 100%", sm: "1 1 400px" } }}
// //             />
// //             <FormControl size="small" sx={{ minWidth: "200px" }}>
// //               <InputLabel>{t("Status")}</InputLabel>
// //               <Select
// //                 value={statusFilter}
// //                 label={t("Status")}
// //                 onChange={(e) => setStatusFilter(e.target.value)}
// //               >
// //                 <MenuItem value="">{t("All Statuses")}</MenuItem>
// //                 <MenuItem value="open">{t("Open")}</MenuItem>
// //                 <MenuItem value="in_progress">{t("In Progress")}</MenuItem>
// //                 <MenuItem value="closed">{t("Closed")}</MenuItem>
// //               </Select>
// //             </FormControl>
// //             <Button variant="contained" onClick={fetchData} disabled={loading}>{t("Refresh")}</Button>
// //           </Box>

// //           {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// //           <TableContainer component={Paper} sx={{ maxHeight: 600, border: "1px solid #e0e0e0" }}>
// //             {loading ? (
// //               <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}><CircularProgress /></Box>
// //             ) : (
// //               <Table stickyHeader>
// //                 <TableHead>
// //                   <TableRow>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>ID</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Room")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Title")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Start Date/Time")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("End Date/Time")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Status")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Priority")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("STAFF")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5", textAlign: "center" }}>{t("ACTIONS")}</TableCell>
// //                   </TableRow>
// //                 </TableHead>
// //                 <TableBody>
// //                   {filteredIssues.map((issue) => (
// //                     <TableRow key={issue.id} hover>
// //                       <TableCell>#{issue.id}</TableCell>
// //                       <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>
// //                         {issue.room_number || "-"}
// //                       </TableCell>
// //                       <TableCell>
// //                         <Typography variant="body2" fontWeight="bold">{issue.title}</Typography>
// //                         <Typography variant="caption" color="textSecondary" sx={{ display: 'block' }}>
// //                           {issue.description}
// //                         </Typography>
// //                       </TableCell>
// //                       <TableCell>{formatDateTime(issue.created_at || issue.start_time)}</TableCell>
// //                       <TableCell>{formatDateTime(issue.closed_at || issue.end_time)}</TableCell>
// //                       <TableCell>
// //                         <Chip 
// //                           label={t(issue.status || "open")} 
// //                           color={getStatusColor(issue.status)} 
// //                           size="small" 
// //                           variant="outlined" 
// //                         />
// //                       </TableCell>
// //                       <TableCell>{t(issue.priority || "Medium")}</TableCell>
// //                       <TableCell sx={{ fontWeight: 'bold' }}>
// //                         {issue.staff_name || issue.technician_name || t("Unassigned")}
// //                       </TableCell>
// //                       <TableCell>
// //                         <Stack direction="row" spacing={1} justifyContent="center">
// //                           <Tooltip title={t("Edit")}>
// //                             <IconButton size="small" color="primary" onClick={() => handleOpenEdit(issue)}>
// //                               <EditIcon fontSize="small" />
// //                             </IconButton>
// //                           </Tooltip>
// //                           <Tooltip title={t("Delete")}>
// //                             <IconButton size="small" color="error" onClick={() => handleDelete(issue.id)}>
// //                               <DeleteIcon fontSize="small" />
// //                             </IconButton>
// //                           </Tooltip>
// //                         </Stack>
// //                       </TableCell>
// //                     </TableRow>
// //                   ))}
// //                 </TableBody>
// //               </Table>
// //             )}
// //           </TableContainer>
// //         </CardContent>
// //       </Card>

// //       {/* --- EDIT MODAL --- */}
// //       <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="sm">
// //         <DialogTitle sx={{ fontWeight: "bold" }}>{t("Edit Issue")} #{selectedIssueId}</DialogTitle>
// //         <DialogContent dividers>
// //           <Stack spacing={3} sx={{ mt: 1 }}>
// //             <TextField
// //               fullWidth
// //               label={t("Issue Title *")}
// //               value={editData.title}
// //               onChange={(e) => setEditData({ ...editData, title: e.target.value })}
// //             />
// //             <TextField
// //               fullWidth
// //               label={t("Room Number *")}
// //               value={editData.room_number}
// //               onChange={(e) => setEditData({ ...editData, room_number: e.target.value })}
// //             />
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Status")}</InputLabel>
// //               <Select
// //                 value={editData.status}
// //                 label={t("Status")}
// //                 onChange={(e) => setEditData({ ...editData, status: e.target.value })}
// //               >
// //                 <MenuItem value="open">{t("Open")}</MenuItem>
// //                 <MenuItem value="in_progress">{t("In Progress")}</MenuItem>
// //                 <MenuItem value="closed">{t("Closed")}</MenuItem>
// //               </Select>
// //             </FormControl>
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Priority")}</InputLabel>
// //               <Select
// //                 value={editData.priority}
// //                 label={t("Priority")}
// //                 onChange={(e) => setEditData({ ...editData, priority: e.target.value })}
// //               >
// //                 <MenuItem value="Low">{t("Low")}</MenuItem>
// //                 <MenuItem value="Medium">{t("Medium")}</MenuItem>
// //                 <MenuItem value="High">{t("High")}</MenuItem>
// //               </Select>
// //             </FormControl>
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Select Staff")}</InputLabel>
// //               <Select
// //                 value={editData.assigned_technician}
// //                 label={t("Select Staff")}
// //                 onChange={(e) => setEditData({ ...editData, assigned_technician: e.target.value })}
// //               >
// //                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
// //                 {staffList.map((user) => (
// //                   <MenuItem key={user.id} value={user.id}>
// //                     {`${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email} ({user.user_role})
// //                   </MenuItem>
// //                 ))}
// //               </Select>
// //             </FormControl>
// //           </Stack>
// //         </DialogContent>
// //         <DialogActions sx={{ p: 3 }}>
// //           <Button onClick={() => setOpenEdit(false)} color="inherit">{t("CANCEL")}</Button>
// //           <Button onClick={handleSaveEdit} variant="contained" color="primary">{t("SAVE CHANGES")}</Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Box>
// //   );
// // };

// // export default IssuesScreen;


// // import React, { useState, useEffect, useMemo } from "react";
// // import {
// //   TableContainer, Table, TableHead, TableRow, TableCell,
// //   TableBody, Paper, Card, CardContent, Box, Typography,
// //   Button, TextField, FormControl, InputLabel, Select, MenuItem,
// //   CircularProgress, Alert, Chip, Stack, IconButton, Tooltip,
// //   Dialog, DialogTitle, DialogContent, DialogActions
// // } from "@mui/material";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import EditIcon from "@mui/icons-material/Edit";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";

// // const pickIssuesFromResponse = (data) => {
// //   if (!data) return [];
// //   if (Array.isArray(data)) return data;
// //   if (data.results && Array.isArray(data.results)) return data.results;
// //   return [];
// // };

// // const IssuesScreen = () => {
// //   const { t } = useTranslation();
// //   const [allIssues, setAllIssues] = useState([]);
// //   const [staffList, setStaffList] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [search, setSearch] = useState("");
// //   const [statusFilter, setStatusFilter] = useState("");

// //   const [openEdit, setOpenEdit] = useState(false);
// //   const [selectedIssueId, setSelectedIssueId] = useState(null);
// //   const [editData, setEditData] = useState({
// //     title: "",
// //     room_number: "",
// //     status: "open",
// //     priority: "Medium",
// //     assigned_technician: ""
// //   });

// //   const fetchData = async () => {
// //     setLoading(true);
// //     setError(null);
// //     try {
// //       const [issueRes, staffRes] = await Promise.all([
// //         axiosClient.get("api/issues/"),
// //         axiosClient.get("auth/users/")
// //       ]);
// //       setAllIssues(pickIssuesFromResponse(issueRes.data));
// //       const allUsers = Array.isArray(staffRes.data) ? staffRes.data : (staffRes.data.results || []);
// //       setStaffList(allUsers.filter(u => u.user_role === "TECHNICIAN" || u.user_role === "MAID"));
// //     } catch (err) {
// //       console.error("Fetch error:", err);
// //       setError(t("Failed to load data from the server. Check backend routes."));
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchData();
// //   }, [t]);

// //   const handleDelete = async (id) => {
// //     if (!id) return;
// //     if (window.confirm(t("Are you sure you want to delete this issue?"))) {
// //       try {
// //         await axiosClient.delete(`api/issues/${id}/`);
// //         setAllIssues(prev => prev.filter(issue => issue.id !== id));
// //       } catch (err) {
// //         console.error("Delete error:", err);
// //         alert(t("Error deleting issue."));
// //       }
// //     }
// //   };

// //   const handleOpenEdit = (issue) => {
// //     setSelectedIssueId(issue.id);
// //     setEditData({
// //       title: issue.title || "",
// //       room_number: issue.room_number || "",
// //       status: issue.status || "open",
// //       priority: issue.priority || "Medium",
// //       assigned_technician: issue.assigned_technician || ""
// //     });
// //     setOpenEdit(true);
// //   };

// //   const handleSaveEdit = async () => {
// //     if (!selectedIssueId) return;
// //     try {
// //       const response = await axiosClient.put(`api/issues/${selectedIssueId}/`, editData);
// //       setAllIssues(prev => prev.map(item => item.id === selectedIssueId ? response.data : item));
// //       setOpenEdit(false);
// //       alert(t("Issue updated successfully!"));
// //     } catch (err) {
// //       console.error("Update error:", err);
// //       alert(t("Update failed."));
// //     }
// //   };

// //   const formatDateTime = (dateString) => {
// //     if (!dateString || dateString === "-") return "-";
// //     const date = new Date(dateString);
// //     return date.toLocaleString();
// //   };

// //   const getStatusColor = (status) => {
// //     switch (status?.toLowerCase()) {
// //       case 'closed': return 'success';
// //       case 'in progress': return 'warning';
// //       case 'open': return 'error';
// //       default: return 'default';
// //     }
// //   };

// //   const filteredIssues = useMemo(() => {
// //     return allIssues.filter((issue) => {
// //       const matchesStatus = statusFilter ? issue.status === statusFilter : true;
// //       const searchStr = search.toLowerCase();
// //       return matchesStatus && (
// //         issue.title?.toLowerCase().includes(searchStr) || 
// //         String(issue.room_number || "").toLowerCase().includes(searchStr) ||
// //         issue.staff_name?.toLowerCase().includes(searchStr) ||
// //         issue.technician_name?.toLowerCase().includes(searchStr)
// //       );
// //     });
// //   }, [allIssues, statusFilter, search]);

// //   return (
// //     <Box sx={{ p: { xs: 1, sm: 3 } }}>
// //       <Card elevation={16} sx={{ borderRadius: 2 }}>
// //         <CardContent>
// //           <Typography variant="h5" fontWeight="bold" gutterBottom>{t("Issue Management List")}</Typography>

// //           <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 4, mt: 2, alignItems: "center" }}>
// //             <TextField
// //               label={t("Search Title, Room, or Staff")}
// //               variant="outlined"
// //               size="small"
// //               value={search}
// //               onChange={(e) => setSearch(e.target.value)}
// //               sx={{ flex: { xs: "1 1 100%", sm: "1 1 400px" } }}
// //             />
// //             <FormControl size="small" sx={{ minWidth: "200px" }}>
// //               <InputLabel>{t("Status")}</InputLabel>
// //               <Select
// //                 value={statusFilter}
// //                 label={t("Status")}
// //                 onChange={(e) => setStatusFilter(e.target.value)}
// //               >
// //                 <MenuItem value="">{t("All Statuses")}</MenuItem>
// //                 <MenuItem value="open">{t("Open")}</MenuItem>
// //                 <MenuItem value="in progress">{t("In Progress")}</MenuItem>
// //                 <MenuItem value="closed">{t("Closed")}</MenuItem>
// //               </Select>
// //             </FormControl>
// //             <Button variant="contained" onClick={fetchData} disabled={loading}>{t("Refresh")}</Button>
// //           </Box>

// //           {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// //           <TableContainer component={Paper} sx={{ maxHeight: 600, border: "1px solid #e0e0e0" }}>
// //             {loading ? (
// //               <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}><CircularProgress /></Box>
// //             ) : (
// //               <Table stickyHeader>
// //                 <TableHead>
// //                   <TableRow>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>ID</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Room")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Title")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Start Date/Time")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("End Date/Time")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Status")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Priority")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("STAFF")}</TableCell>
// //                     <TableCell align="center" sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("ACTIONS")}</TableCell>
// //                   </TableRow>
// //                 </TableHead>
// //                 <TableBody>
// //                   {filteredIssues.map((issue) => (
// //                     <TableRow key={issue.id} hover>
// //                       <TableCell>#{issue.id}</TableCell>
// //                       <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>
// //                         {issue.room_number || "-"}
// //                       </TableCell>
// //                       <TableCell>
// //                         <Typography variant="body2" fontWeight="bold">{issue.title}</Typography>
// //                         <Typography variant="caption" color="textSecondary" sx={{ display: 'block' }}>
// //                           {issue.description}
// //                         </Typography>
// //                       </TableCell>
// //                       <TableCell>{formatDateTime(issue.created_at || issue.start_time)}</TableCell>
// //                       <TableCell>{formatDateTime(issue.closed_at || issue.end_time)}</TableCell>
// //                       <TableCell>
// //                         <Chip 
// //                           label={t(issue.status || "open")} 
// //                           color={getStatusColor(issue.status)} 
// //                           size="small" 
// //                           variant="outlined" 
// //                         />
// //                       </TableCell>
// //                       <TableCell>{t(issue.priority || "Medium")}</TableCell>
// //                       {/* FIX: Ensure staff name appears correctly in column */}
// //                       <TableCell sx={{ fontWeight: 'bold' }}>
// //                         {issue.assigned_technician_name || issue.staff_name || issue.technician_name || t("Unassigned")}
// //                       </TableCell>
// //                       <TableCell>
// //                         <Stack direction="row" spacing={1} justifyContent="center">
// //                           <Tooltip title={t("Edit")}>
// //                             <IconButton size="small" color="primary" onClick={() => handleOpenEdit(issue)}>
// //                               <EditIcon fontSize="small" />
// //                             </IconButton>
// //                           </Tooltip>
// //                           <Tooltip title={t("Delete")}>
// //                             <IconButton size="small" color="error" onClick={() => handleDelete(issue.id)}>
// //                               <DeleteIcon fontSize="small" />
// //                             </IconButton>
// //                           </Tooltip>
// //                         </Stack>
// //                       </TableCell>
// //                     </TableRow>
// //                   ))}
// //                 </TableBody>
// //               </Table>
// //             )}
// //           </TableContainer>
// //         </CardContent>
// //       </Card>

// //       {/* --- EDIT MODAL --- */}
// //       <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="sm">
// //         <DialogTitle sx={{ fontWeight: "bold" }}>{t("Edit Issue")} #{selectedIssueId}</DialogTitle>
// //         <DialogContent dividers>
// //           <Stack spacing={3} sx={{ mt: 1 }}>
// //             <TextField
// //               fullWidth
// //               label={t("Issue Title *")}
// //               value={editData.title}
// //               onChange={(e) => setEditData({ ...editData, title: e.target.value })}
// //             />
// //             <TextField
// //               fullWidth
// //               label={t("Room Number *")}
// //               value={editData.room_number}
// //               onChange={(e) => setEditData({ ...editData, room_number: e.target.value })}
// //             />
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Status")}</InputLabel>
// //               <Select
// //                 value={editData.status}
// //                 label={t("Status")}
// //                 onChange={(e) => setEditData({ ...editData, status: e.target.value })}
// //               >
// //                 <MenuItem value="open">{t("Open")}</MenuItem>
// //                 <MenuItem value="in progress">{t("In Progress")}</MenuItem>
// //                 <MenuItem value="closed">{t("Closed")}</MenuItem>
// //               </Select>
// //             </FormControl>
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Priority")}</InputLabel>
// //               <Select
// //                 value={editData.priority}
// //                 label={t("Priority")}
// //                 onChange={(e) => setEditData({ ...editData, priority: e.target.value })}
// //               >
// //                 <MenuItem value="Low">{t("Low")}</MenuItem>
// //                 <MenuItem value="Medium">{t("Medium")}</MenuItem>
// //                 <MenuItem value="High">{t("High")}</MenuItem>
// //               </Select>
// //             </FormControl>
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Select Staff")}</InputLabel>
// //               <Select
// //                 value={editData.assigned_technician}
// //                 label={t("Select Staff")}
// //                 onChange={(e) => setEditData({ ...editData, assigned_technician: e.target.value })}
// //               >
// //                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
// //                 {staffList.map((user) => (
// //                   <MenuItem key={user.id} value={user.id}>
// //                     {`${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email} ({user.user_role})
// //                   </MenuItem>
// //                 ))}
// //               </Select>
// //             </FormControl>
// //           </Stack>
// //         </DialogContent>
// //         <DialogActions sx={{ p: 3 }}>
// //           <Button onClick={() => setOpenEdit(false)} color="inherit">{t("CANCEL")}</Button>
// //           <Button onClick={handleSaveEdit} variant="contained" color="primary">{t("SAVE CHANGES")}</Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Box>
// //   );
// // };

// // export default IssuesScreen;


// // import React, { useState, useEffect, useMemo } from "react";
// // import {
// //   TableContainer, Table, TableHead, TableRow, TableCell,
// //   TableBody, Paper, Card, CardContent, Box, Typography,
// //   Button, TextField, FormControl, InputLabel, Select, MenuItem,
// //   CircularProgress, Alert, Chip, Stack, IconButton, Tooltip,
// //   Dialog, DialogTitle, DialogContent, DialogActions
// // } from "@mui/material";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import EditIcon from "@mui/icons-material/Edit";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";

// // const pickIssuesFromResponse = (data) => {
// //   if (!data) return [];
// //   if (Array.isArray(data)) return data;
// //   if (data.results && Array.isArray(data.results)) return data.results;
// //   return [];
// // };

// // const IssuesScreen = () => {
// //   const { t } = useTranslation();
// //   const [allIssues, setAllIssues] = useState([]);
// //   const [staffList, setStaffList] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [search, setSearch] = useState("");
// //   const [statusFilter, setStatusFilter] = useState("");

// //   const [openEdit, setOpenEdit] = useState(false);
// //   const [selectedIssueId, setSelectedIssueId] = useState(null);
// //   const [editData, setEditData] = useState({
// //     title: "",
// //     room_number: "",
// //     status: "open",
// //     priority: "Medium",
// //     assigned_technician: ""
// //   });

// //   const fetchData = async () => {
// //     setLoading(true);
// //     setError(null);
// //     try {
// //       // Use standard api paths that returned 200 OK in logs
// //       const [issueRes, staffRes] = await Promise.all([
// //         axiosClient.get("api/issues/"),
// //         axiosClient.get("auth/users/")
// //       ]);
// //       setAllIssues(pickIssuesFromResponse(issueRes.data));
// //       const allUsers = Array.isArray(staffRes.data) ? staffRes.data : (staffRes.data.results || []);
// //       setStaffList(allUsers.filter(u => u.user_role === "TECHNICIAN" || u.user_role === "MAID"));
// //     } catch (err) {
// //       console.error("Fetch error:", err);
// //       setError(t("Failed to load data from the server. Check backend routes."));
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchData();
// //   }, [t]);

// //   const handleDelete = async (id) => {
// //     if (!id) return;
// //     if (window.confirm(t("Are you sure you want to delete this issue?"))) {
// //       try {
// //         await axiosClient.delete(`api/issues/${id}/`);
// //         setAllIssues(prev => prev.filter(issue => issue.id !== id));
// //       } catch (err) {
// //         console.error("Delete error:", err);
// //         alert(t("Error deleting issue. Please try again."));
// //       }
// //     }
// //   };

// //   const handleOpenEdit = (issue) => {
// //     setSelectedIssueId(issue.id);
// //     setEditData({
// //       title: issue.title || "",
// //       room_number: issue.room_number || "",
// //       status: issue.status || "open",
// //       priority: issue.priority || "Medium",
// //       assigned_technician: issue.assigned_technician || ""
// //     });
// //     setOpenEdit(true);
// //   };

// //   const handleSaveEdit = async () => {
// //     if (!selectedIssueId) return;
// //     try {
// //       const response = await axiosClient.put(`api/issues/${selectedIssueId}/`, editData);
// //       // Immediately refresh list after save to update staff names in the column
// //       fetchData(); 
// //       setOpenEdit(false);
// //       alert(t("Issue updated successfully!"));
// //     } catch (err) {
// //       console.error("Update error:", err);
// //       alert(t("Update failed."));
// //     }
// //   };

// //   const formatDateTime = (dateString) => {
// //     if (!dateString || dateString === "-") return "-";
// //     const date = new Date(dateString);
// //     return date.toLocaleString();
// //   };

// //   const getStatusColor = (status) => {
// //     switch (status?.toLowerCase()) {
// //       case 'closed': return 'success';
// //       case 'in_progress': 
// //       case 'in progress': return 'warning';
// //       case 'open': return 'error';
// //       default: return 'default';
// //     }
// //   };

// //   const filteredIssues = useMemo(() => {
// //     return allIssues.filter((issue) => {
// //       const matchesStatus = statusFilter ? issue.status === statusFilter : true;
// //       const searchStr = search.toLowerCase();
// //       return matchesStatus && (
// //         issue.title?.toLowerCase().includes(searchStr) || 
// //         String(issue.room_number || "").toLowerCase().includes(searchStr) ||
// //         (issue.assigned_technician_name || issue.staff_name || issue.technician_name || "").toLowerCase().includes(searchStr)
// //       );
// //     });
// //   }, [allIssues, statusFilter, search]);

// //   return (
// //     <Box sx={{ p: { xs: 1, sm: 3 } }}>
// //       <Card elevation={16} sx={{ borderRadius: 2 }}>
// //         <CardContent>
// //           <Typography variant="h5" fontWeight="bold" gutterBottom>{t("Issue Management List")}</Typography>

// //           <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 4, mt: 2, alignItems: "center" }}>
// //             <TextField
// //               label={t("Search Title, Room, or Staff")}
// //               variant="outlined"
// //               size="small"
// //               value={search}
// //               onChange={(e) => setSearch(e.target.value)}
// //               sx={{ flex: { xs: "1 1 100%", sm: "1 1 400px" } }}
// //             />
// //             <FormControl size="small" sx={{ minWidth: "200px" }}>
// //               <InputLabel>{t("Status")}</InputLabel>
// //               <Select
// //                 value={statusFilter}
// //                 label={t("Status")}
// //                 onChange={(e) => setStatusFilter(e.target.value)}
// //               >
// //                 <MenuItem value="">{t("All Statuses")}</MenuItem>
// //                 <MenuItem value="open">{t("Open")}</MenuItem>
// //                 <MenuItem value="in progress">{t("In Progress")}</MenuItem>
// //                 <MenuItem value="closed">{t("Closed")}</MenuItem>
// //               </Select>
// //             </FormControl>
// //             <Button variant="contained" onClick={fetchData} disabled={loading}>{t("Refresh")}</Button>
// //           </Box>

// //           {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// //           <TableContainer component={Paper} sx={{ maxHeight: 700, border: "1px solid #e0e0e0" }}>
// //             {loading ? (
// //               <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}><CircularProgress /></Box>
// //             ) : (
// //               <Table stickyHeader>
// //                 <TableHead>
// //                   <TableRow>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>ID</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Room")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Title")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Start Date/Time")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("End Date/Time")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Status")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Priority")}</TableCell>
// //                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("STAFF")}</TableCell>
// //                     <TableCell align="center" sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("ACTIONS")}</TableCell>
// //                   </TableRow>
// //                 </TableHead>
// //                 <TableBody>
// //                   {filteredIssues.map((issue) => (
// //                     <TableRow key={issue.id} hover>
// //                       <TableCell>#{issue.id}</TableCell>
// //                       <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>
// //                         {issue.room_number || "-"}
// //                       </TableCell>
// //                       <TableCell>
// //                         <Typography variant="body2" fontWeight="bold">{issue.title}</Typography>
// //                         <Typography variant="caption" color="textSecondary" sx={{ display: 'block' }}>
// //                           {issue.description}
// //                         </Typography>
// //                       </TableCell>
// //                       <TableCell>{formatDateTime(issue.created_at || issue.start_time)}</TableCell>
// //                       <TableCell>{formatDateTime(issue.closed_at || issue.end_time)}</TableCell>
// //                       <TableCell>
// //                         <Chip 
// //                           label={t(issue.status || "open")} 
// //                           color={getStatusColor(issue.status)} 
// //                           size="small" 
// //                           variant="outlined" 
// //                         />
// //                       </TableCell>
// //                       <TableCell>{t(issue.priority || "Medium")}</TableCell>
                      
// //                       {/* FIX: Column now checks all possible name fields to avoid "Unassigned" */}
// //                       <TableCell sx={{ fontWeight: 'bold' }}>
// //                         {issue.assigned_technician_name || issue.staff_name || issue.technician_name || t("Unassigned")}
// //                       </TableCell>

// //                       <TableCell>
// //                         <Stack direction="row" spacing={1} justifyContent="center">
// //                           <Tooltip title={t("Edit")}>
// //                             <IconButton size="small" color="primary" onClick={() => handleOpenEdit(issue)}>
// //                               <EditIcon fontSize="small" />
// //                             </IconButton>
// //                           </Tooltip>
// //                           <Tooltip title={t("Delete")}>
// //                             <IconButton size="small" color="error" onClick={() => handleDelete(issue.id)}>
// //                               <DeleteIcon fontSize="small" />
// //                             </IconButton>
// //                           </Tooltip>
// //                         </Stack>
// //                       </TableCell>
// //                     </TableRow>
// //                   ))}
// //                 </TableBody>
// //               </Table>
// //             )}
// //           </TableContainer>
// //         </CardContent>
// //       </Card>

// //       {/* --- EDIT MODAL --- */}
// //       <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="sm">
// //         <DialogTitle sx={{ fontWeight: "bold" }}>{t("Edit Issue")} #{selectedIssueId}</DialogTitle>
// //         <DialogContent dividers>
// //           <Stack spacing={3} sx={{ mt: 1 }}>
// //             <TextField
// //               fullWidth
// //               label={t("Issue Title *")}
// //               value={editData.title}
// //               onChange={(e) => setEditData({ ...editData, title: e.target.value })}
// //             />
// //             <TextField
// //               fullWidth
// //               label={t("Room Number *")}
// //               value={editData.room_number}
// //               onChange={(e) => setEditData({ ...editData, room_number: e.target.value })}
// //             />
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Status")}</InputLabel>
// //               <Select
// //                 value={editData.status}
// //                 label={t("Status")}
// //                 onChange={(e) => setEditData({ ...editData, status: e.target.value })}
// //               >
// //                 <MenuItem value="open">{t("Open")}</MenuItem>
// //                 <MenuItem value="in progress">{t("In Progress")}</MenuItem>
// //                 <MenuItem value="closed">{t("Closed")}</MenuItem>
// //               </Select>
// //             </FormControl>
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Priority")}</InputLabel>
// //               <Select
// //                 value={editData.priority}
// //                 label={t("Priority")}
// //                 onChange={(e) => setEditData({ ...editData, priority: e.target.value })}
// //               >
// //                 <MenuItem value="Low">{t("Low")}</MenuItem>
// //                 <MenuItem value="Medium">{t("Medium")}</MenuItem>
// //                 <MenuItem value="High">{t("High")}</MenuItem>
// //               </Select>
// //             </FormControl>
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Select Staff")}</InputLabel>
// //               <Select
// //                 value={editData.assigned_technician}
// //                 label={t("Select Staff")}
// //                 onChange={(e) => setEditData({ ...editData, assigned_technician: e.target.value })}
// //               >
// //                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
// //                 {staffList.map((user) => (
// //                   <MenuItem key={user.id} value={user.id}>
// //                     {`${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email} ({user.user_role})
// //                   </MenuItem>
// //                 ))}
// //               </Select>
// //             </FormControl>
// //           </Stack>
// //         </DialogContent>
// //         <DialogActions sx={{ p: 3 }}>
// //           <Button onClick={() => setOpenEdit(false)} color="inherit">{t("CANCEL")}</Button>
// //           <Button onClick={handleSaveEdit} variant="contained" color="primary">{t("SAVE CHANGES")}</Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Box>
// //   );
// // };

// // export default IssuesScreen;

// ///////////////////////////////////

// // import React, { useState, useEffect, useMemo } from "react";
// // import {
// //   TableContainer, Table, TableHead, TableRow, TableCell,
// //   TableBody, Paper, Card, CardContent, Box, Typography,
// //   Button, TextField, FormControl, InputLabel, Select, MenuItem,
// //   CircularProgress, Alert, Chip, Stack, IconButton, Tooltip,
// //   Dialog, DialogTitle, DialogContent, DialogActions
// // } from "@mui/material";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import EditIcon from "@mui/icons-material/Edit";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";

// // const pickIssuesFromResponse = (data) => {
// //   if (!data) return [];
// //   if (Array.isArray(data)) return data;
// //   if (data.results && Array.isArray(data.results)) return data.results;
// //   return [];
// // };

// // const IssuesScreen = () => {
// //   const { t } = useTranslation();
// //   const [allIssues, setAllIssues] = useState([]);
// //   const [staffList, setStaffList] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [search, setSearch] = useState("");

// //   // Edit Modal State
// //   const [openEdit, setOpenEdit] = useState(false);
// //   const [selectedIssueId, setSelectedIssueId] = useState(null);
// //   const [editData, setEditData] = useState({
// //     title: "", room_number: "", status: "open", priority: "Medium", assigned_technician: ""
// //   });

// //   const fetchData = async () => {
// //     setLoading(true);
// //     try {
// //       const [issueRes, staffRes] = await Promise.all([
// //         axiosClient.get("api/issues/"),
// //         axiosClient.get("auth/users/")
// //       ]);
// //       setAllIssues(pickIssuesFromResponse(issueRes.data));
// //       const allUsers = Array.isArray(staffRes.data) ? staffRes.data : (staffRes.data.results || []);
// //       setStaffList(allUsers.filter(u => u.user_role === "TECHNICIAN" || u.user_role === "MAID"));
// //     } catch (err) {
// //       setError(t("Failed to load data."));
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => { fetchData(); }, [t]);

// //   const handleDelete = async (id) => {
// //     if (!id) return;
// //     if (window.confirm(t("Are you sure you want to delete this issue?"))) {
// //       try {
// //         await axiosClient.delete(`api/issues/${id}/`);
// //         setAllIssues(prev => prev.filter(issue => issue.id !== id));
// //       } catch (err) { alert(t("Delete failed.")); }
// //     }
// //   };

// //   const handleOpenEdit = (issue) => {
// //     setSelectedIssueId(issue.id);
// //     setEditData({
// //       title: issue.title || "",
// //       room_number: issue.room_number || "",
// //       status: issue.status || "open",
// //       priority: issue.priority || "Medium",
// //       assigned_technician: issue.assigned_technician || ""
// //     });
// //     setOpenEdit(true);
// //   };

// //   const handleSaveEdit = async () => {
// //     try {
// //       const response = await axiosClient.put(`api/issues/${selectedIssueId}/`, editData);
// //       // We refresh the list to make sure we get the updated staff_name from the backend
// //       fetchData(); 
// //       setOpenEdit(false);
// //       alert(t("Updated successfully!"));
// //     } catch (err) { alert(t("Update failed.")); }
// //   };

// //   const formatDateTime = (dateString) => {
// //     if (!dateString) return "-";
// //     return new Date(dateString).toLocaleString();
// //   };

// //   return (
// //     <Box sx={{ p: 3 }}>
// //       <Card elevation={6} sx={{ borderRadius: 2 }}>
// //         <CardContent>
// //           <Typography variant="h5" fontWeight="bold" mb={3}>{t("Issue Management List")}</Typography>
// //           <Box display="flex" gap={2} mb={3}>
// //              <TextField label={t("Search")} size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ flex: 1 }} />
// //              <Button variant="contained" onClick={fetchData}>{t("Refresh")}</Button>
// //           </Box>
// //           <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
// //             <Table stickyHeader>
// //               <TableHead>
// //                 <TableRow>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>ID</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Room")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Title")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Start Date/Time")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Status")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("STAFF")}</TableCell>
// //                   <TableCell align="center" sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("ACTIONS")}</TableCell>
// //                 </TableRow>
// //               </TableHead>
// //               <TableBody>
// //                 {allIssues.filter(i => i.title?.toLowerCase().includes(search.toLowerCase())).map((issue) => (
// //                   <TableRow key={issue.id} hover>
// //                     <TableCell>#{issue.id}</TableCell>
// //                     <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>{issue.room_number || "-"}</TableCell>
// //                     <TableCell>
// //                         <Typography variant="body2" fontWeight="bold">{issue.title}</Typography>
// //                         <Typography variant="caption" color="textSecondary">{issue.description}</Typography>
// //                     </TableCell>
// //                     <TableCell>{formatDateTime(issue.created_at)}</TableCell>
// //                     <TableCell>
// //                         <Chip label={issue.status} size="small" variant="outlined" color={issue.status === 'open' ? 'error' : 'success'} />
// //                     </TableCell>
                    
// //                     {/* --- FIXED: Staff column uses the flattened staff_name from serializer --- */}
// //                     <TableCell sx={{ fontWeight: 'bold' }}>
// //                       {issue.staff_name || t("Unassigned")}
// //                     </TableCell>

// //                     <TableCell align="center">
// //                       <Stack direction="row" spacing={1} justifyContent="center">
// //                         <IconButton color="primary" onClick={() => handleOpenEdit(issue)}><EditIcon fontSize="small" /></IconButton>
// //                         <IconButton color="error" onClick={() => handleDelete(issue.id)}><DeleteIcon fontSize="small" /></IconButton>
// //                       </Stack>
// //                     </TableCell>
// //                   </TableRow>
// //                 ))}
// //               </TableBody>
// //             </Table>
// //           </TableContainer>
// //         </CardContent>
// //       </Card>

// //       {/* --- Edit Modal --- */}
// //       <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="sm">
// //         <DialogTitle sx={{ fontWeight: "bold" }}>{t("Edit Issue")} #{selectedIssueId}</DialogTitle>
// //         <DialogContent dividers>
// //           <Stack spacing={3} mt={1}>
// //             <TextField fullWidth label={t("Title")} value={editData.title} onChange={(e) => setEditData({ ...editData, title: e.target.value })} />
// //             <TextField fullWidth label={t("Room")} value={editData.room_number} onChange={(e) => setEditData({ ...editData, room_number: e.target.value })} />
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Status")}</InputLabel>
// //               <Select value={editData.status} label={t("Status")} onChange={(e) => setEditData({ ...editData, status: e.target.value })}>
// //                 <MenuItem value="open">{t("Open")}</MenuItem>
// //                 <MenuItem value="in_progress">{t("In Progress")}</MenuItem>
// //                 <MenuItem value="closed">{t("Closed")}</MenuItem>
// //               </Select>
// //             </FormControl>
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Staff")}</InputLabel>
// //               <Select value={editData.assigned_technician} label={t("Staff")} onChange={(e) => setEditData({ ...editData, assigned_technician: e.target.value })}>
// //                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
// //                 {staffList.map(user => (
// //                   <MenuItem key={user.id} value={user.id}>{user.first_name} {user.last_name} ({user.user_role})</MenuItem>
// //                 ))}
// //               </Select>
// //             </FormControl>
// //           </Stack>
// //         </DialogContent>
// //         <DialogActions sx={{ p: 2 }}>
// //           <Button onClick={() => setOpenEdit(false)}>{t("Cancel")}</Button>
// //           <Button variant="contained" onClick={handleSaveEdit}>{t("Save Changes")}</Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Box>
// //   );
// // };

// // export default IssuesScreen;


// ///////////////////////////
// // import React, { useState, useEffect, useMemo } from "react";
// // import {
// //   TableContainer, Table, TableHead, TableRow, TableCell,
// //   TableBody, Paper, Card, CardContent, Box, Typography,
// //   Button, TextField, FormControl, InputLabel, Select, MenuItem,
// //   CircularProgress, Alert, Chip, Stack, IconButton, Tooltip,
// //   Dialog, DialogTitle, DialogContent, DialogActions
// // } from "@mui/material";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import EditIcon from "@mui/icons-material/Edit";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";

// // const pickIssuesFromResponse = (data) => {
// //   if (!data) return [];
// //   if (Array.isArray(data)) return data;
// //   if (data.results && Array.isArray(data.results)) return data.results;
// //   return [];
// // };

// // const IssuesScreen = () => {
// //   const { t } = useTranslation();
// //   const [allIssues, setAllIssues] = useState([]);
// //   const [staffList, setStaffList] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [search, setSearch] = useState("");

// //   // Edit Modal State
// //   const [openEdit, setOpenEdit] = useState(false);
// //   const [selectedIssueId, setSelectedIssueId] = useState(null);
// //   const [editData, setEditData] = useState({
// //     title: "",
// //     room_number: "",
// //     status: "open",
// //     assigned_technician: "",
// //     closed_at: "" // Added for manual End Time editing
// //   });

// //   const fetchData = async () => {
// //     setLoading(true);
// //     try {
// //       const [issueRes, staffRes] = await Promise.all([
// //         axiosClient.get("api/issues/"),
// //         axiosClient.get("auth/users/")
// //       ]);
// //       setAllIssues(pickIssuesFromResponse(issueRes.data));
// //       const allUsers = Array.isArray(staffRes.data) ? staffRes.data : (staffRes.data.results || []);
// //       setStaffList(allUsers.filter(u => u.user_role === "TECHNICIAN" || u.user_role === "MAID"));
// //     } catch (err) {
// //       setError(t("Failed to load data."));
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => { fetchData(); }, [t]);

// //   const handleDelete = async (id) => {
// //     if (!id) return;
// //     if (window.confirm(t("Are you sure?"))) {
// //       try {
// //         await axiosClient.delete(`api/issues/${id}/`);
// //         setAllIssues(prev => prev.filter(issue => issue.id !== id));
// //       } catch (err) { alert(t("Delete failed.")); }
// //     }
// //   };

// //   const handleOpenEdit = (issue) => {
// //     setSelectedIssueId(issue.id);
// //     setEditData({
// //       title: issue.title || "",
// //       room_number: issue.room_number || "",
// //       status: issue.status || "open",
// //       assigned_technician: issue.assigned_technician || "",
// //       // Format backend ISO date to 'YYYY-MM-DDTHH:mm' for the datetime-local input
// //       closed_at: issue.closed_at ? new Date(issue.closed_at).toISOString().slice(0, 16) : ""
// //     });
// //     setOpenEdit(true);
// //   };

// //   const handleSaveEdit = async () => {
// //     try {
// //       // Send null if the string is empty so the backend doesn't error
// //       const payload = { 
// //         ...editData, 
// //         closed_at: editData.closed_at === "" ? null : editData.closed_at 
// //       };
// //       await axiosClient.put(`api/issues/${selectedIssueId}/`, payload);
// //       fetchData(); // Refresh table to show updated times and staff
// //       setOpenEdit(false);
// //       alert(t("Updated successfully!"));
// //     } catch (err) { alert(t("Update failed. Check your data.")); }
// //   };

// //   const formatDateTime = (dateString) => {
// //     if (!dateString || dateString === "-") return "-";
// //     const date = new Date(dateString);
// //     return isNaN(date.getTime()) ? dateString : date.toLocaleString();
// //   };

// //   const filteredIssues = useMemo(() => {
// //     return allIssues.filter((issue) => {
// //       const searchStr = search.toLowerCase();
// //       return (issue.title?.toLowerCase().includes(searchStr) || 
// //              String(issue.room_number || "").toLowerCase().includes(searchStr) ||
// //              issue.staff_name?.toLowerCase().includes(searchStr));
// //     });
// //   }, [allIssues, search]);

// //   return (
// //     <Box sx={{ p: 3 }}>
// //       <Card elevation={6} sx={{ borderRadius: 2 }}>
// //         <CardContent>
// //           <Typography variant="h5" fontWeight="bold" mb={3}>{t("Issue Management List")}</Typography>
// //           <Box display="flex" gap={2} mb={3}>
// //              <TextField label={t("Search")} size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ flex: 1 }} />
// //              <Button variant="contained" onClick={fetchData}>{t("Refresh")}</Button>
// //           </Box>
// //           <TableContainer component={Paper} sx={{ maxHeight: 700 }}>
// //             <Table stickyHeader>
// //               <TableHead>
// //                 <TableRow>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>ID</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Room")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Title")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Start Date/Time")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("End Date/Time")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Status")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("STAFF")}</TableCell>
// //                   <TableCell align="center" sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("ACTIONS")}</TableCell>
// //                 </TableRow>
// //               </TableHead>
// //               <TableBody>
// //                 {filteredIssues.map((issue) => (
// //                   <TableRow key={issue.id} hover>
// //                     <TableCell>#{issue.id}</TableCell>
// //                     <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>{issue.room_number || "-"}</TableCell>
// //                     <TableCell>{issue.title}</TableCell>

// //                     {/* Start Time: Shows Calendar start, fallbacks to creation date */}
// //                     <TableCell>
// //                       {issue.appt_start ? formatDateTime(issue.appt_start) : formatDateTime(issue.created_at)}
// //                     </TableCell>

// //                     {/* End Time: Shows manual 'closed_at', fallbacks to Calendar end */}
// //                     <TableCell>
// //                       {issue.closed_at 
// //                         ? formatDateTime(issue.closed_at) 
// //                         : (issue.appt_end ? formatDateTime(issue.appt_end) : "-")}
// //                     </TableCell>

// //                     <TableCell>
// //                         <Chip 
// //                           label={t(issue.status || "open")} 
// //                           size="small" 
// //                           variant="outlined" 
// //                           color={issue.status === 'open' ? 'error' : (issue.status === 'closed' || issue.status === 'resolved' ? 'success' : 'warning')} 
// //                         />
// //                     </TableCell>
// //                     <TableCell sx={{ fontWeight: 'bold' }}>{issue.staff_name || t("Unassigned")}</TableCell>
// //                     <TableCell align="center">
// //                       <Stack direction="row" spacing={1} justifyContent="center">
// //                         <IconButton color="primary" onClick={() => handleOpenEdit(issue)}><EditIcon fontSize="small" /></IconButton>
// //                         <IconButton color="error" onClick={() => handleDelete(issue.id)}><DeleteIcon fontSize="small" /></IconButton>
// //                       </Stack>
// //                     </TableCell>
// //                   </TableRow>
// //                 ))}
// //               </TableBody>
// //             </Table>
// //           </TableContainer>
// //         </CardContent>
// //       </Card>

// //       {/* --- EDIT MODAL --- */}
// //       <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="sm">
// //         <DialogTitle sx={{ fontWeight: "bold" }}>{t("Edit Issue")} #{selectedIssueId}</DialogTitle>
// //         <DialogContent dividers>
// //           <Stack spacing={3} mt={1}>
// //             <TextField fullWidth label={t("Title")} value={editData.title} onChange={(e) => setEditData({ ...editData, title: e.target.value })} />
// //             <TextField fullWidth label={t("Room")} value={editData.room_number} onChange={(e) => setEditData({ ...editData, room_number: e.target.value })} />
            
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Status")}</InputLabel>
// //               <Select value={editData.status} label={t("Status")} onChange={(e) => setEditData({ ...editData, status: e.target.value })}>
// //                 <MenuItem value="open">{t("Open")}</MenuItem>
// //                 <MenuItem value="in_progress">{t("In Progress")}</MenuItem>
// //                 <MenuItem value="resolved">{t("Resolved")}</MenuItem>
// //                 <MenuItem value="closed">{t("Closed")}</MenuItem>
// //               </Select>
// //             </FormControl>

// //             <FormControl fullWidth>
// //               <InputLabel>{t("Staff")}</InputLabel>
// //               <Select value={editData.assigned_technician} label={t("Staff")} onChange={(e) => setEditData({ ...editData, assigned_technician: e.target.value })}>
// //                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
// //                 {staffList.map(user => (
// //                   <MenuItem key={user.id} value={user.id}>
// //                     {user.first_name} {user.last_name} ({user.user_role})
// //                   </MenuItem>
// //                 ))}
// //               </Select>
// //             </FormControl>

// //             {/* MANUAL END TIME FIELD */}
// //             <TextField
// //               fullWidth
// //               label={t("End Date/Time (Manual)")}
// //               type="datetime-local"
// //               value={editData.closed_at}
// //               onChange={(e) => setEditData({ ...editData, closed_at: e.target.value })}
// //               InputLabelProps={{ shrink: true }}
// //             />
// //           </Stack>
// //         </DialogContent>
// //         <DialogActions sx={{ p: 2 }}>
// //           <Button onClick={() => setOpenEdit(false)}>{t("Cancel")}</Button>
// //           <Button variant="contained" onClick={handleSaveEdit}>{t("Save Changes")}</Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Box>
// //   );
// // };

// // export default IssuesScreen;

// ///////////////////////////////////////////////////////////////////


// // import React, { useState, useEffect, useMemo } from "react";
// // import {
// //   TableContainer, Table, TableHead, TableRow, TableCell,
// //   TableBody, Paper, Card, CardContent, Box, Typography,
// //   Button, TextField, FormControl, InputLabel, Select, MenuItem,
// //   CircularProgress, Alert, Chip, Stack, IconButton, Tooltip,
// //   Dialog, DialogTitle, DialogContent, DialogActions
// // } from "@mui/material";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import EditIcon from "@mui/icons-material/Edit";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";

// // const pickIssuesFromResponse = (data) => {
// //   if (!data) return [];
// //   if (Array.isArray(data)) return data;
// //   if (data.results && Array.isArray(data.results)) return data.results;
// //   return [];
// // };

// // const IssuesScreen = () => {
// //   const { t } = useTranslation();
// //   const [allIssues, setAllIssues] = useState([]);
// //   const [staffList, setStaffList] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [search, setSearch] = useState("");

// //   const [openEdit, setOpenEdit] = useState(false);
// //   const [selectedIssueId, setSelectedIssueId] = useState(null);
// //   const [editData, setEditData] = useState({
// //     title: "",
// //     room_number: "",
// //     status: "open",
// //     assigned_technician: "",
// //     closed_at: "" 
// //   });

// //   const fetchData = async () => {
// //     setLoading(true);
// //     try {
// //       const [issueRes, staffRes] = await Promise.all([
// //         axiosClient.get("api/issues/"),
// //         axiosClient.get("auth/users/")
// //       ]);
// //       setAllIssues(pickIssuesFromResponse(issueRes.data));
// //       const allUsers = Array.isArray(staffRes.data) ? staffRes.data : (staffRes.data.results || []);
// //       setStaffList(allUsers.filter(u => u.user_role === "TECHNICIAN" || u.user_role === "MAID"));
// //     } catch (err) {
// //       setError(t("Failed to load data."));
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => { fetchData(); }, [t]);

// //   const handleDelete = async (id) => {
// //     if (!id) return;
// //     if (window.confirm(t("Are you sure?"))) {
// //       try {
// //         await axiosClient.delete(`api/issues/${id}/`);
// //         setAllIssues(prev => prev.filter(issue => issue.id !== id));
// //       } catch (err) { alert(t("Delete failed.")); }
// //     }
// //   };

// //   const handleOpenEdit = (issue) => {
// //     setSelectedIssueId(issue.id);
// //     setEditData({
// //       title: issue.title || "",
// //       room_number: issue.room_number || "",
// //       status: issue.status || "open",
// //       assigned_technician: issue.assigned_technician || "",
// //       closed_at: issue.closed_at ? new Date(issue.closed_at).toISOString().slice(0, 16) : ""
// //     });
// //     setOpenEdit(true);
// //   };

// //   const handleSaveEdit = async () => {
// //     try {
// //       const payload = { 
// //         ...editData, 
// //         closed_at: editData.closed_at === "" ? null : editData.closed_at 
// //       };
// //       await axiosClient.put(`api/issues/${selectedIssueId}/`, payload);
// //       fetchData();
// //       setOpenEdit(false);
// //       alert(t("Updated successfully!"));
// //     } catch (err) { alert(t("Update failed. Check your data.")); }
// //   };

// //   // 🛠️ UPDATED: Format Function for DD/MM/YY
// //   const formatDateTime = (dateString) => {
// //     if (!dateString || dateString === "-" || dateString === "None") return "-";
// //     const date = new Date(dateString);
// //     if (isNaN(date.getTime())) return dateString;

// //     const day = String(date.getDate()).padStart(2, '0');
// //     const month = String(date.getMonth() + 1).padStart(2, '0');
// //     const year = String(date.getFullYear()).slice(-2); // last 2 digits

// //     return `${day}/${month}/${year}`;
// //   };

// //   const filteredIssues = useMemo(() => {
// //     return allIssues.filter((issue) => {
// //       const searchStr = search.toLowerCase();
// //       return (issue.title?.toLowerCase().includes(searchStr) || 
// //               String(issue.room_number || "").toLowerCase().includes(searchStr) ||
// //               issue.staff_name?.toLowerCase().includes(searchStr));
// //     });
// //   }, [allIssues, search]);

// //   if (loading && allIssues.length === 0) return <Box display="flex" justifyContent="center" mt={10}><CircularProgress /></Box>;

// //   return (
// //     <Box sx={{ p: 3 }}>
// //       <Card elevation={6} sx={{ borderRadius: 2 }}>
// //         <CardContent>
// //           <Typography variant="h5" fontWeight="bold" mb={3}>{t("Issue Management List")}</Typography>
// //           <Box display="flex" gap={2} mb={3}>
// //              <TextField label={t("Search")} size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ flex: 1 }} />
// //              <Button variant="contained" onClick={fetchData}>{t("Refresh")}</Button>
// //           </Box>
// //           <TableContainer component={Paper} sx={{ maxHeight: 700 }}>
// //             <Table stickyHeader>
// //               <TableHead>
// //                 <TableRow>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>ID</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Room")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Title")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Start Date/Time")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("End Date/Time")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Status")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("STAFF")}</TableCell>
// //                   <TableCell align="center" sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("ACTIONS")}</TableCell>
// //                 </TableRow>
// //               </TableHead>
// //               <TableBody>
// //                 {filteredIssues.map((issue) => (
// //                   <TableRow key={issue.id} hover>
// //                     <TableCell>#{issue.id}</TableCell>
// //                     <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>{issue.room_number || "-"}</TableCell>
// //                     <TableCell>{issue.title}</TableCell>

// //                     {/* Start Time formatted to DD/MM/YY */}
// //                     <TableCell>
// //                       {issue.appt_start ? formatDateTime(issue.appt_start) : formatDateTime(issue.created_at)}
// //                     </TableCell>

// //                     {/* End Time formatted to DD/MM/YY */}
// //                     <TableCell>
// //                       {issue.closed_at 
// //                         ? formatDateTime(issue.closed_at) 
// //                         : (issue.appt_end ? formatDateTime(issue.appt_end) : "-")}
// //                     </TableCell>

// //                     <TableCell>
// //                         <Chip 
// //                           label={t(issue.status || "open")} 
// //                           size="small" 
// //                           variant="outlined" 
// //                           color={issue.status === 'open' ? 'error' : (issue.status === 'closed' || issue.status === 'resolved' ? 'success' : 'warning')} 
// //                         />
// //                     </TableCell>
// //                     <TableCell sx={{ fontWeight: 'bold' }}>{issue.staff_name || t("Unassigned")}</TableCell>
// //                     <TableCell align="center">
// //                       <Stack direction="row" spacing={1} justifyContent="center">
// //                         <IconButton color="primary" onClick={() => handleOpenEdit(issue)}><EditIcon fontSize="small" /></IconButton>
// //                         <IconButton color="error" onClick={() => handleDelete(issue.id)}><DeleteIcon fontSize="small" /></IconButton>
// //                       </Stack>
// //                     </TableCell>
// //                   </TableRow>
// //                 ))}
// //               </TableBody>
// //             </Table>
// //           </TableContainer>
// //         </CardContent>
// //       </Card>

// //       <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="sm">
// //         <DialogTitle sx={{ fontWeight: "bold" }}>{t("Edit Issue")} #{selectedIssueId}</DialogTitle>
// //         <DialogContent dividers>
// //           <Stack spacing={3} mt={1}>
// //             <TextField fullWidth label={t("Title")} value={editData.title} onChange={(e) => setEditData({ ...editData, title: e.target.value })} />
// //             <TextField fullWidth label={t("Room")} value={editData.room_number} onChange={(e) => setEditData({ ...editData, room_number: e.target.value })} />
            
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Status")}</InputLabel>
// //               <Select value={editData.status} label={t("Status")} onChange={(e) => setEditData({ ...editData, status: e.target.value })}>
// //                 <MenuItem value="open">{t("Open")}</MenuItem>
// //                 <MenuItem value="in_progress">{t("In Progress")}</MenuItem>
// //                 <MenuItem value="resolved">{t("Resolved")}</MenuItem>
// //                 <MenuItem value="closed">{t("Closed")}</MenuItem>
// //               </Select>
// //             </FormControl>

// //             <FormControl fullWidth>
// //               <InputLabel>{t("Staff")}</InputLabel>
// //               <Select value={editData.assigned_technician} label={t("Staff")} onChange={(e) => setEditData({ ...editData, assigned_technician: e.target.value })}>
// //                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
// //                 {staffList.map(user => (
// //                   <MenuItem key={user.id} value={user.id}>
// //                     {user.first_name} {user.last_name} ({user.user_role})
// //                   </MenuItem>
// //                 ))}
// //               </Select>
// //             </FormControl>

// //             <TextField
// //               fullWidth
// //               label={t("End Date/Time (Manual)")}
// //               type="datetime-local"
// //               value={editData.closed_at}
// //               onChange={(e) => setEditData({ ...editData, closed_at: e.target.value })}
// //               InputLabelProps={{ shrink: true }}
// //             />
// //           </Stack>
// //         </DialogContent>
// //         <DialogActions sx={{ p: 2 }}>
// //           <Button onClick={() => setOpenEdit(false)}>{t("Cancel")}</Button>
// //           <Button variant="contained" onClick={handleSaveEdit}>{t("Save Changes")}</Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Box>
// //   );
// // };

// // export default IssuesScreen;


// ///////////////////////////////////////

// // import React, { useState, useEffect, useMemo } from "react";
// // import {
// //   TableContainer, Table, TableHead, TableRow, TableCell,
// //   TableBody, Paper, Card, CardContent, Box, Typography,
// //   Button, TextField, FormControl, InputLabel, Select, MenuItem,
// //   CircularProgress, Alert, Chip, Stack, IconButton, Tooltip,
// //   Dialog, DialogTitle, DialogContent, DialogActions
// // } from "@mui/material";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import EditIcon from "@mui/icons-material/Edit";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";

// // const pickIssuesFromResponse = (data) => {
// //   if (!data) return [];
// //   if (Array.isArray(data)) return data;
// //   if (data.results && Array.isArray(data.results)) return data.results;
// //   return [];
// // };

// // const IssuesScreen = () => {
// //   const { t } = useTranslation();
// //   const [allIssues, setAllIssues] = useState([]);
// //   const [staffList, setStaffList] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [search, setSearch] = useState("");

// //   const [openEdit, setOpenEdit] = useState(false);
// //   const [selectedIssueId, setSelectedIssueId] = useState(null);
// //   const [editData, setEditData] = useState({
// //     title: "",
// //     room_number: "",
// //     status: "open",
// //     assigned_technician: "",
// //     scheduled_end: "" // 🛠️ Changed from closed_at to scheduled_end
// //   });

// //   const fetchData = async () => {
// //     setLoading(true);
// //     try {
// //       const [issueRes, staffRes] = await Promise.all([
// //         axiosClient.get("api/issues/"),
// //         axiosClient.get("auth/users/")
// //       ]);
// //       setAllIssues(pickIssuesFromResponse(issueRes.data));
// //       const allUsers = Array.isArray(staffRes.data) ? staffRes.data : (staffRes.data.results || []);
// //       setStaffList(allUsers.filter(u => u.user_role === "TECHNICIAN" || u.user_role === "MAID"));
// //     } catch (err) {
// //       setError(t("Failed to load data."));
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => { fetchData(); }, [t]);

// //   const handleDelete = async (id) => {
// //     if (!id) return;
// //     if (window.confirm(t("Are you sure?"))) {
// //       try {
// //         await axiosClient.delete(`api/issues/${id}/`);
// //         setAllIssues(prev => prev.filter(issue => issue.id !== id));
// //       } catch (err) { alert(t("Delete failed.")); }
// //     }
// //   };

// //   const handleOpenEdit = (issue) => {
// //     setSelectedIssueId(issue.id);
// //     setEditData({
// //       title: issue.title || "",
// //       room_number: issue.room_number || "",
// //       status: issue.status || "open",
// //       assigned_technician: issue.assigned_technician || "",
// //       // 🛠️ Load the manual end date if it exists
// //       scheduled_end: issue.scheduled_end ? new Date(issue.scheduled_end).toISOString().slice(0, 16) : ""
// //     });
// //     setOpenEdit(true);
// //   };

// //   const handleSaveEdit = async () => {
// //     try {
// //       let finalData = { ...editData };
      
// //       // 🛠️ LOGIC: If user closes the issue but didn't pick an end date, 
// //       // default it to "Now" so the calendar bar stops stretching.
// //       if ((editData.status === "closed" || editData.status === "resolved") && !editData.scheduled_end) {
// //         finalData.scheduled_end = new Date().toISOString().slice(0, 16);
// //       }

// //       const payload = { 
// //         ...finalData, 
// //         scheduled_end: finalData.scheduled_end === "" ? null : finalData.scheduled_end 
// //       };

// //       await axiosClient.put(`api/issues/${selectedIssueId}/`, payload);
// //       fetchData();
// //       setOpenEdit(false);
// //       alert(t("Updated successfully!"));
// //     } catch (err) { alert(t("Update failed. Check your data.")); }
// //   };

// //   const formatDateTime = (dateString) => {
// //     if (!dateString || dateString === "-" || dateString === "None") return "-";
// //     const date = new Date(dateString);
// //     if (isNaN(date.getTime())) return dateString;

// //     const day = String(date.getDate()).padStart(2, '0');
// //     const month = String(date.getMonth() + 1).padStart(2, '0');
// //     const year = String(date.getFullYear()).slice(-2);

// //     return `${day}/${month}/${year}`;
// //   };

// //   const filteredIssues = useMemo(() => {
// //     return allIssues.filter((issue) => {
// //       const searchStr = search.toLowerCase();
// //       return (issue.title?.toLowerCase().includes(searchStr) || 
// //               String(issue.room_number || "").toLowerCase().includes(searchStr) ||
// //               issue.staff_name?.toLowerCase().includes(searchStr));
// //     });
// //   }, [allIssues, search]);

// //   if (loading && allIssues.length === 0) return <Box display="flex" justifyContent="center" mt={10}><CircularProgress /></Box>;

// //   return (
// //     <Box sx={{ p: 3 }}>
// //       <Card elevation={6} sx={{ borderRadius: 2 }}>
// //         <CardContent>
// //           <Typography variant="h5" fontWeight="bold" mb={3}>{t("Issue Management List")}</Typography>
// //           <Box display="flex" gap={2} mb={3}>
// //              <TextField label={t("Search")} size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ flex: 1 }} />
// //              <Button variant="contained" onClick={fetchData}>{t("Refresh")}</Button>
// //           </Box>
// //           <TableContainer component={Paper} sx={{ maxHeight: 700 }}>
// //             <Table stickyHeader>
// //               <TableHead>
// //                 <TableRow>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>ID</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Room")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Title")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Start Date/Time")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("End Date/Time")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Status")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("STAFF")}</TableCell>
// //                   <TableCell align="center" sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("ACTIONS")}</TableCell>
// //                 </TableRow>
// //               </TableHead>
// //               <TableBody>
// //                 {filteredIssues.map((issue) => (
// //                   <TableRow key={issue.id} hover>
// //                     <TableCell>#{issue.id}</TableCell>
// //                     <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>{issue.room_number || "-"}</TableCell>
// //                     <TableCell>{issue.title}</TableCell>
// //                     <TableCell>
// //                       {issue.appt_start ? formatDateTime(issue.appt_start) : formatDateTime(issue.created_at)}
// //                     </TableCell>
// //                     <TableCell>
// //                       {/* 🛠️ Shows the Manual End Date */}
// //                       {issue.scheduled_end ? formatDateTime(issue.scheduled_end) : "-"}
// //                     </TableCell>
// //                     <TableCell>
// //                         <Chip 
// //                           label={t(issue.status || "open")} 
// //                           size="small" 
// //                           variant="outlined" 
// //                           color={issue.status === 'open' ? 'error' : (issue.status === 'closed' || issue.status === 'resolved' ? 'success' : 'warning')} 
// //                         />
// //                     </TableCell>
// //                     <TableCell sx={{ fontWeight: 'bold' }}>{issue.staff_name || t("Unassigned")}</TableCell>
// //                     <TableCell align="center">
// //                       <Stack direction="row" spacing={1} justifyContent="center">
// //                         <IconButton color="primary" onClick={() => handleOpenEdit(issue)}><EditIcon fontSize="small" /></IconButton>
// //                         <IconButton color="error" onClick={() => handleDelete(issue.id)}><DeleteIcon fontSize="small" /></IconButton>
// //                       </Stack>
// //                     </TableCell>
// //                   </TableRow>
// //                 ))}
// //               </TableBody>
// //             </Table>
// //           </TableContainer>
// //         </CardContent>
// //       </Card>

// //       <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="sm">
// //         <DialogTitle sx={{ fontWeight: "bold" }}>{t("Edit Issue")} #{selectedIssueId}</DialogTitle>
// //         <DialogContent dividers>
// //           <Stack spacing={3} mt={1}>
// //             <TextField fullWidth label={t("Title")} value={editData.title} onChange={(e) => setEditData({ ...editData, title: e.target.value })} />
// //             <TextField fullWidth label={t("Room")} value={editData.room_number} onChange={(e) => setEditData({ ...editData, room_number: e.target.value })} />
            
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Status")}</InputLabel>
// //               <Select value={editData.status} label={t("Status")} onChange={(e) => setEditData({ ...editData, status: e.target.value })}>
// //                 <MenuItem value="open">{t("Open")}</MenuItem>
// //                 <MenuItem value="in_progress">{t("In Progress")}</MenuItem>
// //                 <MenuItem value="resolved">{t("Resolved")}</MenuItem>
// //                 <MenuItem value="closed">{t("Closed")}</MenuItem>
// //               </Select>
// //             </FormControl>

// //             <FormControl fullWidth>
// //               <InputLabel>{t("Staff")}</InputLabel>
// //               <Select value={editData.assigned_technician} label={t("Staff")} onChange={(e) => setEditData({ ...editData, assigned_technician: e.target.value })}>
// //                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
// //                 {staffList.map(user => (
// //                   <MenuItem key={user.id} value={user.id}>
// //                     {user.first_name} {user.last_name} ({user.user_role})
// //                   </MenuItem>
// //                 ))}
// //               </Select>
// //             </FormControl>

// //             <TextField
// //               fullWidth
// //               label={t("End Date/Time (Manual)")}
// //               type="datetime-local"
// //               // 🛠️ Linked to scheduled_end
// //               value={editData.scheduled_end}
// //               onChange={(e) => setEditData({ ...editData, scheduled_end: e.target.value })}
// //               InputLabelProps={{ shrink: true }}
// //             />
// //           </Stack>
// //         </DialogContent>
// //         <DialogActions sx={{ p: 2 }}>
// //           <Button onClick={() => setOpenEdit(false)}>{t("Cancel")}</Button>
// //           <Button variant="contained" onClick={handleSaveEdit}>{t("Save Changes")}</Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Box>
// //   );
// // };

// // export default IssuesScreen;

// ///////////////////////////////////////////////////////////////////

// // import React, { useState, useEffect, useMemo } from "react";
// // import {
// //   TableContainer, Table, TableHead, TableRow, TableCell,
// //   TableBody, Paper, Card, CardContent, Box, Typography,
// //   Button, TextField, FormControl, InputLabel, Select, MenuItem,
// //   CircularProgress, Alert, Chip, Stack, IconButton, Tooltip,
// //   Dialog, DialogTitle, DialogContent, DialogActions
// // } from "@mui/material";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import EditIcon from "@mui/icons-material/Edit";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";

// // const pickIssuesFromResponse = (data) => {
// //   if (!data) return [];
// //   if (Array.isArray(data)) return data;
// //   if (data.results && Array.isArray(data.results)) return data.results;
// //   return [];
// // };

// // const IssuesScreen = () => {
// //   const { t } = useTranslation();
// //   const [allIssues, setAllIssues] = useState([]);
// //   const [staffList, setStaffList] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [search, setSearch] = useState("");

// //   const [openEdit, setOpenEdit] = useState(false);
// //   const [selectedIssueId, setSelectedIssueId] = useState(null);
// //   const [editData, setEditData] = useState({
// //     title: "",
// //     room_number: "",
// //     status: "open",
// //     assigned_technician: "",
// //     scheduled_end: "" 
// //   });

// //   const fetchData = async () => {
// //     setLoading(true);
// //     try {
// //       const [issueRes, staffRes] = await Promise.all([
// //         axiosClient.get("api/issues/"),
// //         axiosClient.get("auth/users/")
// //       ]);
// //       setAllIssues(pickIssuesFromResponse(issueRes.data));
// //       const allUsers = Array.isArray(staffRes.data) ? staffRes.data : (staffRes.data.results || []);
// //       setStaffList(allUsers.filter(u => u.user_role === "TECHNICIAN" || u.user_role === "MAID"));
// //     } catch (err) {
// //       console.error("Failed to load data.");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => { fetchData(); }, [t]);

// //   const handleDelete = async (id) => {
// //     if (!id) return;
// //     if (window.confirm(t("Are you sure?"))) {
// //       try {
// //         await axiosClient.delete(`api/issues/${id}/`);
// //         setAllIssues(prev => prev.filter(issue => issue.id !== id));
// //       } catch (err) { alert(t("Delete failed.")); }
// //     }
// //   };

// //   const handleOpenEdit = (issue) => {
// //     setSelectedIssueId(issue.id);
// //     setEditData({
// //       title: issue.title || "",
// //       room_number: issue.room_number || "",
// //       status: issue.status || "open",
// //       assigned_technician: issue.assigned_technician || "", 
// //       scheduled_end: issue.scheduled_end ? new Date(issue.scheduled_end).toISOString().slice(0, 16) : ""
// //     });
// //     setOpenEdit(true);
// //   };

// //   const handleSaveEdit = async () => {
// //     try {
// //       let finalData = { ...editData };
      
// //       // 🛠️ LOGIC: Auto-set end date to 'Now' if closing but date is empty
// //       if ((editData.status === "closed" || editData.status === "resolved") && !editData.scheduled_end) {
// //         finalData.scheduled_end = new Date().toISOString().slice(0, 16);
// //       }

// //       const payload = { 
// //         title: finalData.title,
// //         room_number: finalData.room_number,
// //         status: finalData.status,
// //         // 🛠️ CRITICAL: Ensure ID is sent so staff_name updates
// //         assigned_technician: finalData.assigned_technician || null,
// //         scheduled_end: finalData.scheduled_end === "" ? null : finalData.scheduled_end 
// //       };

// //       await axiosClient.put(`api/issues/${selectedIssueId}/`, payload);
// //       fetchData(); // Refresh to show the new name in the table
// //       setOpenEdit(false);
// //       alert(t("Updated successfully!"));
// //     } catch (err) { alert(t("Update failed. Check your data.")); }
// //   };

// //   const formatDateTime = (dateString) => {
// //     if (!dateString || dateString === "-" || dateString === "None") return "-";
// //     const date = new Date(dateString);
// //     if (isNaN(date.getTime())) return dateString;
// //     const day = String(date.getDate()).padStart(2, '0');
// //     const month = String(date.getMonth() + 1).padStart(2, '0');
// //     const year = String(date.getFullYear()).slice(-2);
// //     return `${day}/${month}/${year}`;
// //   };

// //   const filteredIssues = useMemo(() => {
// //     return allIssues.filter((issue) => {
// //       const searchStr = search.toLowerCase();
// //       return (issue.title?.toLowerCase().includes(searchStr) || 
// //               String(issue.room_number || "").toLowerCase().includes(searchStr) ||
// //               issue.staff_name?.toLowerCase().includes(searchStr));
// //     });
// //   }, [allIssues, search]);

// //   if (loading && allIssues.length === 0) return <Box display="flex" justifyContent="center" mt={10}><CircularProgress /></Box>;

// //   return (
// //     <Box sx={{ p: 3 }}>
// //       <Card elevation={6} sx={{ borderRadius: 2 }}>
// //         <CardContent>
// //           <Typography variant="h5" fontWeight="bold" mb={3}>{t("Issue Management List")}</Typography>
// //           <Box display="flex" gap={2} mb={3}>
// //              <TextField label={t("Search")} size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ flex: 1 }} />
// //              <Button variant="contained" onClick={fetchData}>{t("Refresh")}</Button>
// //           </Box>
// //           <TableContainer component={Paper} sx={{ maxHeight: 700 }}>
// //             <Table stickyHeader>
// //               <TableHead>
// //                 <TableRow>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>ID</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Room")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Title")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Start Date/Time")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("End Date/Time")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Status")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("STAFF")}</TableCell>
// //                   <TableCell align="center" sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("ACTIONS")}</TableCell>
// //                 </TableRow>
// //               </TableHead>
// //               <TableBody>
// //                 {filteredIssues.map((issue) => (
// //                   <TableRow key={issue.id} hover>
// //                     <TableCell>#{issue.id}</TableCell>
// //                     <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>{issue.room_number || "-"}</TableCell>
// //                     <TableCell>{issue.title}</TableCell>
// //                     <TableCell>{formatDateTime(issue.appt_start)}</TableCell>
// //                     <TableCell>{formatDateTime(issue.scheduled_end)}</TableCell>
// //                     <TableCell>
// //                         <Chip 
// //                           label={t(issue.status || "open")} 
// //                           size="small" 
// //                           variant="outlined" 
// //                           color={issue.status === 'open' ? 'error' : (issue.status === 'closed' || issue.status === 'resolved' ? 'success' : 'warning')} 
// //                         />
// //                     </TableCell>
// //                     <TableCell sx={{ fontWeight: 'bold' }}>
// //                         {/* 🛠️ Shows Name from Serializer */}
// //                         {issue.staff_name || t("Unassigned")}
// //                     </TableCell>
// //                     <TableCell align="center">
// //                       <Stack direction="row" spacing={1} justifyContent="center">
// //                         <IconButton color="primary" onClick={() => handleOpenEdit(issue)}><EditIcon fontSize="small" /></IconButton>
// //                         <IconButton color="error" onClick={() => handleDelete(issue.id)}><DeleteIcon fontSize="small" /></IconButton>
// //                       </Stack>
// //                     </TableCell>
// //                   </TableRow>
// //                 ))}
// //               </TableBody>
// //             </Table>
// //           </TableContainer>
// //         </CardContent>
// //       </Card>

// //       <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="sm">
// //         <DialogTitle sx={{ fontWeight: "bold" }}>{t("Edit Issue")} #{selectedIssueId}</DialogTitle>
// //         <DialogContent dividers>
// //           <Stack spacing={3} mt={1}>
// //             <TextField fullWidth label={t("Title")} value={editData.title} onChange={(e) => setEditData({ ...editData, title: e.target.value })} />
// //             <TextField fullWidth label={t("Room")} value={editData.room_number} onChange={(e) => setEditData({ ...editData, room_number: e.target.value })} />
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Status")}</InputLabel>
// //               <Select value={editData.status} label={t("Status")} onChange={(e) => setEditData({ ...editData, status: e.target.value })}>
// //                 <MenuItem value="open">{t("Open")}</MenuItem>
// //                 <MenuItem value="in_progress">{t("In Progress")}</MenuItem>
// //                 <MenuItem value="resolved">{t("Resolved")}</MenuItem>
// //                 <MenuItem value="closed">{t("Closed")}</MenuItem>
// //               </Select>
// //             </FormControl>
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Staff")}</InputLabel>
// //               <Select value={editData.assigned_technician} label={t("Staff")} onChange={(e) => setEditData({ ...editData, assigned_technician: e.target.value })}>
// //                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
// //                 {staffList.map(user => (
// //                   <MenuItem key={user.id} value={user.id}>
// //                     {user.first_name} {user.last_name} ({user.user_role})
// //                   </MenuItem>
// //                 ))}
// //               </Select>
// //             </FormControl>
// //             <TextField
// //               fullWidth
// //               label={t("End Date/Time (Manual)")}
// //               type="datetime-local"
// //               value={editData.scheduled_end}
// //               onChange={(e) => setEditData({ ...editData, scheduled_end: e.target.value })}
// //               InputLabelProps={{ shrink: true }}
// //             />
// //           </Stack>
// //         </DialogContent>
// //         <DialogActions sx={{ p: 2 }}>
// //           <Button onClick={() => setOpenEdit(false)}>{t("Cancel")}</Button>
// //           <Button variant="contained" onClick={handleSaveEdit}>{t("Save Changes")}</Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Box>
// //   );
// // };

// // export default IssuesScreen;


// /////////////////////////////

// // import React, { useState, useEffect, useMemo } from "react";
// // import {
// //   TableContainer, Table, TableHead, TableRow, TableCell,
// //   TableBody, Paper, Card, CardContent, Box, Typography,
// //   Button, TextField, FormControl, InputLabel, Select, MenuItem,
// //   CircularProgress, Alert, Chip, Stack, IconButton, Tooltip,
// //   Dialog, DialogTitle, DialogContent, DialogActions
// // } from "@mui/material";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import EditIcon from "@mui/icons-material/Edit";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";

// // const pickIssuesFromResponse = (data) => {
// //   if (!data) return [];
// //   if (Array.isArray(data)) return data;
// //   if (data.results && Array.isArray(data.results)) return data.results;
// //   return [];
// // };

// // const IssuesScreen = () => {
// //   const { t } = useTranslation();
// //   const [allIssues, setAllIssues] = useState([]);
// //   const [staffList, setStaffList] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [search, setSearch] = useState("");

// //   const [openEdit, setOpenEdit] = useState(false);
// //   const [selectedIssueId, setSelectedIssueId] = useState(null);
// //   const [editData, setEditData] = useState({
// //     title: "",
// //     room_number: "",
// //     status: "open",
// //     assigned_technician: "",
// //     scheduled_end: "" 
// //   });

// //   const fetchData = async () => {
// //     setLoading(true);
// //     try {
// //       const [issueRes, staffRes] = await Promise.all([
// //         axiosClient.get("api/issues/"),
// //         axiosClient.get("auth/users/")
// //       ]);
// //       setAllIssues(pickIssuesFromResponse(issueRes.data));
// //       const allUsers = Array.isArray(staffRes.data) ? staffRes.data : (staffRes.data.results || []);
// //       setStaffList(allUsers.filter(u => u.user_role === "TECHNICIAN" || u.user_role === "MAID"));
// //     } catch (err) {
// //       console.error("Failed to load data.");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => { fetchData(); }, [t]);

// //   const handleDelete = async (id) => {
// //     if (!id) return;
// //     if (window.confirm(t("Are you sure?"))) {
// //       try {
// //         await axiosClient.delete(`api/issues/${id}/`);
// //         setAllIssues(prev => prev.filter(issue => issue.id !== id));
// //       } catch (err) { alert(t("Delete failed.")); }
// //     }
// //   };

// //   const handleOpenEdit = (issue) => {
// //     setSelectedIssueId(issue.id);
// //     setEditData({
// //       title: issue.title || "",
// //       room_number: issue.room_number || "",
// //       status: issue.status || "open",
// //       // 🛠️ Ensure we store the ID for the Select component
// //       assigned_technician: issue.assigned_technician || "", 
// //       scheduled_end: issue.scheduled_end ? new Date(issue.scheduled_end).toISOString().slice(0, 16) : ""
// //     });
// //     setOpenEdit(true);
// //   };

// //   const handleSaveEdit = async () => {
// //     try {
// //       let finalData = { ...editData };
      
// //       // Auto-set end date if closing and empty
// //       if ((editData.status === "closed" || editData.status === "resolved") && !editData.scheduled_end) {
// //         finalData.scheduled_end = new Date().toISOString().slice(0, 16);
// //       }

// //       // 🛠️ PAYLOAD: We send 'assigned_technician' as an ID
// //       const payload = { 
// //         title: finalData.title,
// //         room_number: finalData.room_number,
// //         status: finalData.status,
// //         assigned_technician: finalData.assigned_technician || null,
// //         scheduled_end: finalData.scheduled_end === "" ? null : finalData.scheduled_end 
// //       };

// //       await axiosClient.put(`api/issues/${selectedIssueId}/`, payload);
// //       fetchData(); // 🛠️ Crucial: Refresh list to show the new 'staff_name' from the backend
// //       setOpenEdit(false);
// //       alert(t("Updated successfully!"));
// //     } catch (err) { alert(t("Update failed. Check your data.")); }
// //   };

// //   const formatDateTime = (dateString) => {
// //     if (!dateString || dateString === "-" || dateString === "None") return "-";
// //     const date = new Date(dateString);
// //     if (isNaN(date.getTime())) return dateString;
// //     const day = String(date.getDate()).padStart(2, '0');
// //     const month = String(date.getMonth() + 1).padStart(2, '0');
// //     const year = String(date.getFullYear()).slice(-2);
// //     return `${day}/${month}/${year}`;
// //   };

// //   const filteredIssues = useMemo(() => {
// //     return allIssues.filter((issue) => {
// //       const searchStr = search.toLowerCase();
// //       return (issue.title?.toLowerCase().includes(searchStr) || 
// //               String(issue.room_number || "").toLowerCase().includes(searchStr) ||
// //               issue.staff_name?.toLowerCase().includes(searchStr));
// //     });
// //   }, [allIssues, search]);

// //   if (loading && allIssues.length === 0) return <Box display="flex" justifyContent="center" mt={10}><CircularProgress /></Box>;

// //   return (
// //     <Box sx={{ p: 3 }}>
// //       <Card elevation={6} sx={{ borderRadius: 2 }}>
// //         <CardContent>
// //           <Typography variant="h5" fontWeight="bold" mb={3}>{t("Issue Management List")}</Typography>
// //           <Box display="flex" gap={2} mb={3}>
// //              <TextField label={t("Search")} size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ flex: 1 }} />
// //              <Button variant="contained" onClick={fetchData}>{t("Refresh")}</Button>
// //           </Box>
// //           <TableContainer component={Paper} sx={{ maxHeight: 700 }}>
// //             <Table stickyHeader>
// //               <TableHead>
// //                 <TableRow>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>ID</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Room")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Title")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Start Date/Time")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("End Date/Time")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Status")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("STAFF")}</TableCell>
// //                   <TableCell align="center" sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("ACTIONS")}</TableCell>
// //                 </TableRow>
// //               </TableHead>
// //               <TableBody>
// //                 {filteredIssues.map((issue) => (
// //                   <TableRow key={issue.id} hover>
// //                     <TableCell>#{issue.id}</TableCell>
// //                     <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>{issue.room_number || "-"}</TableCell>
// //                     <TableCell>{issue.title}</TableCell>
// //                     <TableCell>{formatDateTime(issue.appt_start)}</TableCell>
// //                     <TableCell>{formatDateTime(issue.scheduled_end)}</TableCell>
// //                     <TableCell>
// //                         <Chip 
// //                           label={t(issue.status || "open")} 
// //                           size="small" 
// //                           variant="outlined" 
// //                           color={issue.status === 'open' ? 'error' : (issue.status === 'closed' || issue.status === 'resolved' ? 'success' : 'warning')} 
// //                         />
// //                     </TableCell>

// //                     {/* 🛠️ Display Staff Name from the backend Serializer method */}
// //                     <TableCell sx={{ fontWeight: 'bold' }}>
// //                       {issue.staff_name || t("Unassigned")}
// //                     </TableCell>

// //                     <TableCell align="center">
// //                       <Stack direction="row" spacing={1} justifyContent="center">
// //                         <IconButton color="primary" onClick={() => handleOpenEdit(issue)}><EditIcon fontSize="small" /></IconButton>
// //                         <IconButton color="error" onClick={() => handleDelete(issue.id)}><DeleteIcon fontSize="small" /></IconButton>
// //                       </Stack>
// //                     </TableCell>
// //                   </TableRow>
// //                 ))}
// //               </TableBody>
// //             </Table>
// //           </TableContainer>
// //         </CardContent>
// //       </Card>

// //       {/* EDIT DIALOG */}
// //       <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="sm">
// //         <DialogTitle sx={{ fontWeight: "bold" }}>{t("Edit Issue")} #{selectedIssueId}</DialogTitle>
// //         <DialogContent dividers>
// //           <Stack spacing={3} mt={1}>
// //             <TextField fullWidth label={t("Title")} value={editData.title} onChange={(e) => setEditData({ ...editData, title: e.target.value })} />
// //             <TextField fullWidth label={t("Room")} value={editData.room_number} onChange={(e) => setEditData({ ...editData, room_number: e.target.value })} />
            
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Status")}</InputLabel>
// //               <Select value={editData.status} label={t("Status")} onChange={(e) => setEditData({ ...editData, status: e.target.value })}>
// //                 <MenuItem value="open">{t("Open")}</MenuItem>
// //                 <MenuItem value="in_progress">{t("In Progress")}</MenuItem>
// //                 <MenuItem value="resolved">{t("Resolved")}</MenuItem>
// //                 <MenuItem value="closed">{t("Closed")}</MenuItem>
// //               </Select>
// //             </FormControl>

// //             <FormControl fullWidth>
// //               <InputLabel>{t("Staff")}</InputLabel>
// //               <Select value={editData.assigned_technician} label={t("Staff")} onChange={(e) => setEditData({ ...editData, assigned_technician: e.target.value })}>
// //                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
// //                 {staffList.map(user => (
// //                   <MenuItem key={user.id} value={user.id}>
// //                     {user.first_name} {user.last_name} ({user.user_role})
// //                   </MenuItem>
// //                 ))}
// //               </Select>
// //             </FormControl>

// //             <TextField
// //               fullWidth
// //               label={t("End Date/Time (Manual)")}
// //               type="datetime-local"
// //               value={editData.scheduled_end}
// //               onChange={(e) => setEditData({ ...editData, scheduled_end: e.target.value })}
// //               InputLabelProps={{ shrink: true }}
// //             />
// //           </Stack>
// //         </DialogContent>
// //         <DialogActions sx={{ p: 2 }}>
// //           <Button onClick={() => setOpenEdit(false)}>{t("Cancel")}</Button>
// //           <Button variant="contained" onClick={handleSaveEdit}>{t("Save Changes")}</Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Box>
// //   );
// // };

// // export default IssuesScreen;

// // import React, { useState, useEffect, useMemo } from "react";
// // import {
// //   TableContainer, Table, TableHead, TableRow, TableCell,
// //   TableBody, Paper, Card, CardContent, Box, Typography,
// //   Button, TextField, FormControl, InputLabel, Select, MenuItem,
// //   CircularProgress, Alert, Chip, Stack, IconButton, Tooltip,
// //   Dialog, DialogTitle, DialogContent, DialogActions
// // } from "@mui/material";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import EditIcon from "@mui/icons-material/Edit";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";

// // const pickIssuesFromResponse = (data) => {
// //   if (!data) return [];
// //   if (Array.isArray(data)) return data;
// //   if (data.results && Array.isArray(data.results)) return data.results;
// //   return [];
// // };

// // const IssuesScreen = () => {
// //   const { t } = useTranslation();
// //   const [allIssues, setAllIssues] = useState([]);
// //   const [staffList, setStaffList] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [search, setSearch] = useState("");

// //   const [openEdit, setOpenEdit] = useState(false);
// //   const [selectedIssueId, setSelectedIssueId] = useState(null);
// //   const [editData, setEditData] = useState({
// //     title: "",
// //     room_number: "",
// //     status: "open",
// //     assigned_technician: "", // Stores the User ID
// //     scheduled_end: "" 
// //   });

// //   const fetchData = async () => {
// //     setLoading(true);
// //     try {
// //       const [issueRes, staffRes] = await Promise.all([
// //         axiosClient.get("api/issues/"),
// //         axiosClient.get("auth/users/")
// //       ]);
// //       setAllIssues(pickIssuesFromResponse(issueRes.data));
// //       const allUsers = Array.isArray(staffRes.data) ? staffRes.data : (staffRes.data.results || []);
// //       // Filter for roles allowed to be assigned
// //       setStaffList(allUsers.filter(u => u.user_role === "TECHNICIAN" || u.user_role === "MAID"));
// //     } catch (err) {
// //       console.error("Fetch error:", err);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => { fetchData(); }, [t]);

// //   const handleOpenEdit = (issue) => {
// //     setSelectedIssueId(issue.id);
// //     setEditData({
// //       title: issue.title || "",
// //       room_number: issue.room_number || "",
// //       status: issue.status || "open",
// //       assigned_technician: issue.assigned_technician || "", // Map ID for the Select dropdown
// //       scheduled_end: issue.scheduled_end ? new Date(issue.scheduled_end).toISOString().slice(0, 16) : ""
// //     });
// //     setOpenEdit(true);
// //   };

// //   const handleSaveEdit = async () => {
// //     try {
// //       let finalData = { ...editData };
      
// //       // Auto-set end date if status is 'closed' and field is empty
// //       if (editData.status === "closed" && !editData.scheduled_end) {
// //         finalData.scheduled_end = new Date().toISOString().slice(0, 16);
// //       }

// //       const payload = { 
// //         title: finalData.title,
// //         room_number: finalData.room_number,
// //         status: finalData.status,
// //         assigned_technician: finalData.assigned_technician || null, // Send ID to backend
// //         scheduled_end: finalData.scheduled_end || null 
// //       };

// //       await axiosClient.put(`api/issues/${selectedIssueId}/`, payload);
      
// //       // 🛠️ CRITICAL: Re-fetch data so the table shows the new 'staff_name' 
// //       // string generated by the backend serializer
// //       await fetchData(); 
      
// //       setOpenEdit(false);
// //       alert(t("Issue updated successfully!"));
// //     } catch (err) {
// //       alert(t("Update failed. Please check your inputs."));
// //     }
// //   };

// //   const formatDateTime = (dateString) => {
// //     if (!dateString || dateString === "-") return "-";
// //     const date = new Date(dateString);
// //     if (isNaN(date.getTime())) return "-";
// //     return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getFullYear()).slice(-2)}`;
// //   };

// //   const filteredIssues = useMemo(() => {
// //     return allIssues.filter((issue) => {
// //       const searchStr = search.toLowerCase();
// //       return (
// //         issue.title?.toLowerCase().includes(searchStr) || 
// //         String(issue.room_number || "").toLowerCase().includes(searchStr) ||
// //         issue.staff_name?.toLowerCase().includes(searchStr)
// //       );
// //     });
// //   }, [allIssues, search]);

// //   if (loading && allIssues.length === 0) return <Box display="flex" justifyContent="center" mt={10}><CircularProgress /></Box>;

// //   return (
// //     <Box sx={{ p: 3 }}>
// //       <Card elevation={4} sx={{ borderRadius: 3 }}>
// //         <CardContent>
// //           <Typography variant="h5" fontWeight="bold" mb={3} color="primary">
// //             {t("Issue Management List")}
// //           </Typography>
          
// //           <Box display="flex" gap={2} mb={3}>
// //              <TextField 
// //                 label={t("Search by Room, Title or Staff")} 
// //                 size="small" 
// //                 fullWidth
// //                 value={search} 
// //                 onChange={(e) => setSearch(e.target.value)} 
// //              />
// //              <Button variant="outlined" onClick={fetchData}>{t("Refresh")}</Button>
// //           </Box>

// //           <TableContainer component={Paper} sx={{ maxHeight: 600, borderRadius: 2 }}>
// //             <Table stickyHeader>
// //               <TableHead>
// //                 <TableRow>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f8f9fa" }}>ID</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f8f9fa" }}>{t("Room")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f8f9fa" }}>{t("Title")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f8f9fa" }}>{t("Start")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f8f9fa" }}>{t("End")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f8f9fa" }}>{t("Status")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#f8f9fa" }}>{t("STAFF")}</TableCell>
// //                   <TableCell align="center" sx={{ fontWeight: "bold", bgcolor: "#f8f9fa" }}>{t("Actions")}</TableCell>
// //                 </TableRow>
// //               </TableHead>
// //               <TableBody>
// //                 {filteredIssues.map((issue) => (
// //                   <TableRow key={issue.id} hover>
// //                     <TableCell>#{issue.id}</TableCell>
// //                     <TableCell sx={{ fontWeight: 'bold' }}>{issue.room_number}</TableCell>
// //                     <TableCell>{issue.title}</TableCell>
// //                     <TableCell>{formatDateTime(issue.appt_start)}</TableCell>
// //                     <TableCell>{formatDateTime(issue.scheduled_end)}</TableCell>
// //                     <TableCell>
// //                         <Chip 
// //                           label={t(issue.status)} 
// //                           size="small" 
// //                           color={issue.status === 'open' ? 'error' : (issue.status === 'closed' ? 'success' : 'warning')} 
// //                         />
// //                     </TableCell>
                    
// //                     {/* 🛠️ THIS BINDS TO THE staff_name FROM SERIALIZER */}
// //                     <TableCell sx={{ fontWeight: 'bold', color: 'secondary.main' }}>
// //                       {issue.staff_name || t("Unassigned")}
// //                     </TableCell>

// //                     <TableCell align="center">
// //                       <IconButton color="primary" onClick={() => handleOpenEdit(issue)}>
// //                         <EditIcon fontSize="small" />
// //                       </IconButton>
// //                     </TableCell>
// //                   </TableRow>
// //                 ))}
// //               </TableBody>
// //             </Table>
// //           </TableContainer>
// //         </CardContent>
// //       </Card>

// //       {/* EDIT MODAL */}
// //       <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="sm">
// //         <DialogTitle sx={{ fontWeight: "bold" }}>{t("Update Issue Details")}</DialogTitle>
// //         <DialogContent dividers>
// //           <Stack spacing={3} mt={1}>
// //             <TextField fullWidth label={t("Title")} value={editData.title} onChange={e => setEditData({...editData, title: e.target.value})} />
            
// //             <FormControl fullWidth>
// //               <InputLabel>{t("Staff Member")}</InputLabel>
// //               <Select 
// //                 value={editData.assigned_technician} 
// //                 label={t("Staff Member")} 
// //                 onChange={e => setEditData({...editData, assigned_technician: e.target.value})}
// //               >
// //                 <MenuItem value=""><em>{t("Unassigned")}</em></MenuItem>
// //                 {staffList.map(u => (
// //                   <MenuItem key={u.id} value={u.id}>{u.first_name} {u.last_name} ({u.user_role})</MenuItem>
// //                 ))}
// //               </Select>
// //             </FormControl>

// //             <FormControl fullWidth>
// //               <InputLabel>{t("Status")}</InputLabel>
// //               <Select value={editData.status} label={t("Status")} onChange={e => setEditData({...editData, status: e.target.value})}>
// //                 <MenuItem value="open">{t("Open")}</MenuItem>
// //                 <MenuItem value="in_progress">{t("In Progress")}</MenuItem>
// //                 <MenuItem value="closed">{t("Closed")}</MenuItem>
// //               </Select>
// //             </FormControl>

// //             <TextField 
// //               fullWidth 
// //               label={t("Manual End Date")} 
// //               type="datetime-local" 
// //               value={editData.scheduled_end} 
// //               onChange={e => setEditData({...editData, scheduled_end: e.target.value})} 
// //               InputLabelProps={{ shrink: true }} 
// //             />
// //           </Stack>
// //         </DialogContent>
// //         <DialogActions sx={{ p: 2 }}>
// //           <Button onClick={() => setOpenEdit(false)}>{t("Cancel")}</Button>
// //           <Button variant="contained" onClick={handleSaveEdit}>{t("Save Changes")}</Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Box>
// //   );
// // };

// // export default IssuesScreen;


// //////////////////////

// // import React, { useState, useEffect, useMemo } from "react";
// // import {
// //   TableContainer, Table, TableHead, TableRow, TableCell,
// //   TableBody, Paper, Card, CardContent, Box, Typography,
// //   Button, TextField, FormControl, InputLabel, Select, MenuItem,
// //   CircularProgress, Alert, Chip, Stack, IconButton, Tooltip,
// //   Dialog, DialogTitle, DialogContent, DialogActions
// // } from "@mui/material";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import EditIcon from "@mui/icons-material/Edit";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";

// // const pickIssuesFromResponse = (data) => {
// //   if (!data) return [];
// //   if (Array.isArray(data)) return data;
// //   if (data.results && Array.isArray(data.results)) return data.results;
// //   return [];
// // };

// // const IssuesScreen = () => {
// //   const { t } = useTranslation();
// //   const [allIssues, setAllIssues] = useState([]);
// //   const [staffList, setStaffList] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [search, setSearch] = useState("");

// //   const [openEdit, setOpenEdit] = useState(false);
// //   const [selectedIssueId, setSelectedIssueId] = useState(null);
// //   const [editData, setEditData] = useState({
// //     title: "",
// //     room_number: "",
// //     status: "open",
// //     assigned_technician: "",
// //     scheduled_end: "" 
// //   });

// //   const fetchData = async () => {
// //     setLoading(true);
// //     try {
// //       const [issueRes, staffRes] = await Promise.all([
// //         axiosClient.get("api/issues/"),
// //         axiosClient.get("auth/users/")
// //       ]);
// //       setAllIssues(pickIssuesFromResponse(issueRes.data));
// //       const allUsers = Array.isArray(staffRes.data) ? staffRes.data : (staffRes.data.results || []);
// //       setStaffList(allUsers.filter(u => u.user_role === "TECHNICIAN" || u.user_role === "MAID"));
// //     } catch (err) {
// //       console.error("Fetch Error:", err);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => { fetchData(); }, [t]);

// //   const handleOpenEdit = (issue) => {
// //     setSelectedIssueId(issue.id);
// //     setEditData({
// //       title: issue.title || "",
// //       room_number: issue.room_number || "",
// //       status: issue.status || "open",
// //       assigned_technician: issue.assigned_technician || "",
// //       scheduled_end: issue.scheduled_end ? new Date(issue.scheduled_end).toISOString().slice(0, 16) : ""
// //     });
// //     setOpenEdit(true);
// //   };

// //   const handleSaveEdit = async () => {
// //     try {
// //       let finalData = { ...editData };
      
// //       // Auto-set end date if closing and empty
// //       if (editData.status === "closed" && !editData.scheduled_end) {
// //         finalData.scheduled_end = new Date().toISOString().slice(0, 16);
// //       }

// //       const payload = { 
// //         title: finalData.title,
// //         room_number: finalData.room_number,
// //         status: finalData.status,
// //         assigned_technician: finalData.assigned_technician || null,
// //         scheduled_end: finalData.scheduled_end || null 
// //       };

// //       await axiosClient.put(`api/issues/${selectedIssueId}/`, payload);
      
// //       // 🛠️ REFRESH: Pulls the new staff_name and updated dates from DB
// //       await fetchData(); 
      
// //       setOpenEdit(false);
// //       alert(t("Update Successful"));
// //     } catch (err) {
// //       alert(t("Update Failed"));
// //     }
// //   };

// //   const formatDateTime = (dateString) => {
// //     if (!dateString || dateString === "-") return "-";
// //     const date = new Date(dateString);
// //     if (isNaN(date.getTime())) return "-";
// //     const day = String(date.getDate()).padStart(2, '0');
// //     const month = String(date.getMonth() + 1).padStart(2, '0');
// //     const year = String(date.getFullYear()).slice(-2);
// //     return `${day}/${month}/${year}`;
// //   };

// //   const filteredIssues = useMemo(() => {
// //     return allIssues.filter((issue) => {
// //       const searchStr = search.toLowerCase();
// //       return (
// //         issue.title?.toLowerCase().includes(searchStr) || 
// //         String(issue.room_number || "").toLowerCase().includes(searchStr) ||
// //         issue.staff_name?.toLowerCase().includes(searchStr)
// //       );
// //     });
// //   }, [allIssues, search]);

// //   if (loading && allIssues.length === 0) return <Box display="flex" justifyContent="center" mt={10}><CircularProgress /></Box>;

// //   return (
// //     <Box sx={{ p: 3 }}>
// //       <Card elevation={4} sx={{ borderRadius: 3, bgcolor: '#1e1e1e', color: '#fff' }}>
// //         <CardContent>
// //           <Typography variant="h5" fontWeight="bold" mb={3} color="#90caf9">
// //             {t("Issue Management List")}
// //           </Typography>
          
// //           <Box display="flex" gap={2} mb={3}>
// //              <TextField 
// //                 label={t("Search by Room, Title or Staff")} 
// //                 size="small" 
// //                 fullWidth
// //                 variant="outlined"
// //                 value={search} 
// //                 onChange={(e) => setSearch(e.target.value)}
// //                 sx={{ 
// //                   bgcolor: '#2c2c2c', 
// //                   input: { color: '#fff' }, 
// //                   label: { color: '#aaa' },
// //                   '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#444' } }
// //                 }} 
// //              />
// //              <Button variant="contained" sx={{ bgcolor: '#90caf9', color: '#000' }} onClick={fetchData}>{t("Refresh")}</Button>
// //           </Box>

// //           <TableContainer component={Paper} sx={{ maxHeight: 650, borderRadius: 2, bgcolor: '#1e1e1e' }}>
// //             <Table stickyHeader>
// //               <TableHead>
// //                 <TableRow>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#333", color: "#fff" }}>ID</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#333", color: "#fff" }}>{t("Room")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#333", color: "#fff" }}>{t("Title")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#333", color: "#fff" }}>{t("Start")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#333", color: "#fff" }}>{t("End")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#333", color: "#fff" }}>{t("Status")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "#333", color: "#fff" }}>{t("STAFF")}</TableCell>
// //                   <TableCell align="center" sx={{ fontWeight: "bold", bgcolor: "#333", color: "#fff" }}>{t("Actions")}</TableCell>
// //                 </TableRow>
// //               </TableHead>
// //               <TableBody>
// //                 {filteredIssues.map((issue) => (
// //                   <TableRow key={issue.id} hover sx={{ '&:hover': { bgcolor: '#2c2c2c !important' } }}>
// //                     <TableCell sx={{ color: '#aaa' }}>#{issue.id}</TableCell>
// //                     <TableCell sx={{ fontWeight: 'bold', color: '#90caf9' }}>{issue.room_number}</TableCell>
// //                     <TableCell sx={{ color: '#fff' }}>{issue.title}</TableCell>
// //                     <TableCell sx={{ color: '#fff' }}>{formatDateTime(issue.appt_start)}</TableCell>
// //                     <TableCell sx={{ color: '#fff' }}>{formatDateTime(issue.scheduled_end)}</TableCell>
// //                     <TableCell>
// //                         <Chip 
// //                           label={t(issue.status)} 
// //                           size="small" 
// //                           variant="outlined"
// //                           sx={{ 
// //                             color: issue.status === 'open' ? '#f44336' : '#4caf50', 
// //                             borderColor: issue.status === 'open' ? '#f44336' : '#4caf50' 
// //                           }} 
// //                         />
// //                     </TableCell>
// //                     <TableCell sx={{ fontWeight: 'bold', color: '#ce93d8' }}>
// //                       {issue.staff_name || t("Unassigned")}
// //                     </TableCell>
// //                     <TableCell align="center">
// //                       <IconButton sx={{ color: '#90caf9' }} onClick={() => handleOpenEdit(issue)}>
// //                         <EditIcon fontSize="small" />
// //                       </IconButton>
// //                     </TableCell>
// //                   </TableRow>
// //                 ))}
// //               </TableBody>
// //             </Table>
// //           </TableContainer>
// //         </CardContent>
// //       </Card>

// //       <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="sm" PaperProps={{ sx: { bgcolor: '#1e1e1e', color: '#fff' } }}>
// //         <DialogTitle sx={{ fontWeight: "bold", borderBottom: '1px solid #333' }}>{t("Update Issue")}</DialogTitle>
// //         <DialogContent dividers sx={{ borderColor: '#333' }}>
// //           <Stack spacing={3} mt={1}>
// //             <TextField fullWidth label={t("Title")} value={editData.title} onChange={e => setEditData({...editData, title: e.target.value})} sx={{ bgcolor: '#2c2c2c', input: { color: '#fff' }, label: { color: '#aaa' } }} />
            
// //             <FormControl fullWidth>
// //               <InputLabel sx={{ color: '#aaa' }}>{t("Assign Staff")}</InputLabel>
// //               <Select 
// //                 value={editData.assigned_technician} 
// //                 label={t("Assign Staff")} 
// //                 onChange={e => setEditData({...editData, assigned_technician: e.target.value})}
// //                 sx={{ color: '#fff', '.MuiOutlinedInput-notchedOutline': { borderColor: '#444' } }}
// //               >
// //                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
// //                 {staffList.map(u => (
// //                   <MenuItem key={u.id} value={u.id}>{u.first_name} {u.last_name} ({u.user_role})</MenuItem>
// //                 ))}
// //               </Select>
// //             </FormControl>

// //             <FormControl fullWidth>
// //               <InputLabel sx={{ color: '#aaa' }}>{t("Status")}</InputLabel>
// //               <Select value={editData.status} label={t("Status")} onChange={e => setEditData({...editData, status: e.target.value})} sx={{ color: '#fff', '.MuiOutlinedInput-notchedOutline': { borderColor: '#444' } }}>
// //                 <MenuItem value="open">{t("Open")}</MenuItem>
// //                 <MenuItem value="in_progress">{t("In Progress")}</MenuItem>
// //                 <MenuItem value="closed">{t("Closed")}</MenuItem>
// //               </Select>
// //             </FormControl>

// //             <TextField 
// //               fullWidth 
// //               label={t("Manual End Date")} 
// //               type="datetime-local" 
// //               value={editData.scheduled_end} 
// //               onChange={e => setEditData({...editData, scheduled_end: e.target.value})} 
// //               InputLabelProps={{ shrink: true }} 
// //               sx={{ bgcolor: '#2c2c2c', input: { color: '#fff' }, label: { color: '#aaa' } }}
// //             />
// //           </Stack>
// //         </DialogContent>
// //         <DialogActions sx={{ p: 2, borderTop: '1px solid #333' }}>
// //           <Button sx={{ color: '#aaa' }} onClick={() => setOpenEdit(false)}>{t("Cancel")}</Button>
// //           <Button variant="contained" sx={{ bgcolor: '#90caf9', color: '#000' }} onClick={handleSaveEdit}>{t("Save")}</Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Box>
// //   );
// // };

// // export default IssuesScreen;



// /////////////////////////////////////////////////////////////////////////////

// // import React, { useState, useEffect, useMemo } from "react";
// // import {
// //   TableContainer, Table, TableHead, TableRow, TableCell,
// //   TableBody, Paper, Card, CardContent, Box, Typography,
// //   Button, TextField, FormControl, InputLabel, Select, MenuItem,
// //   CircularProgress, Alert, Chip, Stack, IconButton, Tooltip,
// //   Dialog, DialogTitle, DialogContent, DialogActions
// // } from "@mui/material";
// // // 🛠️ FIX: Added DeleteIcon and EditCalendarIcon
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import EditIcon from "@mui/icons-material/Edit";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";

// // const pickIssuesFromResponse = (data) => {
// //   if (!data) return [];
// //   if (Array.isArray(data)) return data;
// //   if (data.results && Array.isArray(data.results)) return data.results;
// //   return [];
// // };

// // const IssuesScreen = () => {
// //   const { t } = useTranslation();
// //   const [allIssues, setAllIssues] = useState([]);
// //   const [staffList, setStaffList] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [search, setSearch] = useState("");

// //   const [openEdit, setOpenEdit] = useState(false);
// //   const [selectedIssueId, setSelectedIssueId] = useState(null);
// //   const [editData, setEditData] = useState({
// //     title: "",
// //     room_number: "",
// //     status: "open",
// //     assigned_technician: "",
// //     scheduled_end: "" 
// //   });

// //   const fetchData = async () => {
// //     setLoading(true);
// //     try {
// //       const [issueRes, staffRes] = await Promise.all([
// //         axiosClient.get("api/issues/"),
// //         axiosClient.get("auth/users/")
// //       ]);
// //       setAllIssues(pickIssuesFromResponse(issueRes.data));
// //       const allUsers = Array.isArray(staffRes.data) ? staffRes.data : (staffRes.data.results || []);
// //       setStaffList(allUsers.filter(u => u.user_role === "TECHNICIAN" || u.user_role === "MAID"));
// //     } catch (err) { console.error(err); }
// //     finally { setLoading(false); }
// //   };

// //   useEffect(() => { fetchData(); }, [t]);

// //   const handleDelete = async (id) => {
// //     if (!id) return;
// //     if (window.confirm(t("Are you sure you want to delete this issue?"))) {
// //       try {
// //         await axiosClient.delete(`api/issues/${id}/`);
// //         setAllIssues(prev => prev.filter(issue => issue.id !== id));
// //       } catch (err) { alert(t("Delete failed.")); }
// //     }
// //   };

// //   const handleOpenEdit = (issue) => {
// //     setSelectedIssueId(issue.id);
// //     setEditData({
// //       title: issue.title || "",
// //       room_number: issue.room_number || "",
// //       status: issue.status || "open",
// //       assigned_technician: issue.assigned_technician || "", 
// //       scheduled_end: issue.scheduled_end ? new Date(issue.scheduled_end).toISOString().slice(0, 16) : ""
// //     });
// //     setOpenEdit(true);
// //   };

// //   const handleSaveEdit = async () => {
// //     try {
// //       let finalData = { ...editData };
// //       if (editData.status === "closed" && !editData.scheduled_end) {
// //         finalData.scheduled_end = new Date().toISOString().slice(0, 16);
// //       }
// //       const payload = { 
// //         title: finalData.title,
// //         room_number: finalData.room_number,
// //         status: finalData.status,
// //         assigned_technician: finalData.assigned_technician || null,
// //         scheduled_end: finalData.scheduled_end || null 
// //       };
// //       await axiosClient.put(`api/issues/${selectedIssueId}/`, payload);
// //       await fetchData(); // 🛠️ Re-fetches the list to show the new staff name
// //       setOpenEdit(false);
// //     } catch (err) { alert(t("Update failed.")); }
// //   };

// //   const formatDateTime = (dateString) => {
// //     if (!dateString || dateString === "-") return "-";
// //     const date = new Date(dateString);
// //     return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getFullYear()).slice(-2)}`;
// //   };

// //   const filteredIssues = useMemo(() => {
// //     return allIssues.filter((issue) => {
// //       const searchStr = search.toLowerCase();
// //       return (issue.title?.toLowerCase().includes(searchStr) || 
// //               String(issue.room_number || "").toLowerCase().includes(searchStr) ||
// //               issue.staff_name?.toLowerCase().includes(searchStr));
// //     });
// //   }, [allIssues, search]);

// //   return (
// //     <Box sx={{ p: 3 }}>
// //       <Card elevation={4} sx={{ borderRadius: 3, bgcolor: '#1e1e1e', color: '#fff' }}>
// //         <CardContent>
// //           <Typography variant="h5" fontWeight="bold" mb={3} color="#90caf9">{t("Issue Management List")}</Typography>
// //           <Box display="flex" gap={2} mb={3}>
// //              <TextField label={t("Search")} size="small" fullWidth value={search} onChange={(e) => setSearch(e.target.value)}
// //                 sx={{ bgcolor: '#2c2c2c', input: { color: '#fff' }, label: { color: '#aaa' } }} />
// //              <Button variant="contained" sx={{ bgcolor: '#90caf9', color: '#000' }} onClick={fetchData}>{t("Refresh")}</Button>
// //           </Box>
// //           <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e' }}>
// //             <Table stickyHeader>
// //               <TableHead>
// //                 <TableRow sx={{ bgcolor: '#333' }}>
// //                   <TableCell sx={{ color: '#fff' }}>ID</TableCell>
// //                   <TableCell sx={{ color: '#fff' }}>{t("Room")}</TableCell>
// //                   <TableCell sx={{ color: '#fff' }}>{t("Title")}</TableCell>
// //                   <TableCell sx={{ color: '#fff' }}>{t("Start")}</TableCell>
// //                   <TableCell sx={{ color: '#fff' }}>{t("End")}</TableCell>
// //                   <TableCell sx={{ color: '#fff' }}>{t("Status")}</TableCell>
// //                   <TableCell sx={{ color: '#fff' }}>{t("STAFF")}</TableCell>
// //                   <TableCell align="center" sx={{ color: '#fff' }}>{t("Actions")}</TableCell>
// //                 </TableRow>
// //               </TableHead>
// //               <TableBody>
// //                 {filteredIssues.map((issue) => (
// //                   <TableRow key={issue.id} hover>
// //                     <TableCell sx={{ color: '#aaa' }}>#{issue.id}</TableCell>
// //                     <TableCell sx={{ fontWeight: 'bold', color: '#90caf9' }}>{issue.room_number}</TableCell>
// //                     <TableCell sx={{ color: '#fff' }}>{issue.title}</TableCell>
// //                     <TableCell sx={{ color: '#fff' }}>{formatDateTime(issue.appt_start)}</TableCell>
// //                     <TableCell sx={{ color: '#fff' }}>{formatDateTime(issue.scheduled_end)}</TableCell>
// //                     <TableCell>
// //                         <Chip label={t(issue.status)} size="small" variant="outlined"
// //                           sx={{ color: issue.status === 'open' ? '#f44336' : '#4caf50', borderColor: issue.status === 'open' ? '#f44336' : '#4caf50' }} />
// //                     </TableCell>

// //                     {/* 🛠️ FIX: NOW DISPLAYS THE ASSIGNED STAFF NAME */}
// //                     <TableCell sx={{ fontWeight: 'bold', color: '#ce93d8' }}>
// //                       {issue.staff_name || t("Unassigned")}
// //                     </TableCell>

// //                     <TableCell align="center">
// //                       <Stack direction="row" spacing={1} justifyContent="center">
// //                         <IconButton sx={{ color: '#90caf9' }} onClick={() => handleOpenEdit(issue)}><EditIcon fontSize="small" /></IconButton>
// //                         {/* 🛠️ FIX: ADDED DELETE BUTTON BACK */}
// //                         <IconButton sx={{ color: '#f44336' }} onClick={() => handleDelete(issue.id)}><DeleteIcon fontSize="small" /></IconButton>
// //                       </Stack>
// //                     </TableCell>
// //                   </TableRow>
// //                 ))}
// //               </TableBody>
// //             </Table>
// //           </TableContainer>
// //         </CardContent>
// //       </Card>

// //       {/* EDIT MODAL */}
// //       <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="sm" PaperProps={{ sx: { bgcolor: '#1e1e1e', color: '#fff' } }}>
// //         <DialogTitle sx={{ fontWeight: "bold", borderBottom: '1px solid #333' }}>{t("Update Issue")}</DialogTitle>
// //         <DialogContent dividers sx={{ borderColor: '#333' }}>
// //           <Stack spacing={3} mt={1}>
// //             <TextField fullWidth label={t("Title")} value={editData.title} onChange={e => setEditData({...editData, title: e.target.value})} sx={{ bgcolor: '#2c2c2c', input: { color: '#fff' }, label: { color: '#aaa' } }} />
// //             <FormControl fullWidth>
// //               <InputLabel sx={{ color: '#aaa' }}>{t("Assign Staff")}</InputLabel>
// //               <Select value={editData.assigned_technician} label={t("Assign Staff")} onChange={e => setEditData({...editData, assigned_technician: e.target.value})}
// //                 sx={{ color: '#fff', '.MuiOutlinedInput-notchedOutline': { borderColor: '#444' } }}>
// //                 <MenuItem value=""><em>{t("None")}</em></MenuItem>
// //                 {staffList.map(u => <MenuItem key={u.id} value={u.id}>{u.first_name} {u.last_name} ({u.user_role})</MenuItem>)}
// //               </Select>
// //             </FormControl>
// //             <FormControl fullWidth>
// //               <InputLabel sx={{ color: '#aaa' }}>{t("Status")}</InputLabel>
// //               <Select value={editData.status} label={t("Status")} onChange={e => setEditData({...editData, status: e.target.value})} sx={{ color: '#fff', '.MuiOutlinedInput-notchedOutline': { borderColor: '#444' } }}>
// //                 <MenuItem value="open">{t("Open")}</MenuItem>
// //                 <MenuItem value="in_progress">{t("In Progress")}</MenuItem>
// //                 <MenuItem value="closed">{t("Closed")}</MenuItem>
// //               </Select>
// //             </FormControl>
// //             <TextField fullWidth label={t("Manual End Date")} type="datetime-local" value={editData.scheduled_end} onChange={e => setEditData({...editData, scheduled_end: e.target.value})} 
// //               InputLabelProps={{ shrink: true }} sx={{ bgcolor: '#2c2c2c', input: { color: '#fff' }, label: { color: '#aaa' } }} />
// //           </Stack>
// //         </DialogContent>
// //         <DialogActions sx={{ p: 2, borderTop: '1px solid #333' }}>
// //           <Button sx={{ color: '#aaa' }} onClick={() => setOpenEdit(false)}>{t("Cancel")}</Button>
// //           <Button variant="contained" sx={{ bgcolor: '#90caf9', color: '#000' }} onClick={handleSaveEdit}>{t("Save")}</Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Box>
// //   );
// // };

// // export default IssuesScreen;


// /////////////////////////////

// import React, { useState, useEffect, useCallback } from "react";
// import {
//   TableContainer, Table, TableHead, TableRow, TableCell,
//   TableBody, Paper, Card, CardContent, Box, Typography,
//   Button, TextField, Chip, Stack, IconButton, Tooltip,
//   CircularProgress
// } from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle"; 
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";
// import { useStateContext } from "../context/ContextProvider"; 

// const IssuesScreen = () => {
//   const { t } = useTranslation();
//   const { user } = useStateContext(); 
//   const [issues, setIssues] = useState([]); // Single source of truth
//   const [loading, setLoading] = useState(false);

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await axiosClient.get("api/issues/");
      
//       // Get data from either standard array or DRF results
//       const rawData = Array.isArray(response.data) 
//         ? response.data 
//         : (response.data.results || []);

//       let cleanData = [];

//       // --- STRICT FILTERING START ---
//       if (user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") {
//         // We only keep data where IDs match exactly as numbers
//         cleanData = rawData.filter(item => 
//           Number(item.assigned_technician) === Number(user.id)
//         );
//       } else {
//         cleanData = rawData;
//       }
//       // --- STRICT FILTERING END ---

//       // Overwrite the state entirely with the clean list
//       setIssues(cleanData);
      
//     } catch (err) { 
//       console.error("Fetch error:", err); 
//     } finally { 
//       setLoading(false); 
//     }
//   }, [user.id, user.user_role]);

//   useEffect(() => {
//     fetchData();
//   }, [fetchData]);

//   const handleQuickResolve = async (id) => {
//     if (window.confirm(t("Mark this task as completed?"))) {
//       try {
//         const now = new Date().toISOString().slice(0, 16);
//         await axiosClient.patch(`api/issues/${id}/`, { 
//           status: "closed", 
//           scheduled_end: now 
//         });
//         fetchData(); 
//       } catch (err) { 
//         alert(t("Update failed.")); 
//       }
//     }
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Card sx={{ borderRadius: 3, bgcolor: '#1e1e1e', color: '#fff' }}>
//         <CardContent>
//           <Typography variant="h5" fontWeight="bold" mb={3} color="#90caf9">
//             {(user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") 
//               ? t("My Assigned Tasks") 
//               : t("Issue Management List")}
//           </Typography>

//           <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e' }}>
//             <Table stickyHeader>
//               <TableHead>
//                 <TableRow sx={{ bgcolor: '#333' }}>
//                   <TableCell sx={{ color: '#fff' }}>ID</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>{t("Room")}</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>{t("Title")}</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>{t("Status")}</TableCell>
//                   <TableCell align="center" sx={{ color: '#fff' }}>{t("Actions")}</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {issues.length > 0 ? (
//                   issues.map((issue) => (
//                     <TableRow key={issue.id} hover>
//                       <TableCell sx={{ color: '#aaa' }}>#{issue.id}</TableCell>
//                       <TableCell sx={{ fontWeight: 'bold', color: '#90caf9' }}>{issue.room_number}</TableCell>
//                       <TableCell sx={{ color: '#fff' }}>{issue.title}</TableCell>
//                       <TableCell>
//                           <Chip 
//                             label={t(issue.status)} 
//                             size="small" 
//                             sx={{ 
//                               color: issue.status === 'open' ? '#f44336' : '#4caf50', 
//                               borderColor: issue.status === 'open' ? '#f44336' : '#4caf50' 
//                             }} 
//                             variant="outlined" 

//                           />
//                       </TableCell>

//                       <TableCell align="center">
//                         {issue.status !== "closed" && (
//                           <IconButton sx={{ color: '#4caf50' }} onClick={() => handleQuickResolve(issue.id)}>
//                             <CheckCircleIcon />
//                           </IconButton>
//                         )}
//                       </TableCell>
//                     </TableRow>
//                   ))
//                 ) : (
//                   <TableRow>
//                     <TableCell colSpan={5} align="center" sx={{ color: '#666', py: 5 }}>
//                       {loading ? <CircularProgress size={24} /> : t("No tasks assigned to you.")}
//                     </TableCell>
//                   </TableRow>
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default IssuesScreen;

////////////////////////////////

// import React, { useState, useEffect, useCallback } from "react";
// import {
//   TableContainer, Table, TableHead, TableRow, TableCell,
//   TableBody, Paper, Card, CardContent, Box, Typography,
//   Button, Chip, IconButton, CircularProgress
// } from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle"; 
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider"; 

// const IssuesScreen = () => {
//   const { user } = useStateContext(); 
//   const [issues, setIssues] = useState([]); 
//   const [loading, setLoading] = useState(false);

//   const fetchData = useCallback(async () => {
//     // 1. ABSOLUTE CLEAR: Wipe the table so no old data can hide there
//     setIssues([]); 
//     setLoading(true);

//     try {
//       const response = await axiosClient.get("api/issues/");
      
//       const rawData = Array.isArray(response.data) 
//         ? response.data 
//         : (response.data.results || []);

//       // 2. LOCAL FILTERING: We create a brand new list in memory
//       const cleanData = [];

//       if (user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") {
//         rawData.forEach(item => {
//           // If IDs don't match, the item is physically ignored
//           if (Number(item.assigned_technician) === Number(user.id)) {
//             cleanData.push(item);
//           }
//         });
//       } else {
//         cleanData.push(...rawData);
//       }

//       // 3. UPDATE STATE ONLY WITH THE CLEAN DATA
//       setIssues(cleanData);
      
//     } catch (err) { 
//       console.error("Fetch error:", err); 
//     } finally { 
//       setLoading(false); 
//     }
//   }, [user.id, user.user_role]);

//   useEffect(() => {
//     fetchData();
//   }, [fetchData]);

//   const handleQuickResolve = async (id) => {
//     if (window.confirm("Mark this task as completed?")) {
//       try {
//         const now = new Date().toISOString().slice(0, 16);
//         await axiosClient.patch(`api/issues/${id}/`, { 
//           status: "closed", 
//           scheduled_end: now 
//         });
//         fetchData(); 
//       } catch (err) { 
//         alert("Update failed."); 
//       }
//     }
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Card sx={{ borderRadius: 3, bgcolor: '#1e1e1e', color: '#fff' }}>
//         <CardContent>
//           <Typography variant="h6" fontWeight="bold" mb={3} color="#90caf9">
//             {(user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") 
//               ? "My Assigned Tasks" 
//               : "Issue Management List"}
//           </Typography>

//           <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e' }}>
//             <Table>
//               <TableHead>
//                 <TableRow sx={{ bgcolor: '#333' }}>
//                   <TableCell sx={{ color: '#fff' }}>ID</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Room</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Title</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Status</TableCell>
//                   <TableCell align="center" sx={{ color: '#fff' }}>Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {issues.length > 0 ? (
//                   issues.map((issue) => (
//                     <TableRow key={issue.id} hover>
//                       <TableCell sx={{ color: '#aaa' }}>#{issue.id}</TableCell>
//                       <TableCell sx={{ fontWeight: 'bold', color: '#90caf9' }}>{issue.room_number}</TableCell>
//                       <TableCell sx={{ color: '#fff' }}>{issue.title}</TableCell>
//                       <TableCell>
//                           <Chip 
//                             label={issue.status} 
//                             size="small" 
//                             sx={{ color: issue.status === 'open' ? '#f44336' : '#4caf50', borderColor: issue.status === 'open' ? '#f44336' : '#4caf50' }} 
//                             variant="outlined" 
//                           />
//                       </TableCell>
//                       <TableCell align="center">
//                         {issue.status !== "closed" && (
//                           <IconButton sx={{ color: '#4caf50' }} onClick={() => handleQuickResolve(issue.id)}>
//                             <CheckCircleIcon />
//                           </IconButton>
//                         )}
//                       </TableCell>
//                     </TableRow>
//                   ))
//                 ) : (
//                   <TableRow>
//                     <TableCell colSpan={5} align="center" sx={{ color: '#666', py: 5 }}>
//                       {loading ? <CircularProgress size={24} /> : "No tasks assigned."}
//                     </TableCell>
//                   </TableRow>
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default IssuesScreen;



////////////////////////////////////////////////////////////////////////////////////

// import React, { useState, useEffect, useCallback } from "react";
// import {
//   TableContainer, Table, TableHead, TableRow, TableCell,
//   TableBody, Paper, Card, CardContent, Box, Typography,
//   Button, Chip, IconButton, CircularProgress
// } from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle"; 
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider"; 

// const IssuesScreen = () => {
//   const { user } = useStateContext(); 
//   const [issues, setIssues] = useState([]); 
//   const [loading, setLoading] = useState(false);

//   const fetchData = useCallback(async () => {
//     setIssues([]); 
//     setLoading(true);

//     try {
//       // 🛠️ We now call the dedicated list-data endpoint to get the formatted fields
//       const response = await axiosClient.get("api/issue-list-data/");
      
//       const rawData = Array.isArray(response.data) 
//         ? response.data 
//         : (response.data.results || []);

//       // 🛡️ Security Check: Double-filter locally to ensure zero "ghost" issues
//       let cleanData = [];
//       if (user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") {
//         cleanData = rawData.filter(item => 
//           Number(item.assigned_technician) === Number(user.id)
//         );
//       } else {
//         cleanData = rawData;
//       }

//       setIssues(cleanData);
      
//     } catch (err) { 
//       console.error("Fetch error:", err); 
//     } finally { 
//       setLoading(false); 
//     }
//   }, [user.id, user.user_role]);

//   useEffect(() => {
//     fetchData();
//   }, [fetchData]);

//   const handleQuickResolve = async (id) => {
//     if (window.confirm("Mark this task as completed?")) {
//       try {
//         const now = new Date().toISOString().slice(0, 16);
//         await axiosClient.post(`api/close-issue/${id}/`, { 
//           status: "closed", 
//           end_time: now,
//           comment: "Closed via Issue List" 
//         });
//         fetchData(); 
//       } catch (err) { 
//         alert("Update failed."); 
//       }
//     }
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Card sx={{ borderRadius: 3, bgcolor: '#1e1e1e', color: '#fff' }}>
//         <CardContent>
//           <Typography variant="h6" fontWeight="bold" mb={3} color="#90caf9">
//             {(user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") 
//               ? "My Assigned Tasks" 
//               : "Issue Management List"}
//           </Typography>

//           <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e' }}>
//             <Table>
//               <TableHead>
//                 <TableRow sx={{ bgcolor: '#333' }}>
//                   <TableCell sx={{ color: '#fff' }}>ID</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Room</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Title</TableCell>
//                   {/* 🛠️ RESTORED HEADERS */}
//                   <TableCell sx={{ color: '#fff' }}>Assigned Staff</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Date Started</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Date End</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Status</TableCell>
//                   <TableCell align="center" sx={{ color: '#fff' }}>Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {issues.length > 0 ? (
//                   issues.map((issue) => (
//                     <TableRow key={issue.id} hover>
//                       <TableCell sx={{ color: '#aaa' }}>#{issue.id}</TableCell>
//                       <TableCell sx={{ fontWeight: 'bold', color: '#90caf9' }}>{issue.room_number}</TableCell>
//                       <TableCell sx={{ color: '#fff' }}>{issue.title}</TableCell>
                      
//                       {/* 🛠️ RESTORED DATA CELLS */}
//                       <TableCell sx={{ color: '#fff' }}>{issue.staff_name}</TableCell>
//                       <TableCell sx={{ color: '#fff' }}>{issue.reported}</TableCell>
//                       <TableCell sx={{ color: '#fff' }}>{issue.finish_time}</TableCell>

//                       <TableCell>
//                           <Chip 
//                             label={issue.status} 
//                             size="small" 
//                             sx={{ color: issue.status === 'open' ? '#f44336' : '#4caf50', borderColor: issue.status === 'open' ? '#f44336' : '#4caf50' }} 
//                             variant="outlined" 
//                           />
//                       </TableCell>
//                       <TableCell align="center">
//                         {issue.status !== "closed" && (
//                           <IconButton sx={{ color: '#4caf50' }} onClick={() => handleQuickResolve(issue.id)}>
//                             <CheckCircleIcon />
//                           </IconButton>
//                         )}
//                       </TableCell>
//                     </TableRow>
//                   ))
//                 ) : (
//                   <TableRow>
//                     <TableCell colSpan={8} align="center" sx={{ color: '#666', py: 5 }}>
//                       {loading ? <CircularProgress size={24} /> : "No tasks assigned."}
//                     </TableCell>
//                   </TableRow>
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default IssuesScreen;

////////////////////////////////////////////////////////////////////////////////////
// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import {
//   TableContainer, Table, TableHead, TableRow, TableCell,
//   TableBody, Paper, Card, CardContent, Box, Typography,
//   Button, Chip, IconButton, CircularProgress, ButtonGroup
// } from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle"; 
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider"; 
// import dayjs from "dayjs";
// import customParseFormat from "dayjs/plugin/customParseFormat";

// // Required to parse your "DD-MM-YYYY" format
// dayjs.extend(customParseFormat);

// const IssuesScreen = () => {
//   const { user } = useStateContext(); 
//   const [issues, setIssues] = useState([]); 
//   const [loading, setLoading] = useState(false);
  
//   // 🛠️ NEW: State for Date Filtering
//   const [dateFilter, setDateFilter] = useState("all");

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await axiosClient.get("api/issue-list-data/");
      
//       const rawData = Array.isArray(response.data) 
//         ? response.data 
//         : (response.data.results || []);

//       let cleanData = [];
//       if (user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") {
//         cleanData = rawData.filter(item => 
//           Number(item.assigned_technician) === Number(user.id)
//         );
//       } else {
//         cleanData = rawData;
//       }
//       setIssues(cleanData);
      
//     } catch (err) { 
//       console.error("Fetch error:", err); 
//     } finally { 
//       setLoading(false); 
//     }
//   }, [user.id, user.user_role]);

//   useEffect(() => {
//     fetchData();
//   }, [fetchData]);

//   // 🛠️ NEW: Local Filter Logic
//   const filteredIssues = useMemo(() => {
//     if (dateFilter === "all") return issues;

//     const now = dayjs();
//     return issues.filter((issue) => {
//       // Parses your "14-03-2026 18:58" format
//       const issueDate = dayjs(issue.reported, "DD-MM-YYYY HH:mm");
      
//       if (dateFilter === "week") {
//         return issueDate.isAfter(now.subtract(7, "day"));
//       }
//       if (dateFilter === "month") {
//         return issueDate.isAfter(now.subtract(1, "month"));
//       }
//       if (dateFilter === "year") {
//         return issueDate.isAfter(now.subtract(1, "year"));
//       }
//       return true;
//     });
//   }, [issues, dateFilter]);

//   const handleQuickResolve = async (id) => {
//     if (window.confirm("Mark this task as completed?")) {
//       try {
//         const now = new Date().toISOString().slice(0, 16);
//         await axiosClient.post(`api/close-issue/${id}/`, { 
//           status: "closed", 
//           end_time: now,
//           comment: "Closed via Issue List" 
//         });
//         fetchData(); 
//       } catch (err) { 
//         alert("Update failed."); 
//       }
//     }
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Card sx={{ borderRadius: 3, bgcolor: '#1e1e1e', color: '#fff' }}>
//         <CardContent>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
//             <Typography variant="h6" fontWeight="bold" color="#90caf9">
//               {(user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") 
//                 ? "My Assigned Tasks" 
//                 : "Issue Management List"}
//             </Typography>

//             {/* 🛠️ NEW: Filter Button Group */}
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//               <Typography variant="caption" sx={{ color: '#aaa', fontWeight: 'bold', textTransform: 'uppercase' }}>
//                 Filter Period:
//               </Typography>
//               <ButtonGroup variant="outlined" size="small" sx={{ borderColor: '#333' }}>
//                 <Button 
//                   onClick={() => setDateFilter("all")} 
//                   sx={{ bgcolor: dateFilter === "all" ? "#90caf9" : "transparent", color: dateFilter === "all" ? "#000" : "#90caf9" }}
//                 >
//                   All
//                 </Button>
//                 <Button 
//                   onClick={() => setDateFilter("week")} 
//                   sx={{ bgcolor: dateFilter === "week" ? "#90caf9" : "transparent", color: dateFilter === "week" ? "#000" : "#90caf9" }}
//                 >
//                   Week
//                 </Button>
//                 <Button 
//                   onClick={() => setDateFilter("month")} 
//                   sx={{ bgcolor: dateFilter === "month" ? "#90caf9" : "transparent", color: dateFilter === "month" ? "#000" : "#90caf9" }}
//                 >
//                   Month
//                 </Button>
//                 <Button 
//                   onClick={() => setDateFilter("year")} 
//                   sx={{ bgcolor: dateFilter === "year" ? "#90caf9" : "transparent", color: dateFilter === "year" ? "#000" : "#90caf9" }}
//                 >
//                   Year
//                 </Button>
//               </ButtonGroup>
//             </Box>
//           </Box>

//           <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e', boxShadow: 'none' }}>
//             <Table>
//               <TableHead>
//                 <TableRow sx={{ bgcolor: '#333' }}>
//                   <TableCell sx={{ color: '#fff' }}>ID</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Room</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Title</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Assigned Staff</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Date Started</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Date End</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Status</TableCell>
//                   <TableCell align="center" sx={{ color: '#fff' }}>Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {filteredIssues.length > 0 ? (
//                   filteredIssues.map((issue) => (
//                     <TableRow key={issue.id} hover sx={{ '&:hover': { bgcolor: '#2a2a2a !important' } }}>
//                       <TableCell sx={{ color: '#aaa' }}>#{issue.id}</TableCell>
//                       <TableCell sx={{ fontWeight: 'bold', color: '#90caf9' }}>{issue.room_number}</TableCell>
//                       <TableCell sx={{ color: '#fff' }}>{issue.title}</TableCell>
//                       <TableCell sx={{ color: '#fff' }}>{issue.staff_name}</TableCell>
//                       <TableCell sx={{ color: '#fff' }}>{issue.reported}</TableCell>
//                       <TableCell sx={{ color: '#fff' }}>{issue.finish_time}</TableCell>
//                       <TableCell>
//                           <Chip 
//                             label={issue.status} 
//                             size="small" 
//                             sx={{ color: issue.status === 'open' ? '#f44336' : '#4caf50', borderColor: issue.status === 'open' ? '#f44336' : '#4caf50' }} 
//                             variant="outlined" 
//                           />
//                       </TableCell>
//                       <TableCell align="center">
//                         {issue.status !== "closed" && (
//                           <IconButton sx={{ color: '#4caf50' }} onClick={() => handleQuickResolve(issue.id)}>
//                             <CheckCircleIcon />
//                           </IconButton>
//                         )}
//                       </TableCell>
//                     </TableRow>
//                   ))
//                 ) : (
//                   <TableRow>
//                     <TableCell colSpan={8} align="center" sx={{ color: '#666', py: 5 }}>
//                       {loading ? <CircularProgress size={24} /> : "No tasks found for this period."}
//                     </TableCell>
//                   </TableRow>
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default IssuesScreen;



//////////////////////////////////////////////////////////////////////////////////////////////////////

// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import {
//   TableContainer, Table, TableHead, TableRow, TableCell,
//   TableBody, Paper, Card, CardContent, Box, Typography,
//   Button, Chip, IconButton, CircularProgress, ButtonGroup, Stack
// } from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import EditIcon from "@mui/icons-material/Edit"; // 🛠️ Added for Edit
// import DeleteIcon from "@mui/icons-material/Delete"; // 🛠️ Added for Delete
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider"; 
// import dayjs from "dayjs";
// import customParseFormat from "dayjs/plugin/customParseFormat";
// import AppointmentEditModal from "../components/AppointmentEditModal"; // 🛠️ Reusing your modal

// // Required to parse your "DD-MM-YYYY" format
// dayjs.extend(customParseFormat);

// const IssuesScreen = () => {
//   const { user } = useStateContext(); 
//   const [issues, setIssues] = useState([]); 
//   const [loading, setLoading] = useState(false);
//   const [dateFilter, setDateFilter] = useState("all");

//   // 🛠️ NEW: State for Edit Modal
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const [selectedIssueId, setSelectedIssueId] = useState(null);

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await axiosClient.get("api/issue-list-data/");
//       const rawData = Array.isArray(response.data) 
//         ? response.data 
//         : (response.data.results || []);

//       let cleanData = [];
//       if (user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") {
//         cleanData = rawData.filter(item => 
//           Number(item.assigned_technician) === Number(user.id)
//         );
//       } else {
//         cleanData = rawData;
//       }
//       setIssues(cleanData);
//     } catch (err) { 
//       console.error("Fetch error:", err); 
//     } finally { 
//       setLoading(false); 
//     }
//   }, [user.id, user.user_role]);

//   useEffect(() => {
//     fetchData();
//   }, [fetchData]);

//   const filteredIssues = useMemo(() => {
//     if (dateFilter === "all") return issues;
//     const now = dayjs();
//     return issues.filter((issue) => {
//       const issueDate = dayjs(issue.reported, "DD-MM-YYYY HH:mm");
//       if (dateFilter === "week") return issueDate.isAfter(now.subtract(7, "day"));
//       if (dateFilter === "month") return issueDate.isAfter(now.subtract(1, "month"));
//       if (dateFilter === "year") return issueDate.isAfter(now.subtract(1, "year"));
//       return true;
//     });
//   }, [issues, dateFilter]);

//   const handleQuickResolve = async (id) => {
//     if (window.confirm("Mark this task as completed?")) {
//       try {
//         const now = new Date().toISOString().slice(0, 16);
//         await axiosClient.post(`api/close-issue/${id}/`, { 
//           status: "closed", 
//           end_time: now,
//           comment: "Closed via Issue List" 
//         });
//         fetchData(); 
//       } catch (err) { 
//         alert("Update failed."); 
//       }
//     }
//   };

//   // 🛠️ NEW: Handle Delete Issue
//   const handleDeleteIssue = async (id) => {
//     if (window.confirm("Are you sure you want to PERMANENTLY delete this issue?")) {
//       try {
//         await axiosClient.delete(`api/issues/${id}/`);
//         fetchData();
//       } catch (err) {
//         alert("Delete failed.");
//       }
//     }
//   };

//   // 🛠️ NEW: Open Edit Modal
//   const handleEditClick = (id) => {
//     setSelectedIssueId(id);
//     setOpenEditModal(true);
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Card sx={{ borderRadius: 3, bgcolor: '#1e1e1e', color: '#fff' }}>
//         <CardContent>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
//             <Typography variant="h6" fontWeight="bold" color="#90caf9">
//               {(user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") 
//                 ? "My Assigned Tasks" 
//                 : "Issue Management List"}
//             </Typography>

//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//               <Typography variant="caption" sx={{ color: '#aaa', fontWeight: 'bold', textTransform: 'uppercase' }}>
//                 Filter Period:
//               </Typography>
//               <ButtonGroup variant="outlined" size="small" sx={{ borderColor: '#333' }}>
//                 {["all", "week", "month", "year"].map((period) => (
//                   <Button 
//                     key={period}
//                     onClick={() => setDateFilter(period)} 
//                     sx={{ 
//                       bgcolor: dateFilter === period ? "#90caf9" : "transparent", 
//                       color: dateFilter === period ? "#000" : "#90caf9",
//                       textTransform: 'capitalize'
//                     }}
//                   >
//                     {period}
//                   </Button>
//                 ))}
//               </ButtonGroup>
//             </Box>
//           </Box>

//           <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e', boxShadow: 'none' }}>
//             <Table>
//               <TableHead>
//                 <TableRow sx={{ bgcolor: '#333' }}>
//                   <TableCell sx={{ color: '#fff' }}>ID</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Room</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Title</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Assigned Staff</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Date Started</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Date End</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Status</TableCell>
//                   <TableCell align="center" sx={{ color: '#fff' }}>Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {filteredIssues.length > 0 ? (
//                   filteredIssues.map((issue) => (
//                     <TableRow key={issue.id} hover sx={{ '&:hover': { bgcolor: '#2a2a2a !important' } }}>
//                       <TableCell sx={{ color: '#aaa' }}>#{issue.id}</TableCell>
//                       <TableCell sx={{ fontWeight: 'bold', color: '#90caf9' }}>{issue.room_number}</TableCell>
//                       <TableCell sx={{ color: '#fff' }}>{issue.title}</TableCell>
//                       <TableCell sx={{ color: '#fff' }}>{issue.staff_name}</TableCell>
//                       <TableCell sx={{ color: '#fff' }}>{issue.reported}</TableCell>
//                       <TableCell sx={{ color: '#fff' }}>{issue.finish_time}</TableCell>
//                       <TableCell>
//                           <Chip 
//                             label={issue.status} 
//                             size="small" 
//                             sx={{ color: issue.status === 'open' ? '#f44336' : '#4caf50', borderColor: issue.status === 'open' ? '#f44336' : '#4caf50' }} 
//                             variant="outlined" 
//                           />
//                       </TableCell>
//                       <TableCell align="center">
//                         <Stack direction="row" spacing={0.5} justifyContent="center">
//                           {/* 🛠️ QUICK RESOLVE (Visible to all assigned staff) */}
//                           {issue.status !== "closed" && (
//                             <IconButton sx={{ color: '#4caf50' }} onClick={() => handleQuickResolve(issue.id)}>
//                               <CheckCircleIcon fontSize="small" />
//                             </IconButton>
//                           )}

//                           {/* 🛠️ EDIT BUTTON (Visible to Admin & Reception) */}
//                           {(user?.user_role === "ADMIN" || user?.user_role === "RECEPTION") && (
//                             <IconButton sx={{ color: '#90caf9' }} onClick={() => handleEditClick(issue.id)}>
//                               <EditIcon fontSize="small" />
//                             </IconButton>
//                           )}

//                           {/* 🛠️ DELETE BUTTON (Visible to Admin Only) */}
//                           {user?.user_role === "ADMIN" && (
//                             <IconButton sx={{ color: '#f44336' }} onClick={() => handleDeleteIssue(issue.id)}>
//                               <DeleteIcon fontSize="small" />
//                             </IconButton>
//                           )}
//                         </Stack>
//                       </TableCell>
//                     </TableRow>
//                   ))
//                 ) : (
//                   <TableRow>
//                     <TableCell colSpan={8} align="center" sx={{ color: '#666', py: 5 }}>
//                       {loading ? <CircularProgress size={24} /> : "No tasks found for this period."}
//                     </TableCell>
//                   </TableRow>
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>

//       {/* 🛠️ MODAL FOR EDITING */}
//       <AppointmentEditModal 
//         open={openEditModal} 
//         id={selectedIssueId} 
//         handleClose={() => setOpenEditModal(false)} 
//         refresh={fetchData} 
//       />
//     </Box>
//   );
// };

// export default IssuesScreen;






//////////////////////////////////

// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import {
//   TableContainer, Table, TableHead, TableRow, TableCell,
//   TableBody, Paper, Card, CardContent, Box, Typography,
//   Button, Chip, IconButton, CircularProgress, ButtonGroup, Stack
// } from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider"; 
// import dayjs from "dayjs";
// import customParseFormat from "dayjs/plugin/customParseFormat";
// import { useTranslation } from "react-i18next"; // 🛠️ FIXED: Added this import

// // 🛠️ Import the Edit Modal
// import AppointmentEditModal from "../components/AppointmentEditModal";

// dayjs.extend(customParseFormat);

// const IssuesScreen = () => {
//   const { t } = useTranslation(); // 🛠️ FIXED: Initialized the translation function
//   const { user } = useStateContext(); 
//   const [issues, setIssues] = useState([]); 
//   const [loading, setLoading] = useState(false);
//   const [dateFilter, setDateFilter] = useState("all");

//   // State for Modal Control
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const [selectedIssueId, setSelectedIssueId] = useState(null);

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await axiosClient.get("api/issue-list-data/");
//       const rawData = Array.isArray(response.data) 
//         ? response.data 
//         : (response.data.results || []);

//       let cleanData = [];
//       if (user?.user_role === "TECHNICIAN" || user?.user_role === "MAID") {
//         cleanData = rawData.filter(item => 
//           Number(item.assigned_technician) === Number(user.id)
//         );
//       } else {
//         cleanData = rawData;
//       }
//       setIssues(cleanData);
//     } catch (err) { 
//       console.error("Fetch error:", err); 
//     } finally { 
//       setLoading(false); 
//     }
//   }, [user.id, user.user_role]);

//   useEffect(() => {
//     fetchData();
//   }, [fetchData]);

//   const filteredIssues = useMemo(() => {
//     if (dateFilter === "all") return issues;
//     const now = dayjs();
//     return issues.filter((issue) => {
//       const issueDate = dayjs(issue.reported, "DD-MM-YYYY HH:mm");
//       if (dateFilter === "week") return issueDate.isAfter(now.subtract(7, "day"));
//       if (dateFilter === "month") return issueDate.isAfter(now.subtract(1, "month"));
//       if (dateFilter === "year") return issueDate.isAfter(now.subtract(1, "year"));
//       return true;
//     });
//   }, [issues, dateFilter]);

//   const handleEditClick = (id) => {
//     setSelectedIssueId(id);
//     setOpenEditModal(true);
//   };

//   const handleDeleteIssue = async (id) => {
//     if (window.confirm(t("Are you sure you want to delete this issue?"))) {
//       try {
//         await axiosClient.delete(`api/issues/${id}/`);
//         fetchData();
//       } catch (err) {
//         alert("Delete failed.");
//       }
//     }
//   };

//   const handleQuickResolve = async (id) => {
//     if (window.confirm(t("Mark this task as completed?"))) {
//       try {
//         const now = new Date().toISOString().slice(0, 16);
//         await axiosClient.post(`api/close-issue/${id}/`, { 
//           status: "closed", 
//           end_time: now,
//           comment: "Closed via Issue List" 
//         });
//         fetchData(); 
//       } catch (err) { 
//         alert("Update failed."); 
//       }
//     }
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Card sx={{ borderRadius: 3, bgcolor: '#1e1e1e', color: '#fff' }}>
//         <CardContent>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
//             <Typography variant="h6" fontWeight="bold" color="#90caf9">
//               {t("Issue Management List")}
//             </Typography>

//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//               <ButtonGroup variant="outlined" size="small" sx={{ borderColor: '#333' }}>
//                 {["all", "week", "month", "year"].map((f) => (
//                   <Button 
//                     key={f} 
//                     onClick={() => setDateFilter(f)} 
//                     sx={{ bgcolor: dateFilter === f ? "#90caf9" : "transparent", color: dateFilter === f ? "#000" : "#90caf9" }}
//                   >
//                     {t(f.toUpperCase())}
//                   </Button>
//                 ))}
//               </ButtonGroup>
//             </Box>
//           </Box>

//           <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e', boxShadow: 'none' }}>
//             <Table>
//               <TableHead>
//                 <TableRow sx={{ bgcolor: '#333' }}>
//                   <TableCell sx={{ color: '#fff' }}>{t("ID")}</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>{t("Room")}</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>{t("Title")}</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>{t("Assigned Staff")}</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>{t("Date Started")}</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>{t("Date End")}</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>{t("Status")}</TableCell>
//                   <TableCell align="center" sx={{ color: '#fff' }}>{t("Action")}</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {filteredIssues.length > 0 ? (
//                   filteredIssues.map((issue) => (
//                     <TableRow key={issue.id} hover sx={{ '&:hover': { bgcolor: '#2a2a2a !important' } }}>
//                       <TableCell sx={{ color: '#aaa' }}>#{issue.id}</TableCell>
//                       <TableCell sx={{ fontWeight: 'bold', color: '#90caf9' }}>{issue.room_number}</TableCell>
//                       <TableCell sx={{ color: '#fff' }}>{issue.title}</TableCell>
//                       <TableCell sx={{ color: '#fff' }}>{issue.staff_name}</TableCell>
//                       <TableCell sx={{ color: '#fff' }}>{issue.reported}</TableCell>
//                       <TableCell sx={{ color: '#fff' }}>{issue.finish_time}</TableCell>
//                       <TableCell>
//                         <Chip label={t(issue.status)} size="small" variant="outlined" sx={{ color: issue.status === 'open' ? '#f44336' : '#4caf50', borderColor: issue.status === 'open' ? '#f44336' : '#4caf50' }} />
//                       </TableCell>
//                       <TableCell align="center">
//                         <Stack direction="row" spacing={1} justifyContent="center">
//                           {/* 🛠️ EDIT (Admin & Reception) */}
//                           {(user?.user_role === "ADMIN" || user?.user_role === "RECEPTION") && (
//                             <IconButton sx={{ color: '#90caf9' }} onClick={() => handleEditClick(issue.id)}>
//                               <EditIcon fontSize="small" />
//                             </IconButton>
//                           )}

//                           {/* 🛠️ DELETE (Admin Only) */}
//                           {user?.user_role === "ADMIN" && (
//                             <IconButton sx={{ color: '#f44336' }} onClick={() => handleDeleteIssue(issue.id)}>
//                               <DeleteIcon fontSize="small" />
//                             </IconButton>
//                           )}
                          
//                           {issue.status !== "closed" && (
//                             <IconButton sx={{ color: '#4caf50' }} onClick={() => handleQuickResolve(issue.id)}>
//                               <CheckCircleIcon fontSize="small" />
//                             </IconButton>
//                           )}
//                         </Stack>
//                       </TableCell>
//                     </TableRow>
//                   ))
//                 ) : (
//                   <TableRow>
//                     <TableCell colSpan={8} align="center" sx={{ py: 5, color: '#666' }}>
//                        {loading ? <CircularProgress size={24} /> : t("No tasks found")}
//                     </TableCell>
//                   </TableRow>
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>

//       {/* 🛠️ MODAL POPUP */}
//       <AppointmentEditModal 
//         open={openEditModal} 
//         id={selectedIssueId} 
//         handleClose={() => setOpenEditModal(false)} 
//         refresh={fetchData} 
//       />
//     </Box>
//   );
// };

// export default IssuesScreen;



//////////////////

// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import {
//   TableContainer, Table, TableHead, TableRow, TableCell,
//   TableBody, Paper, Card, CardContent, Box, Typography,
//   Button, Chip, IconButton, CircularProgress, ButtonGroup, Stack
// } from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider"; 
// import dayjs from "dayjs";
// import customParseFormat from "dayjs/plugin/customParseFormat";
// import { useTranslation } from "react-i18next";
// import AppointmentEditModal from "../components/AppointmentEditModal";

// dayjs.extend(customParseFormat);

// const IssuesScreen = () => {
//   const { t } = useTranslation();
//   const { user } = useStateContext(); 
//   const [issues, setIssues] = useState([]); 
//   const [loading, setLoading] = useState(false);
//   const [dateFilter, setDateFilter] = useState("all");
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const [selectedIssueId, setSelectedIssueId] = useState(null);

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await axiosClient.get("api/issue-list-data/");
//       const rawData = Array.isArray(response.data) ? response.data : (response.data.results || []);
//       const cleanData = (user?.user_role === "TECHNICIAN" || user?.user_role === "MAID")
//         ? rawData.filter(item => Number(item.assigned_technician) === Number(user.id))
//         : rawData;
//       setIssues(cleanData);
//     } catch (err) { console.error("Fetch error:", err); } 
//     finally { setLoading(false); }
//   }, [user.id, user.user_role]);

//   useEffect(() => { fetchData(); }, [fetchData]);

//   const handleQuickResolve = async (id) => {
//     if (window.confirm(t("Mark this task as completed?"))) {
//       try {
//         // 🛠️ TIMEZONE RESOLUTION:
//         const realTime = dayjs().format("YYYY-MM-DD HH:mm");
//         const utcTime = new Date().toISOString();
        
//         console.log("PC Real Time (Sending to DB):", realTime);
//         console.log("UTC Time (Ignored):", utcTime);

//         await axiosClient.post(`api/close-issue/${id}/`, { 
//           status: "closed", 
//           end_time: realTime, // Send local time string to prevent 2-hour drop
//           comment: "Closed via Quick Resolve" 
//         });
//         fetchData(); 
//       } catch (err) { alert("Update failed."); }
//     }
//   };

//   const handleEditClick = (id) => { setSelectedIssueId(id); setOpenEditModal(true); };

//   const handleDeleteIssue = async (id) => {
//     if (window.confirm(t("Are you sure?"))) {
//       try { await axiosClient.delete(`api/issues/${id}/`); fetchData(); } catch (err) { alert("Delete failed."); }
//     }
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Card sx={{ borderRadius: 3, bgcolor: '#1e1e1e', color: '#fff' }}>
//         <CardContent>
//           <Typography variant="h6" fontWeight="bold" color="#90caf9" sx={{ mb: 3 }}>
//             {t("Issue Management List")}
//           </Typography>
//           <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e', boxShadow: 'none' }}>
//             <Table>
//               <TableHead>
//                 <TableRow sx={{ bgcolor: '#333' }}>
//                   <TableCell sx={{ color: '#fff' }}>ID</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Room</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Title</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Staff</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Started</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>End</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Status</TableCell>
//                   <TableCell align="center" sx={{ color: '#fff' }}>Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {issues.map((issue) => (
//                   <TableRow key={issue.id} hover sx={{ '&:hover': { bgcolor: '#2a2a2a !important' } }}>
//                     <TableCell sx={{ color: '#aaa' }}>#{issue.id}</TableCell>
//                     <TableCell sx={{ color: '#90caf9', fontWeight: 'bold' }}>{issue.room_number}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.title}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.staff_name}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.reported}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.finish_time}</TableCell>
//                     <TableCell>
//                       <Chip label={issue.status} size="small" variant="outlined" sx={{ color: issue.status === 'open' ? '#f44336' : '#4caf50' }} />
//                     </TableCell>
//                     <TableCell align="center">
//                       <Stack direction="row" spacing={1} justifyContent="center">
//                         <IconButton sx={{ color: '#90caf9' }} onClick={() => handleEditClick(issue.id)}><EditIcon fontSize="small" /></IconButton>
//                         {user?.user_role === "ADMIN" && (
//                           <IconButton sx={{ color: '#f44336' }} onClick={() => handleDeleteIssue(issue.id)}><DeleteIcon fontSize="small" /></IconButton>
//                         )}
//                         {issue.status !== "closed" && (
//                           <IconButton sx={{ color: '#4caf50' }} onClick={() => handleQuickResolve(issue.id)}><CheckCircleIcon fontSize="small" /></IconButton>
//                         )}
//                       </Stack>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>
//       <AppointmentEditModal open={openEditModal} id={selectedIssueId} handleClose={() => setOpenEditModal(false)} refresh={fetchData} />
//     </Box>
//   );
// };

// export default IssuesScreen;

/////////////////////////////////////

// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import {
//   TableContainer, Table, TableHead, TableRow, TableCell,
//   TableBody, Paper, Card, CardContent, Box, Typography,
//   Button, Chip, IconButton, CircularProgress, ButtonGroup, Stack
// } from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider"; 
// import dayjs from "dayjs";
// import customParseFormat from "dayjs/plugin/customParseFormat";
// import { useTranslation } from "react-i18next";
// import AppointmentEditModal from "../components/AppointmentEditModal";

// dayjs.extend(customParseFormat);

// const IssuesScreen = () => {
//   const { t } = useTranslation();
//   const { user } = useStateContext(); 
//   const [issues, setIssues] = useState([]); 
//   const [loading, setLoading] = useState(false);
//   const [dateFilter, setDateFilter] = useState("all");
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const [selectedIssueId, setSelectedIssueId] = useState(null);

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await axiosClient.get("api/issue-list-data/");
//       const rawData = Array.isArray(response.data) ? response.data : (response.data.results || []);
//       setIssues(rawData);
//     } catch (err) { console.error("Fetch error:", err); } 
//     finally { setLoading(false); }
//   }, []);

//   useEffect(() => { fetchData(); }, [fetchData]);

//   const handleQuickResolve = async (id) => {
//     if (window.confirm(t("Mark this task as completed?"))) {
//       try {
//         // 🛠️ FIX: Using .format() grabs your computer time (20:48) 
//         // and sends it as a string so the server doesn't change it.
//         const nowLocal = dayjs().format("YYYY-MM-DD HH:mm");
        
//         await axiosClient.post(`api/close-issue/${id}/`, { 
//           status: "closed", 
//           end_time: nowLocal,
//           comment: "Closed via List" 
//         });
//         fetchData(); 
//       } catch (err) { alert("Update failed."); }
//     }
//   };

//   const handleEditClick = (id) => { setSelectedIssueId(id); setOpenEditModal(true); };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Card sx={{ borderRadius: 3, bgcolor: '#1e1e1e', color: '#fff' }}>
//         <CardContent>
//           <Typography variant="h6" fontWeight="bold" color="#90caf9" sx={{ mb: 3 }}>{t("Issue Management List")}</Typography>
//           <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e', boxShadow: 'none' }}>
//             <Table>
//               <TableHead>
//                 <TableRow sx={{ bgcolor: '#333' }}>
//                   <TableCell sx={{ color: '#fff' }}>ID</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Room</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Title</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Date Started</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Date End</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Status</TableCell>
//                   <TableCell align="center" sx={{ color: '#fff' }}>Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {issues.map((issue) => (
//                   <TableRow key={issue.id} hover sx={{ '&:hover': { bgcolor: '#2a2a2a' } }}>
//                     <TableCell sx={{ color: '#aaa' }}>#{issue.id}</TableCell>
//                     <TableCell sx={{ color: '#90caf9', fontWeight: 'bold' }}>{issue.room_number}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.title}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.reported}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.finish_time}</TableCell>
//                     <TableCell>
//                       <Chip label={issue.status} size="small" variant="outlined" sx={{ color: issue.status === 'open' ? '#f44336' : '#4caf50', borderColor: issue.status === 'open' ? '#f44336' : '#4caf50' }} />
//                     </TableCell>
//                     <TableCell align="center">
//                       <Stack direction="row" spacing={1} justifyContent="center">
//                         <IconButton sx={{ color: '#90caf9' }} onClick={() => handleEditClick(issue.id)}><EditIcon fontSize="small" /></IconButton>
//                         {issue.status !== "closed" && (
//                           <IconButton sx={{ color: '#4caf50' }} onClick={() => handleQuickResolve(issue.id)}><CheckCircleIcon fontSize="small" /></IconButton>
//                         )}
//                       </Stack>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>
//       <AppointmentEditModal open={openEditModal} id={selectedIssueId} handleClose={() => setOpenEditModal(false)} refresh={fetchData} />
//     </Box>
//   );
// };

// export default IssuesScreen;


////////////////////////


// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import {
//   TableContainer, Table, TableHead, TableRow, TableCell,
//   TableBody, Paper, Card, CardContent, Box, Typography,
//   Button, Chip, IconButton, CircularProgress, ButtonGroup, Stack
// } from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider"; 
// import dayjs from "dayjs";
// import customParseFormat from "dayjs/plugin/customParseFormat";
// import { useTranslation } from "react-i18next";
// import AppointmentEditModal from "../components/AppointmentEditModal";

// dayjs.extend(customParseFormat);

// const IssuesScreen = () => {
//   const { t } = useTranslation();
//   const { user } = useStateContext(); 
//   const [issues, setIssues] = useState([]); 
//   const [loading, setLoading] = useState(false);
//   const [dateFilter, setDateFilter] = useState("all");
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const [selectedIssueId, setSelectedIssueId] = useState(null);

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await axiosClient.get("api/issue-list-data/");
//       const rawData = Array.isArray(response.data) ? response.data : (response.data.results || []);
//       setIssues(rawData);
//     } catch (err) { console.error("Fetch error:", err); } 
//     finally { setLoading(false); }
//   }, []);

//   useEffect(() => { fetchData(); }, [fetchData]);

//   const handleQuickResolve = async (id) => {
//     if (window.confirm(t("Mark this task as completed?"))) {
//       try {
//         // 🛠️ FIX: Use .format() to send your LOCAL time (e.g. 20:12) to the server
//         const nowLocal = dayjs().format("YYYY-MM-DD HH:mm");
        
//         await axiosClient.post(`api/close-issue/${id}/`, { 
//           status: "closed", 
//           end_time: nowLocal,
//           comment: "Closed via List" 
//         });
//         fetchData(); 
//       } catch (err) { alert("Update failed."); }
//     }
//   };

//   const handleEditClick = (id) => {
//     setSelectedIssueId(id);
//     setOpenEditModal(true);
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Card sx={{ borderRadius: 3, bgcolor: '#1e1e1e', color: '#fff' }}>
//         <CardContent>
//           <Typography variant="h6" fontWeight="bold" color="#90caf9" sx={{ mb: 3 }}>
//             {t("Issue Management List")}
//           </Typography>
//           <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e', boxShadow: 'none' }}>
//             <Table>
//               <TableHead>
//                 <TableRow sx={{ bgcolor: '#333' }}>
//                   <TableCell sx={{ color: '#fff' }}>ID</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Room</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Title</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Date Started</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Date End</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Status</TableCell>
//                   <TableCell align="center" sx={{ color: '#fff' }}>Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {issues.map((issue) => (
//                   <TableRow key={issue.id} hover sx={{ '&:hover': { bgcolor: '#2a2a2a' } }}>
//                     <TableCell sx={{ color: '#aaa' }}>#{issue.id}</TableCell>
//                     <TableCell sx={{ color: '#90caf9', fontWeight: 'bold' }}>{issue.room_number}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.title}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.reported}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.finish_time}</TableCell>
//                     <TableCell>
//                       <Chip label={issue.status} size="small" variant="outlined" 
//                         sx={{ color: issue.status === 'open' ? '#f44336' : '#4caf50', borderColor: issue.status === 'open' ? '#f44336' : '#4caf50' }} />
//                     </TableCell>
//                     <TableCell align="center">
//                       <Stack direction="row" spacing={1} justifyContent="center">
//                         <IconButton sx={{ color: '#90caf9' }} onClick={() => handleEditClick(issue.id)}><EditIcon fontSize="small" /></IconButton>
//                         {issue.status !== "closed" && (
//                           <IconButton sx={{ color: '#4caf50' }} onClick={() => handleQuickResolve(issue.id)}><CheckCircleIcon fontSize="small" /></IconButton>
//                         )}
//                       </Stack>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>
//       <AppointmentEditModal open={openEditModal} id={selectedIssueId} handleClose={() => setOpenEditModal(false)} refresh={fetchData} />
//     </Box>
//   );
// };

// export default IssuesScreen;


// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import {
//   TableContainer, Table, TableHead, TableRow, TableCell,
//   TableBody, Paper, Card, CardContent, Box, Typography,
//   Button, Chip, IconButton, CircularProgress, ButtonGroup, Stack
// } from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider"; 
// import dayjs from "dayjs";
// import customParseFormat from "dayjs/plugin/customParseFormat";
// import { useTranslation } from "react-i18next";
// import AppointmentEditModal from "../components/AppointmentEditModal";

// dayjs.extend(customParseFormat);

// const IssuesScreen = () => {
//   const { t } = useTranslation();
//   const { user } = useStateContext(); 
//   const [issues, setIssues] = useState([]); 
//   const [loading, setLoading] = useState(false);
//   const [dateFilter, setDateFilter] = useState("all");
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const [selectedIssueId, setSelectedIssueId] = useState(null);

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await axiosClient.get("api/issue-list-data/");
//       const rawData = Array.isArray(response.data) ? response.data : (response.data.results || []);
//       setIssues(rawData);
//     } catch (err) { console.error("Fetch error:", err); } 
//     finally { setLoading(false); }
//   }, []);

//   useEffect(() => { fetchData(); }, [fetchData]);

//   const handleQuickResolve = async (id) => {
//     if (window.confirm(t("Mark this task as completed?"))) {
//       try {
//         // 🛠️ TIMEZONE FIX: Grabs 21:30 if your PC says 21:30. No UTC conversion.
//         const nowLocal = dayjs().format("YYYY-MM-DD HH:mm");
        
//         await axiosClient.post(`api/close-issue/${id}/`, { 
//           status: "closed", 
//           end_time: nowLocal,
//           comment: "Closed via List" 
//         });
//         fetchData(); 
//       } catch (err) { alert("Update failed."); }
//     }
//   };

//   const handleEditClick = (id) => {
//     setSelectedIssueId(id);
//     setOpenEditModal(true);
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Card sx={{ borderRadius: 3, bgcolor: '#1e1e1e', color: '#fff' }}>
//         <CardContent>
//           <Typography variant="h6" fontWeight="bold" color="#90caf9" sx={{ mb: 3 }}>
//             {t("Issue Management List")}
//           </Typography>
//           <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e', boxShadow: 'none' }}>
//             <Table>
//               <TableHead>
//                 <TableRow sx={{ bgcolor: '#333' }}>
//                   <TableCell sx={{ color: '#fff' }}>ID</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Room</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Title</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Started</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>End</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>Status</TableCell>
//                   <TableCell align="center" sx={{ color: '#fff' }}>Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {issues.map((issue) => (
//                   <TableRow key={issue.id} hover sx={{ '&:hover': { bgcolor: '#2a2a2a' } }}>
//                     <TableCell sx={{ color: '#aaa' }}>#{issue.id}</TableCell>
//                     <TableCell sx={{ color: '#90caf9', fontWeight: 'bold' }}>{issue.room_number}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.title}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.reported}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.finish_time}</TableCell>
//                     <TableCell>
//                       <Chip label={issue.status} size="small" variant="outlined" 
//                         sx={{ color: issue.status === 'open' ? '#f44336' : '#4caf50', borderColor: issue.status === 'open' ? '#f44336' : '#4caf50' }} />
//                     </TableCell>
//                     <TableCell align="center">
//                       <Stack direction="row" spacing={1} justifyContent="center">
//                         <IconButton sx={{ color: '#90caf9' }} onClick={() => handleEditClick(issue.id)}><EditIcon fontSize="small" /></IconButton>
//                         {issue.status !== "closed" && (
//                           <IconButton sx={{ color: '#4caf50' }} onClick={() => handleQuickResolve(issue.id)}><CheckCircleIcon fontSize="small" /></IconButton>
//                         )}
//                       </Stack>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>
//       <AppointmentEditModal open={openEditModal} id={selectedIssueId} handleClose={() => setOpenEditModal(false)} refresh={fetchData} />
//     </Box>
//   );
// };

// export default IssuesScreen;




////////////////////////////////////////////////////////////////////////////////////////////////////////


// import React, { useState, useEffect, useCallback } from "react";
// import {
//   TableContainer, Table, TableHead, TableRow, TableCell,
//   TableBody, Paper, Card, CardContent, Box, Typography,
//   Chip, IconButton, Stack, Tooltip
// } from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";
// import AppointmentEditModal from "../components/AppointmentEditModal";
// import { useStateContext } from "../context/ContextProvider";

// const IssuesScreen = () => {
//   const { t } = useTranslation();
//   const { user } = useStateContext(); 
//   const [issues, setIssues] = useState([]); 
//   const [loading, setLoading] = useState(false);
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const [selectedIssueId, setSelectedIssueId] = useState(null);

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await axiosClient.get("api/issue-list-data/");
//       const rawData = Array.isArray(response.data) ? response.data : (response.data.results || []);
//       setIssues(rawData);
//     } catch (err) { console.error("Fetch error:", err); } 
//     finally { setLoading(false); }
//   }, []);

//   useEffect(() => { fetchData(); }, [fetchData]);

//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this issue?")) {
//       try {
//         await axiosClient.delete(`api/issues/${id}/`);
//         fetchData(); 
//       } catch (err) { alert("Delete failed"); }
//     }
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Card sx={{ bgcolor: '#1e1e1e', color: '#fff', borderRadius: 2 }}>
//         <CardContent>
//           <Typography variant="h6" color="#90caf9" sx={{ mb: 3, textAlign: 'center' }}>
//             Issue Management List
//           </Typography>
//           <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e', boxShadow: 'none' }}>
//             <Table size="small">
//               <TableHead>
//                 <TableRow sx={{ borderBottom: '1px solid #444' }}>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Room</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Title</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Assigned To</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Started</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>End</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Status</TableCell>
//                   <TableCell align="center" sx={{ color: '#fff', fontWeight: 'bold' }}>Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {issues.map((issue) => (
//                   <TableRow key={issue.id} sx={{ '& td': { borderBottom: '1px solid #333' } }}>
//                     <TableCell sx={{ color: '#90caf9', fontWeight: 'bold' }}>{issue.room_number}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.title}</TableCell>
                    
//                     {/* FIXED: Showing Staff Name + Role correctly */}
//                     <TableCell sx={{ color: '#fff' }}>
//                       {issue.staff_name ? (
//                         `${issue.staff_name} (${issue.assigned_technician_info?.user_role || ''})`
//                       ) : "Unassigned"}
//                     </TableCell>

//                     <TableCell sx={{ color: '#fff' }}>{issue.reported || issue.appt_start?.replace('T', ' ').substring(0,16)}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.finish_time || "-"}</TableCell>
//                     <TableCell>
//                       <Chip 
//                         label={issue.status} 
//                         size="small" 
//                         variant="outlined" 
//                         sx={{ 
//                           color: issue.status === 'open' ? '#f44336' : '#4caf50', 
//                           borderColor: issue.status === 'open' ? '#f44336' : '#4caf50' 
//                         }} 
//                       />
//                     </TableCell>
//                     <TableCell align="center">
//                       <Stack direction="row" spacing={1} justifyContent="center">
//                         <Tooltip title="Edit">
//                           <IconButton sx={{ color: '#90caf9' }} onClick={() => { setSelectedIssueId(issue.id); setOpenEditModal(true); }}>
//                             <EditIcon fontSize="small" />
//                           </IconButton>
//                         </Tooltip>
                        
//                         {/* THE DELETE BUTTON IS BACK */}
//                         <Tooltip title="Delete">
//                           <IconButton sx={{ color: '#f44336' }} onClick={() => handleDelete(issue.id)}>
//                             <DeleteIcon fontSize="small" />
//                           </IconButton>
//                         </Tooltip>
//                       </Stack>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>
//       <AppointmentEditModal open={openEditModal} id={selectedIssueId} handleClose={() => setOpenEditModal(false)} refresh={fetchData} />
//     </Box>
//   );
// };

// export default IssuesScreen;




// ////////////////////////////////////////////////18_03_2026/////////////////////////////////////////////////////

// import React, { useState, useEffect, useCallback } from "react";
// import {
//   TableContainer, Table, TableHead, TableRow, TableCell,
//   TableBody, Paper, Card, CardContent, Box, Typography,
//   Chip, IconButton, Stack, Tooltip
// } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";
// import AppointmentEditModal from "../components/AppointmentEditModal";
// import { useStateContext } from "../context/ContextProvider";

// const IssuesScreen = () => {
//   const { t } = useTranslation();
//   const { user } = useStateContext(); 
//   const [issues, setIssues] = useState([]); 
//   const [loading, setLoading] = useState(false);
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const [selectedIssueId, setSelectedIssueId] = useState(null);

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await axiosClient.get("api/issue-list-data/");
//       const rawData = Array.isArray(response.data) ? response.data : (response.data.results || []);
//       setIssues(rawData);
//     } catch (err) { console.error("Fetch error:", err); } 
//     finally { setLoading(false); }
//   }, []);

//   useEffect(() => { fetchData(); }, [fetchData]);

//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this issue?")) {
//       try {
//         await axiosClient.delete(`api/issues/${id}/`);
//         fetchData(); 
//       } catch (err) { alert("Delete failed"); }
//     }
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Card sx={{ bgcolor: '#1e1e1e', color: '#fff', borderRadius: 2 }}>
//         <CardContent>
//           <Typography variant="h6" color="#90caf9" sx={{ mb: 3, textAlign: 'center' }}>
//             Issue Management List
//           </Typography>
//           <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e', boxShadow: 'none' }}>
//             <Table size="small">
//               <TableHead>
//                 <TableRow sx={{ borderBottom: '1px solid #444' }}>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Room</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Title</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Assigned To</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Started</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>End</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Status</TableCell>
//                   <TableCell align="center" sx={{ color: '#fff', fontWeight: 'bold' }}>Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {issues.map((issue) => (
//                   <TableRow key={issue.id} sx={{ '& td': { borderBottom: '1px solid #333' } }}>
//                     <TableCell sx={{ color: '#90caf9', fontWeight: 'bold' }}>{issue.room_number}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.title}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>
//                       {issue.staff_name || "Unassigned"}
//                     </TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.reported || issue.appt_start?.replace('T', ' ').substring(0,16)}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.finish_time || "-"}</TableCell>

//                     {/* ✅ Status column: shows closed chip + admin badge if applicable */}
//                     <TableCell>
//                       <Stack spacing={0.5} alignItems="flex-start">
//                         <Chip 
//                           label={issue.status} 
//                           size="small" 
//                           variant="outlined" 
//                           sx={{ 
//                             color: issue.status === 'open' ? '#f44336' : '#4caf50', 
//                             borderColor: issue.status === 'open' ? '#f44336' : '#4caf50' 
//                           }} 
//                         />
//                         {/* ✅ Only shows when an admin/reception closed the task */}
//                         {issue.closed_by_admin && (
//                           <Chip
//                             label={`Closed by: ${issue.closed_by_admin}`}
//                             size="small"
//                             sx={{
//                               bgcolor: '#1565c0',
//                               color: '#fff',
//                               fontSize: '0.65rem',
//                               height: '18px',
//                             }}
//                           />
//                         )}
//                       </Stack>
//                     </TableCell>

//                     <TableCell align="center">
//                       <Stack direction="row" spacing={1} justifyContent="center">
//                         <Tooltip title="Edit">
//                           <IconButton sx={{ color: '#90caf9' }} onClick={() => { setSelectedIssueId(issue.id); setOpenEditModal(true); }}>
//                             <EditIcon fontSize="small" />
//                           </IconButton>
//                         </Tooltip>
//                         <Tooltip title="Delete">
//                           <IconButton sx={{ color: '#f44336' }} onClick={() => handleDelete(issue.id)}>
//                             <DeleteIcon fontSize="small" />
//                           </IconButton>
//                         </Tooltip>
//                       </Stack>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>
//       <AppointmentEditModal open={openEditModal} id={selectedIssueId} handleClose={() => setOpenEditModal(false)} refresh={fetchData} />
//     </Box>
//   );
// };

// export default IssuesScreen;




// import React, { useState, useEffect, useCallback } from "react";
// import {
//   TableContainer, Table, TableHead, TableRow, TableCell,
//   TableBody, Paper, Card, CardContent, Box, Typography,
//   Chip, IconButton, Stack, Tooltip
// } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";
// import AppointmentEditModal from "../components/AppointmentEditModal";
// import { useStateContext } from "../context/ContextProvider";

// const IssuesScreen = () => {
//   const { t } = useTranslation();
//   const { user } = useStateContext(); 
//   const [issues, setIssues] = useState([]); 
//   const [loading, setLoading] = useState(false);
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const [selectedIssueId, setSelectedIssueId] = useState(null);

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await axiosClient.get("api/issue-list-data/");
//       const rawData = Array.isArray(response.data) ? response.data : (response.data.results || []);
//       setIssues(rawData);
//     } catch (err) { console.error("Fetch error:", err); } 
//     finally { setLoading(false); }
//   }, []);

//   useEffect(() => { fetchData(); }, [fetchData]);

//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this issue?")) {
//       try {
//         await axiosClient.delete(`api/issues/${id}/`);
//         fetchData(); 
//       } catch (err) { alert("Delete failed"); }
//     }
//   };

//   // ✅ Only ADMIN can delete
//   const canDelete = user?.user_role === "ADMIN";

//   return (
//     <Box sx={{ p: 3 }}>
//       <Card sx={{ bgcolor: '#1e1e1e', color: '#fff', borderRadius: 2 }}>
//         <CardContent>
//           <Typography variant="h6" color="#90caf9" sx={{ mb: 3, textAlign: 'center' }}>
//             Issue Management List
//           </Typography>
//           <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e', boxShadow: 'none' }}>
//             <Table size="small">
//               <TableHead>
//                 <TableRow sx={{ borderBottom: '1px solid #444' }}>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Room</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Title</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Assigned To</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Started</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>End</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Status</TableCell>
//                   <TableCell align="center" sx={{ color: '#fff', fontWeight: 'bold' }}>Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {issues.map((issue) => (
//                   <TableRow key={issue.id} sx={{ '& td': { borderBottom: '1px solid #333' } }}>
//                     <TableCell sx={{ color: '#90caf9', fontWeight: 'bold' }}>{issue.room_number}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.title}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>
//                       {issue.staff_name || "Unassigned"}
//                     </TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.reported || issue.appt_start?.replace('T', ' ').substring(0,16)}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.finish_time || "-"}</TableCell>

//                     <TableCell>
//                       <Stack spacing={0.5} alignItems="flex-start">
//                         <Chip 
//                           label={issue.status} 
//                           size="small" 
//                           variant="outlined" 
//                           sx={{ 
//                             color: issue.status === 'open' ? '#f44336' : '#4caf50', 
//                             borderColor: issue.status === 'open' ? '#f44336' : '#4caf50' 
//                           }} 
//                         />
//                         {issue.closed_by_admin && (
//                           <Chip
//                             label={`Closed by: ${issue.closed_by_admin}`}
//                             size="small"
//                             sx={{
//                               bgcolor: '#1565c0',
//                               color: '#fff',
//                               fontSize: '0.65rem',
//                               height: '18px',
//                             }}
//                           />
//                         )}
//                       </Stack>
//                     </TableCell>

//                     <TableCell align="center">
//                       <Stack direction="row" spacing={1} justifyContent="center">
//                         <Tooltip title="Edit">
//                           <IconButton sx={{ color: '#90caf9' }} onClick={() => { setSelectedIssueId(issue.id); setOpenEditModal(true); }}>
//                             <EditIcon fontSize="small" />
//                           </IconButton>
//                         </Tooltip>

//                         {/* ✅ Delete button only visible to ADMIN */}
//                         {canDelete && (
//                           <Tooltip title="Delete">
//                             <IconButton sx={{ color: '#f44336' }} onClick={() => handleDelete(issue.id)}>
//                               <DeleteIcon fontSize="small" />
//                             </IconButton>
//                           </Tooltip>
//                         )}
//                       </Stack>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>
//       <AppointmentEditModal open={openEditModal} id={selectedIssueId} handleClose={() => setOpenEditModal(false)} refresh={fetchData} />
//     </Box>
//   );
// };

// export default IssuesScreen;




/////////////////////////

// import React, { useState, useEffect, useCallback } from "react";
// import {
//   TableContainer, Table, TableHead, TableRow, TableCell,
//   TableBody, Paper, Card, CardContent, Box, Typography,
//   Chip, IconButton, Stack, Tooltip
// } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";
// import AppointmentEditModal from "../components/AppointmentEditModal";
// import { useStateContext } from "../context/ContextProvider";

// const IssuesScreen = () => {
//   const { t } = useTranslation();
//   const { user } = useStateContext(); 
//   const [issues, setIssues] = useState([]); 
//   const [loading, setLoading] = useState(false);
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const [selectedIssueId, setSelectedIssueId] = useState(null);

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await axiosClient.get("api/issue-list-data/");
//       const rawData = Array.isArray(response.data) ? response.data : (response.data.results || []);
//       setIssues(rawData);
//     } catch (err) { console.error("Fetch error:", err); } 
//     finally { setLoading(false); }
//   }, []);

//   useEffect(() => { fetchData(); }, [fetchData]);

//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this issue?")) {
//       try {
//         await axiosClient.delete(`api/issues/${id}/`);
//         fetchData(); 
//       } catch (err) { alert("Delete failed"); }
//     }
//   };

//   const canDelete = user?.user_role === "ADMIN";

//   return (
//     <Box sx={{ p: 3 }}>
//       <Card sx={{ bgcolor: '#1e1e1e', color: '#fff', borderRadius: 2 }}>
//         <CardContent>
//           <Typography variant="h6" color="#90caf9" sx={{ mb: 3, textAlign: 'center' }}>
//             Issue Management List
//           </Typography>
//           <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e', boxShadow: 'none' }}>
//             <Table size="small">
//               <TableHead>
//                 <TableRow sx={{ borderBottom: '1px solid #444' }}>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Room</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Title</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Assigned To</TableCell>
//                   {/* ✅ ADDED COMMENT HEADER */}
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Comment</TableCell> 
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Started</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>End</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Status</TableCell>
//                   <TableCell align="center" sx={{ color: '#fff', fontWeight: 'bold' }}>Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {issues.map((issue) => (
//                   <TableRow key={issue.id} sx={{ '& td': { borderBottom: '1px solid #333' } }}>
//                     <TableCell sx={{ color: '#90caf9', fontWeight: 'bold' }}>{issue.room_number}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.title}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>
//                       {issue.staff_name || "Unassigned"}
//                     </TableCell>
//                     {/* ✅ ADDED COMMENT DATA CELL */}
//                     <TableCell sx={{ color: '#ccc', fontStyle: 'italic', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
//                       <Tooltip title={issue.comment || ""}>
//                         <span>{issue.comment || "-"}</span>
//                       </Tooltip>
//                     </TableCell>
                    
//                     <TableCell sx={{ color: '#fff' }}>{issue.reported || issue.appt_start?.replace('T', ' ').substring(0,16)}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.finish_time || "-"}</TableCell>

//                     <TableCell>
//                       <Stack spacing={0.5} alignItems="flex-start">
//                         <Chip 
//                           label={issue.status} 
//                           size="small" 
//                           variant="outlined" 
//                           sx={{ 
//                             color: issue.status === 'open' ? '#f44336' : '#4caf50', 
//                             borderColor: issue.status === 'open' ? '#f44336' : '#4caf50' 
//                           }} 
//                         />
//                         {issue.closed_by_admin && (
//                           <Chip
//                             label={`Closed by: ${issue.closed_by_admin}`}
//                             size="small"
//                             sx={{
//                               bgcolor: '#1565c0',
//                               color: '#fff',
//                               fontSize: '0.65rem',
//                               height: '18px',
//                             }}
//                           />
//                         )}
//                       </Stack>
//                     </TableCell>

//                     <TableCell align="center">
//                       <Stack direction="row" spacing={1} justifyContent="center">
//                         <Tooltip title="Edit">
//                           <IconButton sx={{ color: '#90caf9' }} onClick={() => { setSelectedIssueId(issue.id); setOpenEditModal(true); }}>
//                             <EditIcon fontSize="small" />
//                           </IconButton>
//                         </Tooltip>

//                         {canDelete && (
//                           <Tooltip title="Delete">
//                             <IconButton sx={{ color: '#f44336' }} onClick={() => handleDelete(issue.id)}>
//                               <DeleteIcon fontSize="small" />
//                             </IconButton>
//                           </Tooltip>
//                         )}
//                       </Stack>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>
//       <AppointmentEditModal open={openEditModal} id={selectedIssueId} handleClose={() => setOpenEditModal(false)} refresh={fetchData} />
//     </Box>
//   );
// };

// export default IssuesScreen;


// import React, { useState, useEffect, useCallback } from "react";
// import {
//   TableContainer, Table, TableHead, TableRow, TableCell,
//   TableBody, Paper, Card, CardContent, Box, Typography,
//   Chip, IconButton, Stack, Tooltip
// } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";
// import AppointmentEditModal from "../components/AppointmentEditModal";
// import { useStateContext } from "../context/ContextProvider";

// const IssuesScreen = () => {
//   const { t } = useTranslation();
//   const { user } = useStateContext(); 
//   const [issues, setIssues] = useState([]); 
//   const [loading, setLoading] = useState(false);
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const [selectedIssueId, setSelectedIssueId] = useState(null);

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await axiosClient.get("api/issue-list-data/");
//       const rawData = Array.isArray(response.data) ? response.data : (response.data.results || []);
//       setIssues(rawData);
//     } catch (err) { console.error("Fetch error:", err); } 
//     finally { setLoading(false); }
//   }, []);

//   useEffect(() => { fetchData(); }, [fetchData]);

//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this issue?")) {
//       try {
//         await axiosClient.delete(`api/issues/${id}/`);
//         fetchData(); 
//       } catch (err) { alert("Delete failed"); }
//     }
//   };

//   const canDelete = user?.user_role === "ADMIN";

//   return (
//     <Box sx={{ p: 3 }}>
//       <Card sx={{ bgcolor: '#1e1e1e', color: '#fff', borderRadius: 2 }}>
//         <CardContent>
//           <Typography variant="h6" color="#90caf9" sx={{ mb: 3, textAlign: 'center' }}>
//             Issue Management List
//           </Typography>
//           <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e', boxShadow: 'none' }}>
//             <Table size="small">
//               <TableHead>
//                 <TableRow sx={{ borderBottom: '1px solid #444' }}>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Room</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Title</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Assigned To</TableCell>
                  
//                   {/* ✅ UPDATED COLUMN HEADER */}
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Notes (Admin / Staff)</TableCell> 
                  
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Started</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>End</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Status</TableCell>
//                   <TableCell align="center" sx={{ color: '#fff', fontWeight: 'bold' }}>Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {issues.map((issue) => (
//                   <TableRow key={issue.id} sx={{ '& td': { borderBottom: '1px solid #333' } }}>
//                     <TableCell sx={{ color: '#90caf9', fontWeight: 'bold' }}>{issue.room_number}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.title}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>
//                       {issue.staff_name || "Unassigned"}
//                     </TableCell>

//                     {/* ✅ DUAL COMMENT DATA CELL */}
//                     <TableCell sx={{ maxWidth: '250px' }}>
//                       <Stack spacing={0.5}>
//                         {/* Show Admin Note in Blue */}
//                         <Typography variant="caption" sx={{ color: '#90caf9', fontStyle: 'italic', display: 'block', lineHeight: 1.2 }}>
//                           Admin: {issue.admin_note || "-"}
//                         </Typography>
                        
//                         {/* Show Staff Comment in White/Grey if it exists */}
//                         {issue.staff_note && (
//                           <Typography variant="caption" sx={{ color: '#ccc', display: 'block', borderTop: '1px solid #333', pt: 0.5, lineHeight: 1.2 }}>
//                             Staff: {issue.staff_note}
//                           </Typography>
//                         )}
//                       </Stack>
//                     </TableCell>
                    
//                     <TableCell sx={{ color: '#fff' }}>{issue.reported || issue.appt_start?.replace('T', ' ').substring(0,16)}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.finish_time || "-"}</TableCell>

//                     <TableCell>
//                       <Stack spacing={0.5} alignItems="flex-start">
//                         <Chip 
//                           label={issue.status} 
//                           size="small" 
//                           variant="outlined" 
//                           sx={{ 
//                             color: issue.status === 'open' ? '#f44336' : '#4caf50', 
//                             borderColor: issue.status === 'open' ? '#f44336' : '#4caf50' 
//                           }} 
//                         />
//                         {issue.closed_by_admin && (
//                           <Chip
//                             label={`Closed by: ${issue.closed_by_admin}`}
//                             size="small"
//                             sx={{
//                               bgcolor: '#1565c0',
//                               color: '#fff',
//                               fontSize: '0.65rem',
//                               height: '18px',
//                             }}
//                           />
//                         )}
//                       </Stack>
//                     </TableCell>

//                     <TableCell align="center">
//                       <Stack direction="row" spacing={1} justifyContent="center">
//                         <Tooltip title="Edit">
//                           <IconButton sx={{ color: '#90caf9' }} onClick={() => { setSelectedIssueId(issue.id); setOpenEditModal(true); }}>
//                             <EditIcon fontSize="small" />
//                           </IconButton>
//                         </Tooltip>

//                         {canDelete && (
//                           <Tooltip title="Delete">
//                             <IconButton sx={{ color: '#f44336' }} onClick={() => handleDelete(issue.id)}>
//                               <DeleteIcon fontSize="small" />
//                             </IconButton>
//                           </Tooltip>
//                         )}
//                       </Stack>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>
//       <AppointmentEditModal open={openEditModal} id={selectedIssueId} handleClose={() => setOpenEditModal(false)} refresh={fetchData} />
//     </Box>
//   );
// };

// // export default IssuesScreen;


// import React, { useState, useEffect, useCallback } from "react";
// import {
//   TableContainer, Table, TableHead, TableRow, TableCell,
//   TableBody, Paper, Card, CardContent, Box, Typography,
//   Chip, IconButton, Stack, Tooltip
// } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";
// import AppointmentEditModal from "../components/AppointmentEditModal";
// import { useStateContext } from "../context/ContextProvider";

// const IssuesScreen = () => {
//   const { t } = useTranslation();
//   const { user } = useStateContext(); 
//   const [issues, setIssues] = useState([]); 
//   const [loading, setLoading] = useState(false);
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const [selectedIssueId, setSelectedIssueId] = useState(null);

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await axiosClient.get("api/issue-list-data/");
//       const rawData = Array.isArray(response.data) ? response.data : (response.data.results || []);
//       setIssues(rawData);
//     } catch (err) { console.error("Fetch error:", err); } 
//     finally { setLoading(false); }
//   }, []);

//   useEffect(() => { fetchData(); }, [fetchData]);

//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this issue?")) {
//       try {
//         await axiosClient.delete(`api/issues/${id}/`);
//         fetchData(); 
//       } catch (err) { alert("Delete failed"); }
//     }
//   };

//   const canDelete = user?.user_role === "ADMIN";

//   return (
//     <Box sx={{ p: 3 }}>
//       <Card sx={{ bgcolor: '#1e1e1e', color: '#fff', borderRadius: 2 }}>
//         <CardContent>
//           <Typography variant="h6" color="#90caf9" sx={{ mb: 3, textAlign: 'center' }}>
//             Issue Management List
//           </Typography>
//           <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e', boxShadow: 'none' }}>
//             <Table size="small">
//               <TableHead>
//                 <TableRow sx={{ borderBottom: '1px solid #444' }}>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Room</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Title</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Assigned To</TableCell>
                  
//                   {/* ✅ THE DUAL NOTES COLUMN */}
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Notes (Admin / Staff)</TableCell> 
                  
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Started</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>End</TableCell>
//                   <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Status</TableCell>
//                   <TableCell align="center" sx={{ color: '#fff', fontWeight: 'bold' }}>Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {issues.map((issue) => (
//                   <TableRow key={issue.id} sx={{ '& td': { borderBottom: '1px solid #333' } }}>
//                     <TableCell sx={{ color: '#90caf9', fontWeight: 'bold' }}>{issue.room_number}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.title}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>
//                       {issue.staff_name || "Unassigned"}
//                     </TableCell>

//                     {/* ✅ SHOW BOTH COMMENTS HERE */}
//                     <TableCell sx={{ maxWidth: '300px' }}>
//                       <Stack spacing={0.8}>
//                         {/* Admin Comment Section */}
//                         <Box>


//                           <Typography variant="caption" sx={{ color: '#90caf9', fontWeight: 'bold', display: 'block', fontSize: '0.7rem', textTransform: 'uppercase' }}>
//                             Admin Note:
//                           </Typography>
//                           <Typography variant="body2" sx={{ color: '#fff', fontStyle: 'italic', pl: 1, lineHeight: 1.2 }}>
//                             {issue.admin_note || "-"}
//                           </Typography>
//                         </Box>

//                         {/* Staff Comment Section - Only appears if text exists */}
//                         {issue.staff_note && (
//                           <Box sx={{ borderTop: '1px solid #333', pt: 0.5 }}>
//                             <Typography variant="caption" sx={{ color: '#4caf50', fontWeight: 'bold', display: 'block', fontSize: '0.7rem', textTransform: 'uppercase' }}>
//                               Staff Feedback:
//                             </Typography>
//                             <Typography variant="body2" sx={{ color: '#ccc', pl: 1, lineHeight: 1.2 }}>
//                               {issue.staff_note}
//                             </Typography>
//                           </Box>
//                         )}
//                       </Stack>
//                     </TableCell>
                    
//                     <TableCell sx={{ color: '#fff' }}>{issue.reported || issue.appt_start?.replace('T', ' ').substring(0,16)}</TableCell>
//                     <TableCell sx={{ color: '#fff' }}>{issue.finish_time || "-"}</TableCell>

    
//                     <TableCell>
//                       <Stack spacing={0.5} alignItems="flex-start">
//                         <Chip 
//                           label={issue.status} 
//                           size="small" 
//                           variant="outlined" 
//                           sx={{ 
//                             color: issue.status === 'open' ? '#f44336' : '#4caf50', 
//                             borderColor: issue.status === 'open' ? '#f44336' : '#4caf50' 
//                           }} 
//                         />
//                         {issue.closed_by_admin && (
//                           <Chip
//                             label={`Closed by: ${issue.closed_by_admin}`}
//                             size="small"
//                             sx={{
//                               bgcolor: '#1565c0',
//                               color: '#fff',
//                               fontSize: '0.65rem',
//                               height: '18px',
//                             }}
//                           />
//                         )}
//                       </Stack>
//                     </TableCell>

//                     <TableCell align="center">
//                       <Stack direction="row" spacing={1} justifyContent="center">
    
//                         <Tooltip title="Edit">
//                           <IconButton sx={{ color: '#90caf9' }} onClick={() => { setSelectedIssueId(issue.id); setOpenEditModal(true); }}>
//                             <EditIcon fontSize="small" />
//                           </IconButton>
//                         </Tooltip>

//                         {canDelete && (
//                           <Tooltip title="Delete">
//                             <IconButton sx={{ color: '#f44336' }} onClick={() => handleDelete(issue.id)}>
//                               <DeleteIcon fontSize="small" />
//                             </IconButton>
//                           </Tooltip>
//                         )}
//                       </Stack>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>
//       <AppointmentEditModal 
//         open={openEditModal} 
//         id={selectedIssueId} 
//         handleClose={() => setOpenEditModal(false)} 
//         refresh={fetchData} 
//       />
//     </Box>
//   );
// };

// export default IssuesScreen;


import React, { useState, useEffect, useCallback } from "react";
import {
  TableContainer, Table, TableHead, TableRow, TableCell,
  TableBody, Paper, Card, CardContent, Box, Typography,
  Chip, IconButton, Stack, Tooltip, CircularProgress
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import axiosClient from "../axiosClient";
import AppointmentEditModal from "../components/AppointmentEditModal";
import { useStateContext } from "../context/ContextProvider";

const IssuesScreen = () => {
  const { user } = useStateContext(); 
  const [issues, setIssues] = useState([]); 
  const [loading, setLoading] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedIssueId, setSelectedIssueId] = useState(null);

  // const fetchData = useCallback(async () => {
  //   setLoading(true);
  //   try {
  //     const response = await axiosClient.get("issue-list-data/");
  //     setIssues(Array.isArray(response.data) ? response.data : []);
  //   } catch (err) { 
  //     console.error("Fetch error:", err); 
  //   } finally { 
  //     setLoading(false); 
  //   }
  // }, []);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      // ✅ CHANGE: Call "issue-list/" 
      // Do NOT add "api/" here because axiosClient adds it automatically from .env
      const response = await axiosClient.get("issue-list/"); 
      setIssues(Array.isArray(response.data) ? response.data : []);
    } catch (err) { 
      console.error("Fetch error:", err); 
    } finally { 
      setLoading(false); 
    }
}, []);

  useEffect(() => { 
    fetchData(); 
  }, [fetchData]);

  // const handleDelete = async (id) => {
  //   if (window.confirm("Are you sure you want to delete this issue?")) {
  //     try {
  //       await axiosClient.delete(`api/issues/${id}/`);
  //       fetchData(); 
  //     } catch (err) { 
  //       alert("Delete failed"); 
  //     }
  //   }
  // };
//////////////////////////////////////////////
// const handleDelete = async (id) => {
//     // 1. Confirm with the user
//     if (window.confirm("Are you sure you want to delete this issue?")) {
//       try {
//         // 2. The leading "/" ensures it hits the correct backend route
//         // The trailing "/" is required by Django
//         await axiosClient.delete(`/api/issues/${id}/`); 
        
//         // 3. Refresh the local state
//         // Because your backend 'get_queryset' now filters for is_deleted=False,
//         // this call will return the list WITHOUT the item you just deleted.
//         fetchData(); 
        
//       } catch (err) { 
//         // Log the error to the console so you can see exactly what happened
//         console.error("Delete error:", err.response?.data || err.message);
//         alert("Delete failed"); 
//       }
//     }
//   };


// const handleDelete = async (id) => {
//     // 1. Double check with the user to prevent accidents
//     if (window.confirm("Are you sure you want to delete this issue?")) {
//       try {
//         // 2. The leading "/" is the fix. It points to the root of your server.
//         // The trailing "/" is required by Django's URL configuration.
//         await axiosClient.delete(`/api/issues/${id}/`); 
        
//         // 3. Refresh the UI
//         // Because the backend 'get_queryset' now filters for is_deleted=False,
//         // the item you just deleted will simply vanish from the table.
//         fetchData(); 
        
//       } catch (err) { 
//         // 4. If it fails, check the "Inspect -> Console" tab in your browser
//         console.error("Delete Error for ID " + id + ":", err.response?.data || err.message);
//         alert("Delete failed. Make sure the server is running and you have permission."); 
//       }
//     }
//   };


// const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this issue?")) {
//       try {
//         // ✅ REMOVE the manual port and IP. Use the relative path.
//         // This ensures it uses the same port (3020) the app is already using.
//         await axiosClient.delete(`/api/issues/${id}/`); 
        
//         fetchData(); 
//       } catch (err) { 
//         console.error("Delete Error for ID " + id + ":", err.response?.data);
//         alert("Delete failed. Check if port 8020 is open on your server."); 
//       }
//     }
//   };


// const handleDelete = async (id) => {
//     // 1. Confirm with the user
//     if (window.confirm("Are you sure you want to delete this issue?")) {
//       try {
//         /**
//          * ✅ THE FIX: 
//          * Most likely your axiosClient already includes "/api/". 
//          * By calling just "issues/${id}/", we match the Django Router 
//          * exactly and avoid the 400 error.
//          */
//         await axiosClient.delete(`issues/${id}/`); 
        
//         // 2. Refresh the list immediately
//         fetchData(); 
        
//       } catch (err) { 
//         // Log the EXACT response from the server to find out WHY it's 400
//         console.error("Server Response Error:", err.response?.data);
//         alert("Delete failed. See console (F12) for server details."); 
//       }
//     }
//   };


// const handleDelete = async (id) => {
//   if (window.confirm("Are you sure?")) {
//     try {
//       // ✅ CLEAN: Since BASE_URL has /api/, we just need the resource and ID
//       // await axiosClient.delete(`issues/${id}/`); 
//       await axiosClient.delete("issues/" + id + "/");
//       fetchData(); 
//     } catch (err) {
//       console.error("Delete Error:", err.response);
//       alert("Delete failed. See console.");
//     }
//   }
// };

const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this issue?")) {
      try {
    
        // await axiosClient.delete("/api/issues/" + id + "/"); 
        await axiosClient.delete("issues/" + id + "/"); 
        
        // Refresh the table
        fetchData(); 
        
      } catch (err) { 
        console.error("Delete Error:", err.response?.data || err.message);
        alert("Delete failed. Check terminal for 200 vs 404."); 
      }
    }
  };







//////////////////////////////////////////////
  // const canDelete = user?.user_role === "ADMIN";
  // Change this:
// const canDelete = user?.user_role === "ADMIN";

// To this:
const canDelete = user?.user_role === "ADMIN" || user?.user_role === "RECEPTION";

  return (
    <Box sx={{ p: 3 }}>
      <Card sx={{ bgcolor: '#1e1e1e', color: '#fff', borderRadius: 2 }}>
        <CardContent>
          <Typography variant="h6" color="#90caf9" sx={{ mb: 3, textAlign: 'center' }}>
            Issue Management List
          </Typography>
          
          <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e', boxShadow: 'none' }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ borderBottom: '1px solid #444' }}>
                  <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Room</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Title</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Assigned To</TableCell>
                  
                  {/* ✅ COLUMN RENAMED */}
                  <TableCell sx={{ color: '#90caf9', fontWeight: 'bold' }}>Reception Comment</TableCell>
                  <TableCell sx={{ color: '#4caf50', fontWeight: 'bold' }}>Staff Feedback</TableCell> 
                  
                  <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Started</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>End</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Status</TableCell>
                  <TableCell align="center" sx={{ color: '#fff', fontWeight: 'bold' }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center" sx={{ py: 3 }}>
                      <CircularProgress size={24} />
                    </TableCell>
                  </TableRow>
                ) : (
                  issues.map((issue) => (
                    <TableRow key={issue.id} sx={{ '& td': { borderBottom: '1px solid #333' } }}>
                      <TableCell sx={{ color: '#90caf9', fontWeight: 'bold' }}>{issue.room_number}</TableCell>
                      <TableCell sx={{ color: '#fff' }}>{issue.title}</TableCell>
                      <TableCell sx={{ color: '#fff' }}>
                        {issue.staff_name || "Unassigned"}
                      </TableCell>

                      {/* ✅ BEAUTIFUL BLUE ITALIC STYLE FOR RECEPTION */}
                      <TableCell sx={{ color: '#90caf9', fontStyle: 'italic', fontSize: '0.85rem' }}>
                        {issue.admin_note || "-"}
                      </TableCell>

                      {/* ✅ GREEN STYLE FOR STAFF */}
                      <TableCell sx={{ color: '#4caf50', fontSize: '0.85rem' }}>
                        {issue.staff_note || "-"}
                      </TableCell>
                      
                      <TableCell sx={{ color: '#fff', fontSize: '0.85rem' }}>
                        {issue.reported}
                      </TableCell>

                      <TableCell sx={{ color: '#fff', fontSize: '0.85rem' }}>
                        {issue.finish_time}
                      </TableCell>

                      <TableCell>
                        <Stack spacing={0.5} alignItems="flex-start">
                          {/* Status Chip */}
                          <Chip 
                            label={issue.status} 
                            size="small" 
                            variant="outlined" 
                            sx={{ 
                              color: issue.status === 'open' ? '#f44336' : '#4caf50', 
                              borderColor: issue.status === 'open' ? '#f44336' : '#4caf50' 
                            }} 
                          />
                          
                          {/* ✅ NEW BLUE FRAME CHIP FOR ADMIN NAME */}
                          {issue.closed_by_name && (
                            <Chip
                              label={`By: ${issue.closed_by_name}`}
                              size="small"
                              sx={{
                                bgcolor: '#1565c0', // Solid Blue background
                                color: '#fff',      // White text
                                fontSize: '0.65rem',
                                height: '18px',
                                fontWeight: 'bold',
                                '& .MuiChip-label': { px: 1 }
                              }}
                            />
                          )}
                        </Stack>
                      </TableCell>

                      <TableCell align="center">
                        <Stack direction="row" spacing={1} justifyContent="center">
                          <Tooltip title="Edit">
                            <IconButton sx={{ color: '#90caf9' }} onClick={() => { setSelectedIssueId(issue.id); setOpenEditModal(true); }}>
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>

                          {canDelete && (
                            <Tooltip title="Delete">
                              <IconButton sx={{ color: '#f44336' }} onClick={() => handleDelete(issue.id)}>
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>

      <AppointmentEditModal 
        open={openEditModal} 
        id={selectedIssueId} 
        handleClose={() => setOpenEditModal(false)} 
        refresh={fetchData} 
      />
    </Box>
  );
};

export default IssuesScreen;